var AccessProfiles = /*#__PURE__*/function (AccessProfiles) {
  AccessProfiles["superAdminCA"] = "superAdminCA";
  AccessProfiles["commonUser"] = "commonUser";
  AccessProfiles["helperReadOnlyWLimited"] = "helperReadOnlyWLimited";
  AccessProfiles["helperReadOnlyExtended"] = "helperReadOnlyExtended";
  AccessProfiles["customerAdmin"] = "customerAdmin";
  AccessProfiles["customerAdminGroup"] = "customerAdminGroup";
  AccessProfiles["prodAdminCA"] = "prodAdminCA";
  AccessProfiles["salesAdminCA"] = "salesAdminCA";
  return AccessProfiles;
}(AccessProfiles || {});
;
const loginIDRegex = /^[\wÀ-ú @._-]{4,50}$/;
var access_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get AccessProfiles() {
    return AccessProfiles;
  },
  loginIDRegex: loginIDRegex
});
var actionSet_const = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var DeviceType = /*#__PURE__*/function (DeviceType) {
  DeviceType["ARF8170BCA"] = "ARF8170BCA";
  DeviceType["ARF8171BA"] = "ARF8171BA";
  DeviceType["BSSigfox"] = "BSSigfox";
  DeviceType["BSLora"] = "BSLora";
  DeviceType["CAB"] = "CAB";
  DeviceType["CAW"] = "CAW";
  DeviceType["CALAU"] = "CALAlertUnit";
  DeviceType["CALDC"] = "CALDryContact";
  DeviceType["CALDS"] = "CALDS";
  DeviceType["CALSB"] = "CALSimpleButton";
  DeviceType["CALBC"] = "CALBeacon";
  DeviceType["CALP"] = "CALPear";
  DeviceType["CALT"] = "CALToggle";
  DeviceType["CALWB"] = "CALWornBracelet";
  DeviceType["CAU"] = "AlertUnit";
  DeviceType["EV07B"] = "EV07B";
  DeviceType["GH5200"] = "GH5200";
  DeviceType["I870SF"] = "I870SF";
  DeviceType["I870LR"] = "I870LR";
  DeviceType["LA66USB"] = "LA66USB";
  DeviceType["LHT65NLR"] = "LHT65NLR";
  DeviceType["LDS02DS"] = "LDS02DS";
  DeviceType["LDS02SB"] = "LDS02SimpleButton";
  DeviceType["LUNA4G"] = "Luna4G";
  DeviceType["VH2BBUS01"] = "VH2BBUS01";
  DeviceType["NETWORKDEVICE"] = "NetworkDevice";
  DeviceType["SMARTPHONE"] = "Smartphone";
  DeviceType["SP4BUT"] = "SimplePack4.0Button";
  DeviceType["SP4MAG"] = "SimplePack4.0Magnetic";
  DeviceType["TAGID"] = "TAGID";
  DeviceType["TMT250"] = "TMT250";
  DeviceType["X870LS"] = "X870LSOriginPlus";
  DeviceType["WSM02"] = "WSM02";
  DeviceType["X865LS"] = "X865LSOrigin";
  DeviceType["X860LS"] = "X860LSGuardPlus";
  DeviceType["X855LS"] = "X855LSGuard";
  DeviceType["ZEECDMINOLR"] = "ZEECDMINOLR";
  DeviceType["ZEPRLR"] = "ZEPRLR";
  return DeviceType;
}(DeviceType || {});
;
var SmartphoneModel = /*#__PURE__*/function (SmartphoneModel) {
  SmartphoneModel["XCOVER5"] = "XCover 5";
  SmartphoneModel["XCOVER7"] = "XCover 7";
  SmartphoneModel["GALAXYTABACTIVE4"] = "Galaxy Tab Active4";
  SmartphoneModel["GALAXYTABACTIVE5"] = "Galaxy Tab Active5";
  SmartphoneModel["GALAXYA05S"] = "Galaxy A05s";
  return SmartphoneModel;
}(SmartphoneModel || {});
var NetworkDeviceModel = /*#__PURE__*/function (NetworkDeviceModel) {
  NetworkDeviceModel["RUTX08"] = "TKT Rutx08";
  NetworkDeviceModel["RUTX09"] = "TKT Rutx09";
  NetworkDeviceModel["RUTX10"] = "TKT Rutx10";
  NetworkDeviceModel["RUTX11"] = "TKT Rutx11";
  NetworkDeviceModel["RUT200"] = "TKT Rut200";
  NetworkDeviceModel["RUT300"] = "TKT Rut300";
  NetworkDeviceModel["RUT301"] = "TKT Rut301";
  NetworkDeviceModel["OTB140"] = "TKT Modem 4G Outdoor";
  NetworkDeviceModel["UAPNANOHD"] = "Ubiquity Nano HD";
  NetworkDeviceModel["UCKG2PLUS"] = "Ubiquity Cloud Key 2 Plus";
  NetworkDeviceModel["UDR"] = "Ubiquity Dream Router";
  NetworkDeviceModel["USW16POE"] = "Ubiquity Standard Switch 16p PoE";
  NetworkDeviceModel["UACAPPRO"] = "Ubiquity Access point AC Pro";
  NetworkDeviceModel["U6LR"] = "Ubiquity Access point 6 Long Range ";
  NetworkDeviceModel["SBC3CX"] = "SBC 3CX Raspi";
  NetworkDeviceModel["HT818"] = "HT818 FXS 8p";
  NetworkDeviceModel["GXW4216"] = "GXW4216 FXS 16p";
  NetworkDeviceModel["GXW4224"] = "GXW4224 FXS 24p";
  NetworkDeviceModel["GXW4232"] = "GXW4232 FXS 32p";
  NetworkDeviceModel["GWN7801"] = "GWN7801 Switch L2+ 8p";
  NetworkDeviceModel["GWN7802"] = "GWN7802 Switch L2+ 16p";
  NetworkDeviceModel["GWN7803"] = "GWN7803 Switch L2+ 24p";
  NetworkDeviceModel["GWN7801P"] = "GWN7801 Switch L2+ 8p POE";
  NetworkDeviceModel["GWN7802P"] = "GWN7802 Switch L2+ 16p POE";
  NetworkDeviceModel["GWN7803P"] = "GWN7803 Switch L2+ 24p POE";
  NetworkDeviceModel["X3SG"] = "Fanvil SIP Phone X3SG";
  NetworkDeviceModel["X5U"] = "Fanvil SIP Phone X5U";
  NetworkDeviceModel["X305"] = "Fanvil SIP Phone X305";
  return NetworkDeviceModel;
}(NetworkDeviceModel || {});
var BSLoraModel = /*#__PURE__*/function (BSLoraModel) {
  BSLoraModel["LPS8N"] = "Dragino lps8n (v1)";
  BSLoraModel["LPS8V2"] = "Dragino lps8v2";
  BSLoraModel["IFE00"] = "Kerlink IFemtoCell IFE00 (Eth/WiFi)";
  BSLoraModel["IFE03"] = "Kerlink IFemtoCell Evolution IFE03 (Eth/4G)";
  BSLoraModel["IFE07"] = "Kerlink IFemtoCell Evolution IFE07 (Eth/Wifi/4G)";
  return BSLoraModel;
}(BSLoraModel || {});
var ProfileType = /*#__PURE__*/function (ProfileType) {
  ProfileType["USER"] = "user";
  ProfileType["GROUP"] = "group";
  return ProfileType;
}(ProfileType || {});
var DeviceOS = /*#__PURE__*/function (DeviceOS) {
  DeviceOS["Android"] = "Android";
  DeviceOS["iOS"] = "iOS";
  return DeviceOS;
}(DeviceOS || {});
var entity_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get DeviceType() {
    return DeviceType;
  },
  get SmartphoneModel() {
    return SmartphoneModel;
  },
  get NetworkDeviceModel() {
    return NetworkDeviceModel;
  },
  get BSLoraModel() {
    return BSLoraModel;
  },
  get ProfileType() {
    return ProfileType;
  },
  get DeviceOS() {
    return DeviceOS;
  }
});
var NetworkProviderActions = /*#__PURE__*/function (NetworkProviderActions) {
  NetworkProviderActions["addSigfoxCredentials"] = "addSigfoxCredentials";
  NetworkProviderActions["activateSigfoxCredentials"] = "activateSigfoxCredentials";
  NetworkProviderActions["getSigfoxCredentials"] = "getSigfoxCredentials";
  NetworkProviderActions["createAWSIOTGateway"] = "createWirelessGateway";
  NetworkProviderActions["createAWSIOTDevice"] = "createWirelessDevice";
  NetworkProviderActions["deleteAWSIOTDevice"] = "deleteWirelessDevice";
  NetworkProviderActions["getAWSIOTDevice"] = "getWirelessDevice";
  NetworkProviderActions["getAWSIOTDeviceStatistics"] = "getAWSIOTDeviceStatistics";
  NetworkProviderActions["getAWSIOTGatewayStatistics"] = "getAWSIOTGatewayStatistics";
  return NetworkProviderActions;
}(NetworkProviderActions || {});
;
// Admin model
var DATATYPE_BASE$1 = /*#__PURE__*/function (DATATYPE_BASE) {
  DATATYPE_BASE["AGGREGATE"] = "aggregate";
  DATATYPE_BASE["COUNTER"] = "counter";
  return DATATYPE_BASE;
}(DATATYPE_BASE$1 || {});
;
var DATA_ID = /*#__PURE__*/function (DATA_ID) {
  DATA_ID["DEVICE_USE_RATE"] = "deviceUseRate";
  return DATA_ID;
}(DATA_ID || {});
var AGGREGATE_TYPE = /*#__PURE__*/function (AGGREGATE_TYPE) {
  AGGREGATE_TYPE["SUBSCRIBE"] = "subscribe";
  AGGREGATE_TYPE["UNSUBSCRIBE"] = "unsubscribe";
  AGGREGATE_TYPE["LINKMODULE"] = "linkModule";
  AGGREGATE_TYPE["UNLINKMODULE"] = "unlinkModule";
  return AGGREGATE_TYPE;
}(AGGREGATE_TYPE || {});
;
var BUSINESS_TYPE = /*#__PURE__*/function (BUSINESS_TYPE) {
  BUSINESS_TYPE["B2C"] = "B2C";
  BUSINESS_TYPE["B2B"] = "B2B";
  return BUSINESS_TYPE;
}(BUSINESS_TYPE || {});
;
var EC2_INSTANCE_ACTION = /*#__PURE__*/function (EC2_INSTANCE_ACTION) {
  EC2_INSTANCE_ACTION["START"] = "START";
  EC2_INSTANCE_ACTION["REBOOT"] = "REBOOT";
  EC2_INSTANCE_ACTION["STOP"] = "STOP";
  return EC2_INSTANCE_ACTION;
}(EC2_INSTANCE_ACTION || {});
var EC2_INSTANCE_STATE = /*#__PURE__*/function (EC2_INSTANCE_STATE) {
  EC2_INSTANCE_STATE["RUNNING"] = "running";
  EC2_INSTANCE_STATE["STOPPED"] = "stopped";
  EC2_INSTANCE_STATE["TERMINATED"] = "terminated";
  EC2_INSTANCE_STATE["PENDING"] = "pending";
  EC2_INSTANCE_STATE["STOPPING"] = "stopping";
  return EC2_INSTANCE_STATE;
}(EC2_INSTANCE_STATE || {});
const deviceUseRateDeviceType = [DeviceType.CAW, DeviceType.CAU, DeviceType.SP4BUT];
var DEVICE_USE_RATE_KEY = /*#__PURE__*/function (DEVICE_USE_RATE_KEY) {
  DEVICE_USE_RATE_KEY["ACTIVE_GROUP"] = "withActiveGroup";
  DEVICE_USE_RATE_KEY["ACTIVE_GROUP_AND_ASSOCIATED"] = "withActiveGroupAndAssociated";
  DEVICE_USE_RATE_KEY["ACTIVE_GROUP_AND_ASSOCIATED_AND_OK"] = "withActiveGroupAndAssociatedAndOK";
  return DEVICE_USE_RATE_KEY;
}(DEVICE_USE_RATE_KEY || {});
var SupportTicketStep = /*#__PURE__*/function (SupportTicketStep) {
  SupportTicketStep["OPENED"] = "OPENED";
  SupportTicketStep["TO_ANALYSE"] = "TO_ANALYSE";
  SupportTicketStep["COMMERCIAL_PROCESSING"] = "COMMERCIAL_PROCESSING";
  SupportTicketStep["WAITING_FOR_CUSTOMER"] = "WAITING_FOR_CUSTOMER";
  SupportTicketStep["ACTION_TO_PERFORM"] = "ACTION_TO_PERFORM";
  SupportTicketStep["TO_REPAIR"] = "TO_REPAIR";
  SupportTicketStep["TO_REPLACE"] = "TO_REPLACE";
  SupportTicketStep["TO_KEEP"] = "TO_KEEP";
  SupportTicketStep["GATHER_FOR_RETURN"] = "GATHER_FOR_RETURN";
  SupportTicketStep["TO_SEND"] = "TO_SEND";
  SupportTicketStep["TO_INVOICE"] = "TO_INVOICE";
  SupportTicketStep["CLOSED"] = "CLOSED";
  return SupportTicketStep;
}(SupportTicketStep || {});
var SupportTicketFormDataInputType = /*#__PURE__*/function (SupportTicketFormDataInputType) {
  SupportTicketFormDataInputType["BOOLEAN"] = "BOOLEAN";
  SupportTicketFormDataInputType["SELECT_MULTIPLE"] = "SELECT_MULTIPLE";
  SupportTicketFormDataInputType["SELECT"] = "SELECT";
  SupportTicketFormDataInputType["TEXT"] = "TEXT";
  SupportTicketFormDataInputType["TEXT_AREA"] = "TEXT_AREA";
  SupportTicketFormDataInputType["TODO_LIST"] = "TODO_LIST";
  return SupportTicketFormDataInputType;
}(SupportTicketFormDataInputType || {});
const HUBSPOT_URL = 'https://app.hubspot.com/contacts/2276721/ticket/';
const SHIPPING_URL = 'https://www.laposte.fr/outils/suivre-vos-envois?code=';
var admin_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get NetworkProviderActions() {
    return NetworkProviderActions;
  },
  get DATATYPE_BASE() {
    return DATATYPE_BASE$1;
  },
  get DATA_ID() {
    return DATA_ID;
  },
  get AGGREGATE_TYPE() {
    return AGGREGATE_TYPE;
  },
  get BUSINESS_TYPE() {
    return BUSINESS_TYPE;
  },
  get EC2_INSTANCE_ACTION() {
    return EC2_INSTANCE_ACTION;
  },
  get EC2_INSTANCE_STATE() {
    return EC2_INSTANCE_STATE;
  },
  deviceUseRateDeviceType: deviceUseRateDeviceType,
  get DEVICE_USE_RATE_KEY() {
    return DEVICE_USE_RATE_KEY;
  },
  get SupportTicketStep() {
    return SupportTicketStep;
  },
  get SupportTicketFormDataInputType() {
    return SupportTicketFormDataInputType;
  },
  HUBSPOT_URL: HUBSPOT_URL,
  SHIPPING_URL: SHIPPING_URL
});
var Qualification = /*#__PURE__*/function (Qualification) {
  Qualification["alert"] = "alert";
  Qualification["test"] = "test";
  Qualification["courtesy"] = "courtesy";
  Qualification["inappropriate"] = "inappropriate";
  Qualification["duplicate"] = "duplicate";
  return Qualification;
}(Qualification || {});
;
// How to name alertType: you must suffix the new alertType by the deviceType, ALERTTYPE_DEVICETYPE :alertTypeDeviceType
var AlertType = /*#__PURE__*/function (AlertType) {
  AlertType["BUTTON"] = "button";
  AlertType["FALL"] = "fall";
  AlertType["ZONE_EXIT"] = "zoneExit";
  AlertType["INACTIVITY"] = "inactivity";
  AlertType["LOW_BATTERY"] = "lowBattery";
  AlertType["CRIT_BATTERY"] = "criticalBattery";
  AlertType["EOL_BATTERY"] = "endOfLifeBattery";
  AlertType["DISCONNECTION"] = "disconnection";
  AlertType["NON_FUNCTIONNAL"] = "nonFunctionnal";
  AlertType["BUTTON_SOLE"] = "buttonSole";
  AlertType["BUTTON_CAU_1"] = "buttonCau1";
  AlertType["BUTTON_CAU_2"] = "buttonCau2";
  AlertType["BUTTON_CAU_3"] = "buttonCau3";
  AlertType["BUTTON_CAU_4"] = "buttonCau4";
  AlertType["BUTTON_BRACELET"] = "buttonBracelet";
  AlertType["BUTTON_CALL"] = "buttonCall";
  AlertType["BUTTON_TMT"] = "buttonTmt";
  AlertType["DC_1"] = "dc1";
  AlertType["DC_2"] = "dc2";
  AlertType["SMOKE"] = "smoke";
  AlertType["OPEN_DOOR"] = "openDoor";
  AlertType["PROLONGED_PRESENCE"] = "prolongedPresence";
  AlertType["THRESHOLD"] = "threshold";
  AlertType["TILT"] = "tilt";
  AlertType["LEAK"] = "leak";
  return AlertType;
}(AlertType || {});
// PROCESS
var SpecificActionType = /*#__PURE__*/function (SpecificActionType) {
  SpecificActionType["FOLLOW_UP"] = "followUpNotification";
  return SpecificActionType;
}(SpecificActionType || {});
var AlgorithmsType = /*#__PURE__*/function (AlgorithmsType) {
  AlgorithmsType["CASCADE"] = "CASCADE";
  AlgorithmsType["PARALLEL"] = "PARALLEL";
  return AlgorithmsType;
}(AlgorithmsType || {});
var AlertAction = /*#__PURE__*/function (AlertAction) {
  AlertAction["SPECIFIC_ACTION"] = "specificAction";
  AlertAction["SEND_EMAIL"] = "sendEmail";
  AlertAction["SEND_SMS"] = "sendSms";
  return AlertAction;
}(AlertAction || {});
var ActionSetAction = /*#__PURE__*/function (ActionSetAction) {
  ActionSetAction["SPECIFIC_ACTION"] = "processID";
  ActionSetAction["SEND_EMAIL"] = "emails";
  ActionSetAction["SEND_SMS"] = "smss";
  ActionSetAction["SEND_TECHNICAL_EMAIL"] = "technicalEmails";
  ActionSetAction["SEND_TECHNICAL_SMS"] = "technicalSmss";
  ActionSetAction["SEND_WHATSAPP_MSG"] = "whatsApps";
  ActionSetAction["CALL_WEBHOOKS"] = "webhooks";
  ActionSetAction["PUSH_NOTIFICATION"] = "pushNotifications";
  return ActionSetAction;
}(ActionSetAction || {});
var HTTPMethodRequest = /*#__PURE__*/function (HTTPMethodRequest) {
  HTTPMethodRequest["GET"] = "GET";
  HTTPMethodRequest["POST"] = "POST";
  return HTTPMethodRequest;
}(HTTPMethodRequest || {});
var AvailableVariables = /*#__PURE__*/function (AvailableVariables) {
  AvailableVariables["userID"] = "{{userID}}";
  AvailableVariables["alertID"] = "{{alertID}}";
  AvailableVariables["alertType"] = "{{alertType}}";
  AvailableVariables["alertStatus"] = "{{alertStatus}}";
  AvailableVariables["startTimeMs"] = "{{startTimeMs}}";
  AvailableVariables["lastStatusUpdateMs"] = "{{lastStatusUpdateMs}}";
  AvailableVariables["displayName"] = "{{displayName}}";
  AvailableVariables["additionalInformation"] = "{{additionalInformation}}";
  AvailableVariables["name"] = "{{name}}";
  AvailableVariables["lastKnownAddress"] = "{{lastKnownAddress}}";
  AvailableVariables["lastKnownPosition"] = "{{lastKnownPosition}}";
  return AvailableVariables;
}(AvailableVariables || {});
class WebhookDetails {
  constructor(obj) {
    this.method = obj.method;
    this.url = obj.url;
    this.headers = obj.headers;
    if (obj.method === HTTPMethodRequest.GET) {
      this.urlQuery = obj.urlQuery;
    } else {
      this.customBody = typeof obj.customBody === 'string' ? JSON.parse(obj.customBody) : obj.customBody;
    }
    this.stateNotification = obj.stateNotification;
  }
}
class WhatsAppDetails {
  constructor(obj) {
    this.ids = obj.ids;
  }
}
class NotificationDetails {
  constructor(obj) {
    this.userID = obj.userID;
    this.token = obj.token;
    this.deviceOS = obj.deviceOS;
    this.targetArn = obj.targetArn;
    this.deviceID = obj.deviceID;
    this.appVersion = obj.appVersion;
  }
}
var Status = /*#__PURE__*/function (Status) {
  Status["ACQUITTED"] = "acquitted";
  Status["CLOSED"] = "close";
  Status["EXPIRED"] = "expired";
  Status["HANDLED"] = "handle";
  Status["INTERRUPTED"] = "interrupted";
  Status["STARTED"] = "start";
  Status["NOTIFYING"] = "notifying";
  //todo: Obsolete status should be deleted end of 2024
  Status["TRYING_NEW_NOTIFICATION"] = "trying_new_notification";
  Status["WAITING_FOR_RESPONSE"] = "waiting_for_response";
  return Status;
}(Status || {});
var AcquitInfo;
(function (AcquitInfo) {
  let By;
  (function (By) {
    By["IN_SITU"] = "IN_SITU";
    By["APP"] = "APP";
    By["CALL"] = "CALL";
    By["WA"] = "WHATSAPP";
  })(By = AcquitInfo.By || (AcquitInfo.By = {}));
})(AcquitInfo || (AcquitInfo = {}));
var HandleInfo;
(function (HandleInfo) {
  let By;
  (function (By) {
    By["CALL"] = "CALL";
    By["APP"] = "APP";
    By["WA"] = "WHATSAPP";
    By["TAMAT"] = "TAMAT";
  })(By = HandleInfo.By || (HandleInfo.By = {}));
})(HandleInfo || (HandleInfo = {}));
var TwilioVoiceVerb = /*#__PURE__*/function (TwilioVoiceVerb) {
  TwilioVoiceVerb["pause"] = "pause";
  TwilioVoiceVerb["play"] = "play";
  TwilioVoiceVerb["hangup"] = "hangup";
  return TwilioVoiceVerb;
}(TwilioVoiceVerb || {});
const DEFAULT_IVR_EXPRESSION = '1-H-1';
var alert_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get Qualification() {
    return Qualification;
  },
  get AlertType() {
    return AlertType;
  },
  get SpecificActionType() {
    return SpecificActionType;
  },
  get AlgorithmsType() {
    return AlgorithmsType;
  },
  get AlertAction() {
    return AlertAction;
  },
  get ActionSetAction() {
    return ActionSetAction;
  },
  get HTTPMethodRequest() {
    return HTTPMethodRequest;
  },
  get AvailableVariables() {
    return AvailableVariables;
  },
  WebhookDetails: WebhookDetails,
  WhatsAppDetails: WhatsAppDetails,
  NotificationDetails: NotificationDetails,
  get Status() {
    return Status;
  },
  get AcquitInfo() {
    return AcquitInfo;
  },
  get HandleInfo() {
    return HandleInfo;
  },
  get TwilioVoiceVerb() {
    return TwilioVoiceVerb;
  },
  DEFAULT_IVR_EXPRESSION: DEFAULT_IVR_EXPRESSION
});
var ERROR_MESSAGES = /*#__PURE__*/function (ERROR_MESSAGES) {
  ERROR_MESSAGES["UNKNOWN_ERROR"] = "Unknown error";
  ERROR_MESSAGES["MISSING_ARGUMENT"] = "Missing argument";
  ERROR_MESSAGES["INVALID_ARGUMENT"] = "Invalid argument";
  ERROR_MESSAGES["ALREADY_EXIST"] = "Already Exist";
  ERROR_MESSAGES["NO_DATA_FOUND"] = "No data found";
  ERROR_MESSAGES["NO_DATA_TO_UPDATE"] = "No data to update";
  ERROR_MESSAGES["NO_DATA_TO_DELETE"] = "No data to delete";
  ERROR_MESSAGES["INVALID_PAYMENT_DATA"] = "Invalid Payment data";
  ERROR_MESSAGES["INVALID_PAYMENT_UPDATE"] = "Invalid Payment update";
  ERROR_MESSAGES["MANDATE_INACTIVE"] = "Mandate inactive";
  ERROR_MESSAGES["MANDATE_UPDATE_FAILED"] = "Mandate could not be updated";
  ERROR_MESSAGES["ERROR_PAYMENT"] = "A payment error has occurred";
  ERROR_MESSAGES["REJECTED_PAYMENT"] = "A payment was declined by a 3rd party";
  ERROR_MESSAGES["LATE_PAYMENT"] = "A payment should already have been done";
  ERROR_MESSAGES["NOT_IMPLEMENTED"] = "Not implemented";
  ERROR_MESSAGES["OTP_INCORRECT"] = "otp: incorrect code";
  ERROR_MESSAGES["TOO_OLD_PASSWORD"] = "Password too old";
  ERROR_MESSAGES["NEW_PASSWORD_NEEDED"] = "New password needed";
  ERROR_MESSAGES["BAD_LOGIN"] = "Bad login";
  ERROR_MESSAGES["PAYLOAD_LIMIT_REACHED"] = "Payload size too large";
  return ERROR_MESSAGES;
}(ERROR_MESSAGES || {});
;
var error_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get ERROR_MESSAGES() {
    return ERROR_MESSAGES;
  }
});
const GPS_MESSAGE_OK = "0";
const GPS_MESSAGE_ERROR = "1";
const GPS_MESSAGE_BEACON = "2";
const DECIMAL_FACTOR = 1 / 10000000;
const POSITIVE_GPS_DIRECTION$1 = "0";
const NEGATIVE_GPS_DIRECTION$1 = "1";
const HOME_ADDRESS_POSITION_SOURCE = "homeAddress";
const SCHEDULED_ADDRESS_POSITION_SOURCE = "scheduledAddress";
const POSITION_DATA_TYPE$1 = "position";
var gpsPositionConst = /*#__PURE__*/Object.freeze({
  __proto__: null,
  GPS_MESSAGE_OK: GPS_MESSAGE_OK,
  GPS_MESSAGE_ERROR: GPS_MESSAGE_ERROR,
  GPS_MESSAGE_BEACON: GPS_MESSAGE_BEACON,
  DECIMAL_FACTOR: DECIMAL_FACTOR,
  POSITIVE_GPS_DIRECTION: POSITIVE_GPS_DIRECTION$1,
  NEGATIVE_GPS_DIRECTION: NEGATIVE_GPS_DIRECTION$1,
  HOME_ADDRESS_POSITION_SOURCE: HOME_ADDRESS_POSITION_SOURCE,
  SCHEDULED_ADDRESS_POSITION_SOURCE: SCHEDULED_ADDRESS_POSITION_SOURCE,
  POSITION_DATA_TYPE: POSITION_DATA_TYPE$1
});

// MASK TO RETRIEVE DATA IN MESSAGE
// the first number is the offset of data in bits (the data started to be read from this bit).
// the second number gives the data length in bits.
const HEADER = [0, 4];
const ALERT_SOURCE = [4, 4];
const ALERT_ID = [8, 10];
const ALERT_ACTION = [18, 2];
const PAYLOAD = [20, 76];
const ALERT_TIMESTAMP = [48, 32];
// ALERT CASE: POSITION MASK
const GPS_FIX = [4, 4];
const ALERT_POSITION_LAT = [32, 32];
const ALERT_POSITION_LNG = [64, 32];
const ALERT_POSITION_HDOP = [20, 12];
// Masques pour les valeurs hexa PIC et POST_PIC en cas d'alerte de chute :
// ALERT FALL CASE: hexadecimal value PIC and POST_PIC
const ALERT_FALL_PIC = [48, 16];
const ALERT_FALL_POST_PIC = [64, 32];
// BATTERY LEVEL MASK
const BATTERY_LEVEL = [88, 8];
// POSITION POINT MASK IN DOWNLINK MESSAGE
const ASK_NEW_DOWNLINK = [0, 1];
const ID_SETTING_POINT_DOWNLINK = [1, 6];
const LATITUDE_POINT_DOWNLINK = [8, 28];
const LONGITUDE_POINT_DOWNLINK = [36, 28];
const ASK_NEW_DOWNLINK_IN_AKNOWLEDGMENT$1 = [4, 4];
const LATITUDE_POINT_ACK = [40, 28];
const LONGITUDE_POINT_ACK = [68, 28];
//HANDLING MESSAGE MASK
const IS_ALERT = [8, 4];
// REPORT MESSAGE MASK
const ACTIVITY_INCLUDED = [4, 4];
const BUTTON_CONFIG = [8, 1];
const FALL_CONFIG = [9, 1];
const TRACKER_CONFIG = [10, 1];
const UTC_TIME_ZONE_CONFIG = [11, 5];
const STATE_OF_CHARGE = [16, 8];
const IGNORE_WORN_STATE = [25, 1];
const EMBED_ERROR_LOG = [26, 1];
const DATE_MODE_CONFIG = [27, 2];
const LNG_PRESS_CONFIG = [29, 1];
const CLOCK_MODE_CONFIG = [30, 1];
const WORN_STATE = [31, 1];
const FIRST_ACTIVITY = [32, 16];
// ADMINISTRATION MESSAGE MASK
const ADMINISTRATION_MESSAGE_TYPE = [4, 4];
const DOWNLINK_ERROR_ADMINISTRATION_MESSAGE = [8, 64];
const FIRST_WATCHDOG_EVENT_ADMINISTRATION_MESSAGE = [8, 8];
const POWER_ENERGY_REPORT_MESSAGE = [48, 16];
const TENSION_ENERGY_REPORT_MESSAGE = [64, 16];
const CURRENT_ENERGY_REPORT_MESSAGE = [80, 16];
const ALTI_FIRST_GAP = [8, 8];
const ALTI_NEXT_GAP = [16, 8];
const ALTI_STRONG_OCCURRENCE = [28, 4];
// WATCHDOG EVENT MASK,
const WATCHDOG = [8, 8];
const WATCHDOG_LENGTH = 8;
// DOWNLINK ERROR MASK,
const DOWNLINK_COPY = [8, 64];
// CRON ERROR MASK,
const CRON_PATTERN_EXTEND = [71, 1];
var maskConst = /*#__PURE__*/Object.freeze({
  __proto__: null,
  HEADER: HEADER,
  ALERT_SOURCE: ALERT_SOURCE,
  ALERT_ID: ALERT_ID,
  ALERT_ACTION: ALERT_ACTION,
  PAYLOAD: PAYLOAD,
  ALERT_TIMESTAMP: ALERT_TIMESTAMP,
  GPS_FIX: GPS_FIX,
  ALERT_POSITION_LAT: ALERT_POSITION_LAT,
  ALERT_POSITION_LNG: ALERT_POSITION_LNG,
  ALERT_POSITION_HDOP: ALERT_POSITION_HDOP,
  ALERT_FALL_PIC: ALERT_FALL_PIC,
  ALERT_FALL_POST_PIC: ALERT_FALL_POST_PIC,
  BATTERY_LEVEL: BATTERY_LEVEL,
  ASK_NEW_DOWNLINK: ASK_NEW_DOWNLINK,
  ID_SETTING_POINT_DOWNLINK: ID_SETTING_POINT_DOWNLINK,
  LATITUDE_POINT_DOWNLINK: LATITUDE_POINT_DOWNLINK,
  LONGITUDE_POINT_DOWNLINK: LONGITUDE_POINT_DOWNLINK,
  ASK_NEW_DOWNLINK_IN_AKNOWLEDGMENT: ASK_NEW_DOWNLINK_IN_AKNOWLEDGMENT$1,
  LATITUDE_POINT_ACK: LATITUDE_POINT_ACK,
  LONGITUDE_POINT_ACK: LONGITUDE_POINT_ACK,
  IS_ALERT: IS_ALERT,
  ACTIVITY_INCLUDED: ACTIVITY_INCLUDED,
  BUTTON_CONFIG: BUTTON_CONFIG,
  FALL_CONFIG: FALL_CONFIG,
  TRACKER_CONFIG: TRACKER_CONFIG,
  UTC_TIME_ZONE_CONFIG: UTC_TIME_ZONE_CONFIG,
  STATE_OF_CHARGE: STATE_OF_CHARGE,
  IGNORE_WORN_STATE: IGNORE_WORN_STATE,
  EMBED_ERROR_LOG: EMBED_ERROR_LOG,
  DATE_MODE_CONFIG: DATE_MODE_CONFIG,
  LNG_PRESS_CONFIG: LNG_PRESS_CONFIG,
  CLOCK_MODE_CONFIG: CLOCK_MODE_CONFIG,
  WORN_STATE: WORN_STATE,
  FIRST_ACTIVITY: FIRST_ACTIVITY,
  ADMINISTRATION_MESSAGE_TYPE: ADMINISTRATION_MESSAGE_TYPE,
  DOWNLINK_ERROR_ADMINISTRATION_MESSAGE: DOWNLINK_ERROR_ADMINISTRATION_MESSAGE,
  FIRST_WATCHDOG_EVENT_ADMINISTRATION_MESSAGE: FIRST_WATCHDOG_EVENT_ADMINISTRATION_MESSAGE,
  POWER_ENERGY_REPORT_MESSAGE: POWER_ENERGY_REPORT_MESSAGE,
  TENSION_ENERGY_REPORT_MESSAGE: TENSION_ENERGY_REPORT_MESSAGE,
  CURRENT_ENERGY_REPORT_MESSAGE: CURRENT_ENERGY_REPORT_MESSAGE,
  ALTI_FIRST_GAP: ALTI_FIRST_GAP,
  ALTI_NEXT_GAP: ALTI_NEXT_GAP,
  ALTI_STRONG_OCCURRENCE: ALTI_STRONG_OCCURRENCE,
  WATCHDOG: WATCHDOG,
  WATCHDOG_LENGTH: WATCHDOG_LENGTH,
  DOWNLINK_COPY: DOWNLINK_COPY,
  CRON_PATTERN_EXTEND: CRON_PATTERN_EXTEND
});
function _getAlertTypes(deviceType) {
  switch (deviceType) {
    case DeviceType.ARF8170BCA:
      return [AlertType.DC_1, AlertType.DC_2, AlertType.EOL_BATTERY];
    case DeviceType.ARF8171BA:
      return [AlertType.DC_1, AlertType.DC_2, AlertType.EOL_BATTERY];
    case DeviceType.BSSigfox:
      return [];
    case DeviceType.BSLora:
      return [];
    case DeviceType.CAB:
      return [AlertType.BUTTON_BRACELET, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CALAU:
      return [AlertType.BUTTON_CAU_1, AlertType.BUTTON_CAU_2, AlertType.NON_FUNCTIONNAL, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CALDC:
      return [AlertType.DC_1, AlertType.NON_FUNCTIONNAL, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CALDS:
      return [AlertType.OPEN_DOOR, AlertType.NON_FUNCTIONNAL, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CALSB:
      return [AlertType.BUTTON_SOLE, AlertType.NON_FUNCTIONNAL, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CALP:
      return [AlertType.BUTTON_SOLE, AlertType.NON_FUNCTIONNAL, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CALT:
      return [AlertType.BUTTON_SOLE, AlertType.NON_FUNCTIONNAL, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CALWB:
      return [AlertType.BUTTON_SOLE, AlertType.NON_FUNCTIONNAL, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CALBC:
      return [AlertType.NON_FUNCTIONNAL];
    case DeviceType.CAU:
      return [AlertType.BUTTON_CAU_1, AlertType.BUTTON_CAU_2, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CAW:
      return [AlertType.BUTTON, AlertType.FALL, AlertType.ZONE_EXIT, AlertType.INACTIVITY, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.GH5200:
      return [AlertType.BUTTON_CALL, AlertType.ZONE_EXIT, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.EV07B:
      return [AlertType.BUTTON_CALL, AlertType.ZONE_EXIT, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.I870SF:
      return [AlertType.SMOKE, AlertType.EOL_BATTERY];
    case DeviceType.I870LR:
      return [AlertType.SMOKE, AlertType.EOL_BATTERY];
    case DeviceType.LA66USB:
      return [];
    case DeviceType.LDS02DS:
      return [AlertType.OPEN_DOOR, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.LDS02SB:
      return [AlertType.BUTTON_SOLE, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.LHT65NLR:
      return [AlertType.THRESHOLD];
    case DeviceType.LUNA4G:
      return [AlertType.BUTTON_SOLE];
    case DeviceType.NETWORKDEVICE:
      return [];
    case DeviceType.SMARTPHONE:
      return [];
    case DeviceType.SP4BUT:
      return [AlertType.BUTTON_SOLE, AlertType.EOL_BATTERY];
    case DeviceType.SP4MAG:
      return [AlertType.OPEN_DOOR, AlertType.EOL_BATTERY];
    case DeviceType.TMT250:
      return [AlertType.BUTTON_TMT, AlertType.ZONE_EXIT, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.TAGID:
      return [];
    case DeviceType.VH2BBUS01:
      return [AlertType.FALL, AlertType.ZONE_EXIT, AlertType.DISCONNECTION];
    case DeviceType.WSM02:
      return [AlertType.ZONE_EXIT];
    case DeviceType.X870LS:
      return [AlertType.SMOKE, AlertType.LOW_BATTERY, AlertType.EOL_BATTERY];
    case DeviceType.X865LS:
      return [AlertType.SMOKE, AlertType.LOW_BATTERY, AlertType.EOL_BATTERY];
    case DeviceType.X860LS:
      return [AlertType.SMOKE, AlertType.LOW_BATTERY, AlertType.EOL_BATTERY];
    case DeviceType.X855LS:
      return [AlertType.SMOKE, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.ZEPRLR:
      return [AlertType.SMOKE, AlertType.EOL_BATTERY];
    case DeviceType.ZEECDMINOLR:
      return [AlertType.LEAK, AlertType.EOL_BATTERY];
    default:
      return [];
  }
}
function _getAcknowledgeableAlertTypes(deviceType) {
  switch (deviceType) {
    case DeviceType.ARF8170BCA:
      return [AlertType.DC_1, AlertType.DC_2, AlertType.EOL_BATTERY];
    case DeviceType.ARF8171BA:
      return [AlertType.DC_1, AlertType.DC_2, AlertType.EOL_BATTERY];
    case DeviceType.BSSigfox:
      return [];
    case DeviceType.BSLora:
      return [];
    case DeviceType.CAB:
      return [AlertType.LOW_BATTERY, AlertType.NON_FUNCTIONNAL, AlertType.CRIT_BATTERY];
    case DeviceType.CALAU:
      return [AlertType.BUTTON_CAU_1, AlertType.NON_FUNCTIONNAL, AlertType.BUTTON_CAU_2, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CALDC:
      return [AlertType.DC_1, AlertType.NON_FUNCTIONNAL, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CALDS:
      return [AlertType.OPEN_DOOR, AlertType.NON_FUNCTIONNAL, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CALSB:
      return [AlertType.LOW_BATTERY, AlertType.NON_FUNCTIONNAL, AlertType.CRIT_BATTERY];
    case DeviceType.CALP:
      return [AlertType.LOW_BATTERY, AlertType.NON_FUNCTIONNAL, AlertType.CRIT_BATTERY];
    case DeviceType.CALT:
      return [AlertType.LOW_BATTERY, AlertType.NON_FUNCTIONNAL, AlertType.CRIT_BATTERY];
    case DeviceType.CALBC:
      return [AlertType.NON_FUNCTIONNAL];
    case DeviceType.CALWB:
      return [AlertType.LOW_BATTERY, AlertType.NON_FUNCTIONNAL, AlertType.CRIT_BATTERY];
    case DeviceType.CAU:
      return [AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.CAW:
      return [AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.GH5200:
      return [AlertType.BUTTON_CALL, AlertType.ZONE_EXIT, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.EV07B:
      return [AlertType.BUTTON_CALL, AlertType.ZONE_EXIT, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.I870SF:
      return [AlertType.SMOKE, AlertType.EOL_BATTERY];
    case DeviceType.I870LR:
      return [AlertType.SMOKE, AlertType.EOL_BATTERY];
    case DeviceType.LA66USB:
      return [];
    case DeviceType.LDS02DS:
      return [AlertType.OPEN_DOOR, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.LDS02SB:
      return [AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.LHT65NLR:
      return [AlertType.THRESHOLD];
    case DeviceType.LUNA4G:
      return [AlertType.BUTTON_SOLE];
    case DeviceType.NETWORKDEVICE:
      return [];
    case DeviceType.SMARTPHONE:
      return [];
    case DeviceType.SP4BUT:
      return [AlertType.EOL_BATTERY];
    case DeviceType.SP4MAG:
      return [AlertType.OPEN_DOOR, AlertType.EOL_BATTERY];
    case DeviceType.TMT250:
      return [AlertType.BUTTON_TMT, AlertType.ZONE_EXIT, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.TAGID:
      return [];
    case DeviceType.VH2BBUS01:
      return [AlertType.FALL, AlertType.ZONE_EXIT, AlertType.DISCONNECTION];
    case DeviceType.WSM02:
      return [AlertType.ZONE_EXIT];
    case DeviceType.X870LS:
      return [AlertType.SMOKE, AlertType.LOW_BATTERY, AlertType.EOL_BATTERY];
    case DeviceType.X865LS:
      return [AlertType.SMOKE, AlertType.LOW_BATTERY, AlertType.EOL_BATTERY];
    case DeviceType.X860LS:
      return [AlertType.SMOKE, AlertType.LOW_BATTERY, AlertType.EOL_BATTERY];
    case DeviceType.X855LS:
      return [AlertType.SMOKE, AlertType.LOW_BATTERY, AlertType.CRIT_BATTERY];
    case DeviceType.ZEPRLR:
      return [AlertType.SMOKE, AlertType.EOL_BATTERY];
    case DeviceType.ZEECDMINOLR:
      return [AlertType.THRESHOLD, AlertType.EOL_BATTERY];
    default:
      return [];
  }
}
function _getDelayableAlertTypes(deviceType) {
  switch (deviceType) {
    case DeviceType.ARF8171BA:
      return [];
    case DeviceType.ARF8170BCA:
      return [];
    case DeviceType.BSSigfox:
      return [];
    case DeviceType.BSLora:
      return [];
    case DeviceType.CAB:
      return [];
    case DeviceType.CALAU:
      return [];
    case DeviceType.CALDC:
      return [];
    case DeviceType.CALDS:
      return [AlertType.OPEN_DOOR];
    case DeviceType.CALSB:
      return [];
    case DeviceType.CALP:
      return [];
    case DeviceType.CALT:
      return [];
    case DeviceType.CALWB:
      return [];
    case DeviceType.CALBC:
      return [];
    case DeviceType.CAU:
      return [];
    case DeviceType.CAW:
      return [AlertType.INACTIVITY];
    case DeviceType.GH5200:
      return [];
    case DeviceType.EV07B:
      return [];
    case DeviceType.I870SF:
      return [];
    case DeviceType.I870LR:
      return [];
    case DeviceType.LA66USB:
      return [];
    case DeviceType.LDS02DS:
      return [AlertType.OPEN_DOOR];
    case DeviceType.LDS02SB:
      return [];
    case DeviceType.LHT65NLR:
      return [];
    case DeviceType.LUNA4G:
      return [];
    case DeviceType.NETWORKDEVICE:
      return [];
    case DeviceType.SMARTPHONE:
      return [];
    case DeviceType.SP4BUT:
      return [];
    case DeviceType.SP4MAG:
      return [AlertType.OPEN_DOOR];
    case DeviceType.TMT250:
      return [];
    case DeviceType.TAGID:
      return [];
    case DeviceType.VH2BBUS01:
      return [AlertType.DISCONNECTION];
    case DeviceType.WSM02:
      return [AlertType.ZONE_EXIT];
    case DeviceType.X870LS:
      return [];
    case DeviceType.X865LS:
      return [];
    case DeviceType.X860LS:
      return [];
    case DeviceType.X855LS:
      return [];
    case DeviceType.ZEPRLR:
      return [];
    case DeviceType.ZEECDMINOLR:
      return [];
    default:
      return [];
  }
}
function getAlertTypes(deviceType, unavailableThings = []) {
  return _getAlertTypes(deviceType).filter(a => !unavailableThings.find(ut => ut.deviceType === deviceType && ut.alertType === a));
}
function getAcknowledgeableAlertTypes(deviceType, groupAcknowledgeableAlerts) {
  let ret = _getAcknowledgeableAlertTypes(deviceType);
  if (groupAcknowledgeableAlerts === null || groupAcknowledgeableAlerts === void 0 ? void 0 : groupAcknowledgeableAlerts.length) {
    groupAcknowledgeableAlerts.filter(val => val.deviceType === deviceType).forEach(val => {
      //si c'est overide ackable false; il faut supprimer l'item de la liste ret.
      if (val.isAckable === false) ret = ret.filter(v => v !== val.alertType);else {
        // si c'est overide true, s'il n'est pas déjà dans la liste il faut l'ajouter
        if (!ret.find(v => v === val.alertType)) ret.push(val.alertType);
      }
    });
  }
  return ret;
}
function getDelayableAlertTypes(deviceType) {
  return _getDelayableAlertTypes(deviceType);
}
class GeneralGroup {
  constructor(object) {
    this.groupID = object.groupID;
    this.name = object.name;
    this.homeAddress = object.homeAddress;
    this.homeAddressGps = object.homeAddressGps;
    this.language = object.language || Language.Francais;
    this.active = object.active;
    this.activationDate = object.activationDate;
    this.deactivationDate = object.deactivationDate;
    this.button_long_pressure = object.button_long_pressure;
    this.helpers = object.helpers;
    this.time_mode = object.time_mode;
    this.buildings = object.buildings;
    this.utc_time_zone = object.utc_time_zone;
    this.realTimeTracker = object.realTimeTracker;
    this.autoTimeZoneUpdate = object.autoTimeZoneUpdate;
    this.profilePictureFileName = object.profilePictureFileName;
    this.unavailableModuleSettings = object.unavailableModuleSettings;
    this.acknowledgeableAlerts = object.acknowledgeableAlerts;
    this.unavailableAlerts = object.unavailableAlerts;
    this.alertDebounce = object.alertDebounce;
    this.ivrExpression = object.ivrExpression;
    this.useNewNotifications = object.useNewNotifications;
    this.fees = Array.isArray(object.fees) && normalizeFees(object.fees) || [];
    this.actionSetNames = Array.isArray(object.actionSetNames) && object.actionSetNames || [];
    this.withingsCredentials = object.withingsCredentials;
    this.geolocation = object.geolocation;
  }
  getGroupID() {
    return this.groupID;
  }
  getIVRExpression() {
    return this.ivrExpression || DEFAULT_IVR_EXPRESSION;
  }
  update(data) {
    for (const field in data) {
      const key = field;
      if (key !== 'groupID') {
        //@ts-expect-error
        this[key] = data[key];
      }
    }
    ;
  }
  /**
   * The function will pick up the most recent price for a given date and a particular type
   * @example : with the given "storage"
   * [ { type: subscriptionFees, price: 20, year: 2020 }, { type: consumption, price: 23, year: 2023 }, { type: subscriptionFees, price: 23, year: 2024 } ]
   * a call to this function with these parameters (2023, subscriptionFees) will given 20
   * a call to this function with these parameters (2022, consumption) will given undefined
   * @param year number
   * @param type FeesType
   * @returns the price if a value is found, undefined otherwise
   */
  getFeeByType(year, type) {
    const feeByTypeSortedByDescending = this.fees.filter(f => f.type === type && f.year <= year).sort((a, b) => b.year - a.year);
    return feeByTypeSortedByDescending.length > 0 ? feeByTypeSortedByDescending[0].price : undefined;
  }
  /**
   * Add or update fee if already existing
   * @param fee
   * @returns true if the fee has been loaded, false otherwise
   */
  updateFee(fee) {
    if (!validateFee(fee)) {
      return false;
    }
    const existingFee = this.fees.find(f => f.type === fee.type && f.year === fee.year);
    if (existingFee) {
      existingFee.price = fee.price;
    } else {
      this.fees.push(fee);
    }
    return true;
  }
  getGeolocation() {
    return this.geolocation;
  }
  getGeolocationAlgorithm() {
    var _a;
    return (_a = this.geolocation) === null || _a === void 0 ? void 0 : _a.name;
  }
}
function normalizeFees(fees) {
  return fees.filter(f => {
    return validateFee(f);
  });
}
function validateFee(fee) {
  return typeof (fee === null || fee === void 0 ? void 0 : fee.price) === 'number' && typeof fee.year === 'number' && fee.type in Group.FeesType;
}
var Group;
(function (Group) {
  let FeesType;
  (function (FeesType) {
    FeesType[FeesType["subscriptionFees"] = 0] = "subscriptionFees";
    FeesType[FeesType["hotWaterConsumption"] = 1] = "hotWaterConsumption";
    FeesType[FeesType["coldWaterConsumption"] = 2] = "coldWaterConsumption";
  })(FeesType = Group.FeesType || (Group.FeesType = {}));
  let Setting;
  (function (Setting) {
    Setting["REAL_TIME_TRACKER"] = "realTimeTracker";
    Setting["UTC_TIME_ZONE"] = "utc_time_zone";
    Setting["TIME_MODE"] = "time_mode";
    Setting["BUTTON_LONG_PRESSURE"] = "button_long_pressure";
  })(Setting = Group.Setting || (Group.Setting = {}));
  let TimeMode;
  (function (TimeMode) {
    TimeMode["ANALOG"] = "analog";
    TimeMode["DIGITAL"] = "digital";
    TimeMode["DIGITAL_DDMM"] = "digital_ddmm";
  })(TimeMode = Group.TimeMode || (Group.TimeMode = {}));
})(Group || (Group = {}));
var CAL_PROTOCOL_VERSIONS = /*#__PURE__*/function (CAL_PROTOCOL_VERSIONS) {
  CAL_PROTOCOL_VERSIONS[CAL_PROTOCOL_VERSIONS["ZERO"] = 0] = "ZERO";
  CAL_PROTOCOL_VERSIONS[CAL_PROTOCOL_VERSIONS["ONE"] = 1] = "ONE";
  CAL_PROTOCOL_VERSIONS[CAL_PROTOCOL_VERSIONS["TWO"] = 2] = "TWO";
  CAL_PROTOCOL_VERSIONS[CAL_PROTOCOL_VERSIONS["THREE"] = 3] = "THREE";
  CAL_PROTOCOL_VERSIONS[CAL_PROTOCOL_VERSIONS["FOUR"] = 4] = "FOUR";
  return CAL_PROTOCOL_VERSIONS;
}(CAL_PROTOCOL_VERSIONS || {});
var CAL_HARDWARE_VERSIONS = /*#__PURE__*/function (CAL_HARDWARE_VERSIONS) {
  CAL_HARDWARE_VERSIONS[CAL_HARDWARE_VERSIONS["HW_VERS_CAL_1_1"] = 0] = "HW_VERS_CAL_1_1";
  CAL_HARDWARE_VERSIONS[CAL_HARDWARE_VERSIONS["HW_VERS_LDWS_2_2"] = 1] = "HW_VERS_LDWS_2_2";
  return CAL_HARDWARE_VERSIONS;
}(CAL_HARDWARE_VERSIONS || {});
var CAL_SOFTWARE_VERSIONS = /*#__PURE__*/function (CAL_SOFTWARE_VERSIONS) {
  CAL_SOFTWARE_VERSIONS["ZERO"] = "0";
  CAL_SOFTWARE_VERSIONS["ONE"] = "1";
  CAL_SOFTWARE_VERSIONS["TWO"] = "2";
  CAL_SOFTWARE_VERSIONS["THREE"] = "3";
  CAL_SOFTWARE_VERSIONS["FOUR"] = "4";
  CAL_SOFTWARE_VERSIONS["FIVE"] = "5";
  CAL_SOFTWARE_VERSIONS["SIX"] = "6";
  CAL_SOFTWARE_VERSIONS["SEVEN"] = "7";
  CAL_SOFTWARE_VERSIONS["EIGHT"] = "8";
  CAL_SOFTWARE_VERSIONS["NINE"] = "9";
  CAL_SOFTWARE_VERSIONS["TEN"] = "10";
  CAL_SOFTWARE_VERSIONS["ELEVEN"] = "11";
  return CAL_SOFTWARE_VERSIONS;
}(CAL_SOFTWARE_VERSIONS || {});
var CAB_HARDWARE_VERSIONS = /*#__PURE__*/function (CAB_HARDWARE_VERSIONS) {
  CAB_HARDWARE_VERSIONS["CAB1_ALPHA"] = "cab1-alpha";
  CAB_HARDWARE_VERSIONS["CAB1_BETA"] = "cab1-beta";
  CAB_HARDWARE_VERSIONS["CAB1_GAMMA"] = "cab1-gamma";
  return CAB_HARDWARE_VERSIONS;
}(CAB_HARDWARE_VERSIONS || {});
var CAW_HARDWARE_VERSIONS = /*#__PURE__*/function (CAW_HARDWARE_VERSIONS) {
  CAW_HARDWARE_VERSIONS["CAW_09_24"] = "CAW_09_24";
  CAW_HARDWARE_VERSIONS["CAW_09_25"] = "CAW_09_25";
  CAW_HARDWARE_VERSIONS["CAW_09_27"] = "CAW_09_27";
  CAW_HARDWARE_VERSIONS["CAW_09_30"] = "CAW_09_30";
  CAW_HARDWARE_VERSIONS["CAW_09_40"] = "CAW_09_40";
  return CAW_HARDWARE_VERSIONS;
}(CAW_HARDWARE_VERSIONS || {});
var CAB_SOFTWARE_VERSIONS = /*#__PURE__*/function (CAB_SOFTWARE_VERSIONS) {
  CAB_SOFTWARE_VERSIONS["CAB1_BETA_AVR17"] = "cab1-beta-avr17";
  CAB_SOFTWARE_VERSIONS["CAB1_BETA_MAI17"] = "cab1-beta-mai17";
  CAB_SOFTWARE_VERSIONS["CAB1_BETA_SEPT17"] = "cab1-beta-sept17";
  CAB_SOFTWARE_VERSIONS["CAB1_BETA_OCT17"] = "cab1-beta-oct17";
  CAB_SOFTWARE_VERSIONS["CAB1_GAMMA_SEPT17"] = "cab1-gamma-sept17";
  CAB_SOFTWARE_VERSIONS["CAB1_GAMMA_OCT17"] = "cab1-gamma-oct17";
  CAB_SOFTWARE_VERSIONS["CAB1_GAMMA_NOV17"] = "cab1-gamma-nov17";
  CAB_SOFTWARE_VERSIONS["CAB1_GAMMA_DEC17"] = "cab1-gamma-dec17";
  CAB_SOFTWARE_VERSIONS["CAB1_GAMMA_FEB18"] = "cab1-gamma-feb18";
  return CAB_SOFTWARE_VERSIONS;
}(CAB_SOFTWARE_VERSIONS || {});
var SP4_SOFTWARE_VERSIONS = /*#__PURE__*/function (SP4_SOFTWARE_VERSIONS) {
  SP4_SOFTWARE_VERSIONS["6.1.0"] = "6.1.0";
  SP4_SOFTWARE_VERSIONS["6.1.12"] = "6.1.12";
  SP4_SOFTWARE_VERSIONS["6.2.3"] = "6.2.3";
  return SP4_SOFTWARE_VERSIONS;
}(SP4_SOFTWARE_VERSIONS || {});
var SOFTWARE_VERSIONS = /*#__PURE__*/function (SOFTWARE_VERSIONS) {
  SOFTWARE_VERSIONS["CAW_00_2_0"] = "CAW_00_2_0";
  SOFTWARE_VERSIONS["CAW_00_2_1"] = "CAW_00_2_1";
  SOFTWARE_VERSIONS["CAW_00_2_2"] = "CAW_00_2_2";
  SOFTWARE_VERSIONS["CAW_00_2_3"] = "CAW_00_2_3";
  SOFTWARE_VERSIONS["CAW_00_2_4"] = "CAW_00_2_4";
  SOFTWARE_VERSIONS["CAW_00_2_5"] = "CAW_00_2_5";
  SOFTWARE_VERSIONS["CAW_00_2_6"] = "CAW_00_2_6";
  SOFTWARE_VERSIONS["CAW_00_2_7"] = "CAW_00_2_7";
  SOFTWARE_VERSIONS["CAW_00_2_8"] = "CAW_00_2_8";
  SOFTWARE_VERSIONS["CAW_00_2_9"] = "CAW_00_2_9";
  SOFTWARE_VERSIONS["CAW_SF_3_0"] = "CAW_SF_3_0";
  SOFTWARE_VERSIONS["CAW_LR_3_0"] = "CAW_LR_3_0";
  SOFTWARE_VERSIONS["CAW_SF_3_1"] = "CAW_SF_3_1";
  SOFTWARE_VERSIONS["CAW_LR_3_1"] = "CAW_LR_3_1";
  SOFTWARE_VERSIONS["CAW_SF_3_2"] = "CAW_SF_3_2";
  SOFTWARE_VERSIONS["CAW_LR_3_2"] = "CAW_LR_3_2";
  SOFTWARE_VERSIONS["CAW_SF_3_3"] = "CAW_SF_3_3";
  SOFTWARE_VERSIONS["CAW_LR_3_3"] = "CAW_LR_3_3";
  SOFTWARE_VERSIONS["TBD"] = "TBD";
  SOFTWARE_VERSIONS["ALL_FEATURES_AVAILABLE"] = "AllFeaturesAvalaible"; // AllFeaturesAvalaible is for dev and unit tests
  return SOFTWARE_VERSIONS;
}(SOFTWARE_VERSIONS || {});
// Feature only available in some software/hardware version
var VERSION_FEATURE = /*#__PURE__*/function (VERSION_FEATURE) {
  VERSION_FEATURE["GPS_RELIABILITY_FIX"] = "handleMbdFixOnGPSReliability";
  VERSION_FEATURE["FALL_MODULE_SETTING"] = "fall";
  VERSION_FEATURE["UTC_TIME_ZONE_SETTING"] = "utc_time_zone";
  VERSION_FEATURE["CLOCK_MODE_SETTING"] = "clock_mode_analogDigit";
  VERSION_FEATURE["DATE_MODE_SETTING"] = "date_mode";
  VERSION_FEATURE["BUTTON_LONG_PRESSURE_SETTING"] = "button_long_pressure";
  VERSION_FEATURE["EMBED_ERROR_LOG"] = "embedErrorLog";
  VERSION_FEATURE["EMBED_FEATURE_STATE_MAP"] = "embedFeatureStateMap";
  VERSION_FEATURE["SYNC_TIME_BY_ANY_DOWNLINK"] = "syncTimeByAnyDownlink";
  VERSION_FEATURE["NETWORK_OPERATOR_SETTING"] = "networkOperator";
  VERSION_FEATURE["RTC_COMPENSATION_REMOTELY"] = "rtcCompensation4daysRemote";
  VERSION_FEATURE["RM_TIME_1ST_ALERT_MESSAGE"] = "rmTime1stAlertMessage";
  VERSION_FEATURE["CRON_SEQUENCE"] = "cronSequence";
  return VERSION_FEATURE;
}(VERSION_FEATURE || {});
function _getSettings(deviceType) {
  switch (deviceType) {
    case DeviceType.ARF8170BCA:
      return [];
    case DeviceType.ARF8171BA:
      return [];
    case DeviceType.BSSigfox:
      return [];
    case DeviceType.BSLora:
      return [];
    case DeviceType.CAB:
      return [];
    case DeviceType.CALAU:
      return [];
    case DeviceType.CALDC:
      return [];
    case DeviceType.CALDS:
      return [];
    case DeviceType.CALSB:
      return [];
    case DeviceType.CALP:
      return [];
    case DeviceType.CALT:
      return [];
    case DeviceType.CALWB:
      return [];
    case DeviceType.CALBC:
      return [];
    case DeviceType.CAU:
      return [];
    case DeviceType.CAW:
      return [Group.Setting.BUTTON_LONG_PRESSURE, Group.Setting.REAL_TIME_TRACKER, Group.Setting.TIME_MODE, Group.Setting.UTC_TIME_ZONE];
    case DeviceType.GH5200:
      return [Group.Setting.REAL_TIME_TRACKER];
    case DeviceType.EV07B:
      return [Group.Setting.REAL_TIME_TRACKER];
    case DeviceType.I870SF:
      return [];
    case DeviceType.I870LR:
      return [];
    case DeviceType.LA66USB:
      return [];
    case DeviceType.LDS02DS:
      return [];
    case DeviceType.LDS02SB:
      return [];
    case DeviceType.LHT65NLR:
      return [];
    case DeviceType.LUNA4G:
      return [];
    case DeviceType.NETWORKDEVICE:
      return [];
    case DeviceType.SMARTPHONE:
      return [];
    case DeviceType.SP4BUT:
      return [];
    case DeviceType.SP4MAG:
      return [];
    case DeviceType.TAGID:
      return [];
    case DeviceType.TMT250:
      return [Group.Setting.REAL_TIME_TRACKER];
    case DeviceType.VH2BBUS01:
      return [];
    case DeviceType.WSM02:
      return [];
    case DeviceType.X870LS:
      return [];
    case DeviceType.X865LS:
      return [];
    case DeviceType.X860LS:
      return [];
    case DeviceType.X855LS:
      return [];
    case DeviceType.ZEECDMINOLR:
      return [];
    case DeviceType.ZEPRLR:
      return [];
    default:
      return [];
  }
}
;
function getConfigurableSettings(deviceType, unavailableThings = []) {
  return _getSettings(deviceType).filter(s => !unavailableThings.find(ut => ut.deviceType === deviceType && ut.setting === s));
}
var UnitOfMeasure = /*#__PURE__*/function (UnitOfMeasure) {
  UnitOfMeasure["cubicMeter"] = "cubicMeter";
  UnitOfMeasure["calorie"] = "calorie";
  UnitOfMeasure["liter"] = "liter";
  return UnitOfMeasure;
}(UnitOfMeasure || {});
var Temperature = /*#__PURE__*/function (Temperature) {
  Temperature["cold"] = "cold";
  Temperature["hot"] = "hot";
  return Temperature;
}(Temperature || {});
var features_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get CAL_PROTOCOL_VERSIONS() {
    return CAL_PROTOCOL_VERSIONS;
  },
  get CAL_HARDWARE_VERSIONS() {
    return CAL_HARDWARE_VERSIONS;
  },
  get CAL_SOFTWARE_VERSIONS() {
    return CAL_SOFTWARE_VERSIONS;
  },
  get CAB_HARDWARE_VERSIONS() {
    return CAB_HARDWARE_VERSIONS;
  },
  get CAW_HARDWARE_VERSIONS() {
    return CAW_HARDWARE_VERSIONS;
  },
  get CAB_SOFTWARE_VERSIONS() {
    return CAB_SOFTWARE_VERSIONS;
  },
  get SP4_SOFTWARE_VERSIONS() {
    return SP4_SOFTWARE_VERSIONS;
  },
  get SOFTWARE_VERSIONS() {
    return SOFTWARE_VERSIONS;
  },
  get VERSION_FEATURE() {
    return VERSION_FEATURE;
  },
  getConfigurableSettings: getConfigurableSettings,
  get UnitOfMeasure() {
    return UnitOfMeasure;
  },
  get Temperature() {
    return Temperature;
  }
});

//MODULE STATUS
var STATUS = /*#__PURE__*/function (STATUS) {
  STATUS["STOCK"] = "stock";
  STATUS["DEDICATED"] = "dedicated";
  STATUS["DEPLOYED"] = "deployed";
  STATUS["LOST"] = "lost";
  STATUS["ANALYZING"] = "analyzing";
  STATUS["STOCK_TO_BE_REPAIRED"] = "stock_to_be_repaired";
  STATUS["RECYCLED"] = "recycled"; // => TO_RECYCLE
  return STATUS;
}(STATUS || {});
var DATATYPE_BASE = /*#__PURE__*/function (DATATYPE_BASE) {
  DATATYPE_BASE["GENERAL"] = "general";
  DATATYPE_BASE["STATES"] = "states";
  DATATYPE_BASE["SETTINGS"] = "settings";
  return DATATYPE_BASE;
}(DATATYPE_BASE || {});
;
var STATETYPE = /*#__PURE__*/function (STATETYPE) {
  STATETYPE["IN_DEFAULT"] = "inDefault";
  STATETYPE["BATTERY_LEVEL"] = "batteryLevel";
  STATETYPE["WORN_STATE"] = "wornState";
  STATETYPE["POSITION_STATE"] = "positionState";
  STATETYPE["DC_STATE"] = "dryContact";
  STATETYPE["DOOR_STATE"] = "doorState";
  STATETYPE["CONNECTIVITY"] = "connectivity";
  STATETYPE["LAST_VALUE"] = "lastValue";
  return STATETYPE;
}(STATETYPE || {});
var IN_DEFAULT_VALUE = /*#__PURE__*/function (IN_DEFAULT_VALUE) {
  IN_DEFAULT_VALUE["OK"] = "ok";
  IN_DEFAULT_VALUE["KO"] = "ko";
  IN_DEFAULT_VALUE["NA"] = "#N/A";
  return IN_DEFAULT_VALUE;
}(IN_DEFAULT_VALUE || {});
var DOOR_STATE_VALUE = /*#__PURE__*/function (DOOR_STATE_VALUE) {
  DOOR_STATE_VALUE["OPEN"] = "open";
  DOOR_STATE_VALUE["CLOSE"] = "close";
  return DOOR_STATE_VALUE;
}(DOOR_STATE_VALUE || {});
var BatteryLevel = /*#__PURE__*/function (BatteryLevel) {
  BatteryLevel["Unknown"] = "unknown";
  BatteryLevel["High"] = "high";
  BatteryLevel["Medium"] = "medium";
  BatteryLevel["Low"] = "low";
  BatteryLevel["Critical"] = "critical";
  return BatteryLevel;
}(BatteryLevel || {});
var ModuleState$1 = /*#__PURE__*/function (ModuleState) {
  ModuleState["Unknown"] = "unknown";
  ModuleState["Ok"] = "ok";
  ModuleState["Issue"] = "issue";
  ModuleState["Warning"] = "warning";
  return ModuleState;
}(ModuleState$1 || {});
var Connectivity = /*#__PURE__*/function (Connectivity) {
  Connectivity["Unknown"] = "unknown";
  Connectivity["Connected"] = "connected";
  Connectivity["Disconnected"] = "disconnected";
  return Connectivity;
}(Connectivity || {});
const EMBED_FEATURE_STATE_ALTIMETER_ID = 0;
const EMBED_FEATURE_STATE_ACCELEROMETER_ID = 1;
const EMBED_FEATURE_STATE_INFERRED_FALL_ID = 2;
const EMBED_STATE_MAP = new Map([[EMBED_FEATURE_STATE_ALTIMETER_ID, 'altimeter'], [EMBED_FEATURE_STATE_ACCELEROMETER_ID, 'accelerometer'], [EMBED_FEATURE_STATE_INFERRED_FALL_ID, 'inferredFall']]);
// General
const UPLINK_MESSAGE_LENGTH = 96;
const DOWNLINK_MESSAGE_LENGTH = 64;
// Header des messages envoyés par le module
const ALERT_HEADER = "1";
const HANDLING_HEADER = "2";
const REPORT_HEADER = "3";
const ACKNOWLEDGMENT_DOWNLINK_HEADER = "4";
const GPSFIX_HEADER = "5";
const PULL_HEADER = "6";
const ADMINISTRATION_HEADER = "9";
// ADMIN HEADER ID VALUE
const SYSTEM_ERROR = "0";
const DOWNLINK_ERROR = "1";
const POWER_ENERGY = "2";
const GPS_TEST = "3";
const BATTERY_REPORT = "4";
const ALTI_ERROR = "5";
const FEATURE_STATE_MAP = "6";
const CRON_ERROR = "7";
// FEATURES_STATE_MAP_ID
const FEATURES_STATE_MAP_ID = new Map([[0, "Altimeter"], [1, "Accelerometer"], [2, "Fall"], [3, "GPS"]]);
const FEATURES_STATE_MAP_STATE = new Map([[0, "Undefined"], [1, "Ok"], [2, "Standby"], [3, "Default"]]);
// Constantes d'identification du type d'alerte dans le message envoyé par le module
const BUTTON_ALERT_SOURCE = "0";
const INACTIVITY_ALERT_SOURCE = "1";
const FALL_ALERT_SOURCE = "2";
const ZONE_EXIT_ALERT_SOURCE = "3";
const WANDERING_ALERT_SOURCE = "4";
const LOW_BATTERY_ALERT_SOURCE = "5";
const CRITICAL_BATTERY_ALERT_SOURCE = "6";
// Alert level  in percentage
const LOW_BATTERY_ALERT_LEVEL = 15;
const CRITICAL_BATTERY_ALERT_LEVEL = 6;
// Constantes de types d'alertes
const NEW_ALERT_ACTION = "0";
const CANCEL_ALERT_ACTION = "1";
const ACQUIT_ALERT_ACTION = "2";
const POSITION_ACTION = "3";
// EMPTY DOWNLINK MESSAGE
const EMPTY_DOWNLINK_MESSAGE = "0000000000000000";
const DOWNLINK_BITS_NUMBER = 64;
const DOWNLINK_PAYLOAD_OFFSET = 32;
const ASK_NEW_DOWNLINK_IN_AKNOWLEDGMENT = 2;
const NO_OTHER_DOWNLINK_IN_AKNOWLEDGMENT = 1;
// DOWNLINK : DATA LENGTH (Bits)
const SETTING_ID_LENGTH = 6;
const POSITION_PAYLOAD_LENGTH = 57;
const ASK_NEW_DOWNLINK_LENGTH = 1;
const DOWNLINK_DATA_ID_LENGTH = 6;
// SETTING ID VALUE
const NO_MORE_SETTING_ID = 0;
// MODULE SETTING DEFAULT VALUE
const DOWNLINK_MESSAGE_HEADER_ASK_NEW_DOWNLINK = "1";
const DOWNLINK_MESSAGE_HEADER_NO_OTHER_DOWNLINK_NEEDED = "0";
//SETTING NAME
const NO_MORE_SETTING = "no_more_settings";
// WatchDog LOG EVENT ID VALUE
const WDOG_LOG_NO_EVENT = 0;
const WDOG_LOG_ALERT_FALL = 1;
const WDOG_LOG_ALERT_ZONE_EXIT = 2;
const WDOG_LOG_ALERT_BUTTON = 3;
const WDOG_LOG_ALERT_LOW_BATTERY = 4;
const WDOG_LOG_ALERT_CRITICAL_BATTERY = 5;
const WDOG_LOG_CANCEL_ALERT = 6;
const WDOG_LOG_ACQUIT_ALERT = 7;
const WDOG_LOG_GPS = 8;
const WDOG_LOG_BATTERY_CHECK = 9;
const WDOG_LOG_SIGFOX_SIMPLE = 10;
const WDOG_LOG_SIGFOX_DOWNLINK = 11;
const WDOG_LOG_RESET = 12;
const WDOG_LOG_INITIAL_STATE = 13;
const MAX_WATCHDOG_NUMBER = 11;
//WatchDOG Events NAME
const WDOG_LOG_NO_EVENT_NAME = "WDOG_LOG_NO_EVENT";
const WDOG_LOG_ALERT_FALL_NAME = "WDOG_LOG_ALERT_FALL";
const WDOG_LOG_ALERT_ZONE_EXIT_NAME = "WDOG_LOG_ALERT_ZONE_EXIT";
const WDOG_LOG_ALERT_BUTTON_NAME = "WDOG_LOG_ALERT_BUTTON";
const WDOG_LOG_ALERT_LOW_BATTERY_NAME = "WDOG_LOG_ALERT_LOW_BATTERY";
const WDOG_LOG_ALERT_CRITICAL_BATTERY_NAME = "WDOG_LOG_ALERT_CRITICAL_BATTERY";
const WDOG_LOG_CANCEL_ALERT_NAME = "WDOG_LOG_CANCEL_ALERT";
const WDOG_LOG_ACQUIT_ALERT_NAME = "WDOG_LOG_ACQUIT_ALERT";
const WDOG_LOG_GPS_NAME = "WDOG_LOG_GPS";
const WDOG_LOG_BATTERY_CHECK_NAME = "WDOG_LOG_BATTERY_CHECK";
const WDOG_LOG_SIGFOX_SIMPLE_NAME = "WDOG_LOG_SIGFOX_SIMPLE";
const WDOG_LOG_SIGFOX_DOWNLINK_NAME = "WDOG_LOG_SIGFOX_DOWNLINK";
const WDOG_LOG_RESET_NAME = "WDOG_LOG_RESET";
const WDOG_LOG_INITIAL_STATE_NAME = "WDOG_LOG_INITIAL_STATE";
const _settings = {
  locked: {
    id: 1,
    name: 'locked',
    length: 1,
    defaultValue: 0
  },
  button: {
    id: 2,
    name: 'button',
    length: 1,
    defaultValue: 1
  },
  fall: {
    id: 3,
    name: 'fall',
    length: 1,
    defaultValue: 0
  },
  inactivity: {
    id: 4,
    name: 'inactivity',
    length: 1,
    defaultValue: 0
  },
  cancel_alert: {
    id: 5,
    name: 'cancel_alert',
    length: 1,
    defaultValue: 1
  },
  real_time_tracking: {
    id: 6,
    name: 'real_time_tracking',
    length: 1,
    defaultValue: 0
  },
  wandering: {
    id: 7,
    name: 'wandering',
    length: 1,
    defaultValue: 0
  },
  zoneExit: {
    id: 8,
    name: 'zoneExit',
    length: 1,
    defaultValue: 0
  },
  time_between_two_downlinks: {
    id: 9,
    name: 'time_between_two_downlinks',
    length: 16,
    defaultValue: 1440
  },
  time_between_two_activity_reports: {
    id: 10,
    name: 'time_between_two_activity_reports',
    length: 16,
    defaultValue: 360
  },
  time_between_two_battery_tests: {
    id: 11,
    name: 'time_between_two_battery_tests',
    length: 16,
    defaultValue: 1440
  },
  time_between_two_real_time_tracking: {
    id: 12,
    name: 'time_between_two_real_time_tracking',
    length: 10,
    defaultValue: 10
  },
  fall_threshold_peack: {
    id: 13,
    name: 'fall_threshold_peack',
    length: 16,
    defaultValue: 3400
  },
  fall_threshold_inactivity: {
    id: 14,
    name: 'fall_threshold_inactivity',
    length: 16,
    defaultValue: 15600
  },
  fall_threshold_free_fall: {
    id: 15,
    name: 'fall_threshold_free_fall',
    length: 16,
    defaultValue: 1500
  },
  alert_duration: {
    id: 16,
    name: 'alert_duration',
    length: 10,
    defaultValue: 240
  },
  cron_1_bis: {
    id: 17,
    name: 'cron_1_bis',
    length: 57,
    defaultValue: 60365344270
  },
  cron_1: {
    id: 18,
    name: 'cron_1',
    length: 57,
    defaultValue: 60365344270
  },
  cron_2_bis: {
    id: 19,
    name: 'cron_2_bis',
    length: 57,
    defaultValue: 60365344270
  },
  cron_2: {
    id: 20,
    name: 'cron_2',
    length: 57,
    defaultValue: 60365344270
  },
  cron_3_bis: {
    id: 21,
    name: 'cron_3_bis',
    length: 57,
    defaultValue: 60365344270
  },
  cron_3: {
    id: 22,
    name: 'cron_3',
    length: 57,
    defaultValue: 60365344270
  },
  cron_4_bis: {
    id: 23,
    name: 'cron_4_bis',
    length: 57,
    defaultValue: 60365344270
  },
  cron_4: {
    id: 24,
    name: 'cron_4',
    length: 57,
    defaultValue: 60365344270
  },
  cron_5_bis: {
    id: 25,
    name: 'cron_5_bis',
    length: 57,
    defaultValue: 60365344270
  },
  cron_5: {
    id: 26,
    name: 'cron_5',
    length: 57,
    defaultValue: 60365344270
  },
  cron_6_bis: {
    id: 27,
    name: 'cron_6_bis',
    length: 57,
    defaultValue: 60365344270
  },
  cron_6: {
    id: 28,
    name: 'cron_6',
    length: 57,
    defaultValue: 60365344270
  },
  cron_7_bis: {
    id: 29,
    name: 'cron_7_bis',
    length: 57,
    defaultValue: 60365344270
  },
  cron_7: {
    id: 30,
    name: 'cron_7',
    length: 57,
    defaultValue: 60365344270
  },
  gps_precision_high: {
    id: 31,
    name: 'gps_precision_high',
    length: 8,
    defaultValue: 10
  },
  gps_forbidden_window_short: {
    id: 32,
    name: 'gps_forbidden_window_short',
    length: 16,
    defaultValue: 300
  },
  gps_forbidden_window_middle: {
    id: 33,
    name: 'gps_forbidden_window_middle',
    length: 16,
    defaultValue: 600
  },
  gps_forbidden_window_long: {
    id: 34,
    name: 'gps_forbidden_window_long',
    length: 16,
    defaultValue: 1200
  },
  unlock_key: {
    id: 35,
    name: 'unlock_key',
    length: 8,
    defaultValue: 0
  },
  tracking_threshold_by_packet: {
    id: 36,
    name: 'tracking_threshold_by_packet',
    length: 16,
    defaultValue: 8000
  },
  transport_status: {
    id: 37,
    name: 'transport_status',
    length: 1,
    defaultValue: 0
  },
  utc_time_zone: {
    id: 38,
    name: 'utc_time_zone',
    length: 5,
    defaultValue: 1
  },
  current_absolute_time: {
    id: 39,
    name: 'current_absolute_time',
    length: 32,
    defaultValue: 1
  },
  clock_mode_analogDigit: {
    id: 40,
    name: 'clock_mode_analogDigit',
    length: 1,
    defaultValue: 1
  },
  date_mode: {
    id: 41,
    name: 'date_mode',
    length: 2,
    defaultValue: 1
  },
  button_long_pressure: {
    id: 42,
    name: 'button_long_pressure',
    length: 1,
    defaultValue: 0
  },
  network_operator: {
    id: 43,
    name: 'network_operator',
    length: 2,
    defaultValue: 0
  },
  rtc_comp_4days_remote: {
    id: 44,
    name: 'rtc_comp_4days_remote',
    length: 7,
    defaultValue: -64
  },
  rm_time_1st_alert_message: {
    id: 45,
    name: 'rm_time_1st_alert_message',
    length: 1,
    defaultValue: 0
  }
};
const settingByName = _settings;
const settings = Object.values(settingByName);
const settingById = settings.reduce((acc, setting) => {
  const id = setting.id;
  /* istanbul ignore if */
  if (acc[id] !== undefined) {
    throw new Error(`Setting id '${id}' must be unique !`);
  }
  acc[id] = setting;
  return acc;
}, {});
var ReleasableFields = /*#__PURE__*/function (ReleasableFields) {
  ReleasableFields["groupID"] = "groupID";
  ReleasableFields["moduleOwner"] = "moduleOwner";
  ReleasableFields["name"] = "name";
  ReleasableFields["simCard"] = "simCard";
  ReleasableFields["rfidID"] = "rfidID";
  ReleasableFields["phoneNumber"] = "phoneNumber";
  return ReleasableFields;
}(ReleasableFields || {});
var CAWCondition = /*#__PURE__*/function (CAWCondition) {
  CAWCondition["NEW"] = "new";
  CAWCondition["REFURBISHED"] = "refurbished";
  return CAWCondition;
}(CAWCondition || {});
var BSSigfoxCommunicationStatus = /*#__PURE__*/function (BSSigfoxCommunicationStatus) {
  BSSigfoxCommunicationStatus["down"] = "Communication down";
  BSSigfoxCommunicationStatus["up"] = "Communication up";
  return BSSigfoxCommunicationStatus;
}(BSSigfoxCommunicationStatus || {});
var PositionState = /*#__PURE__*/function (PositionState) {
  PositionState["IN"] = "IN";
  PositionState["OUT"] = "OUT";
  PositionState["UNKNOWN"] = "UNKNOWN";
  return PositionState;
}(PositionState || {});
var VayyarCare;
(function (VayyarCare) {
  let AdminMethod;
  (function (AdminMethod) {
    AdminMethod[AdminMethod["Auth"] = 1] = "Auth";
    AdminMethod[AdminMethod["ReadMqttHook"] = 2] = "ReadMqttHook";
    AdminMethod[AdminMethod["ReadDeviceConfig"] = 3] = "ReadDeviceConfig";
    AdminMethod[AdminMethod["ReadDeviceMetadata"] = 4] = "ReadDeviceMetadata";
    AdminMethod[AdminMethod["SetMqttHook"] = 5] = "SetMqttHook";
    AdminMethod[AdminMethod["SendDeviceCommand"] = 6] = "SendDeviceCommand";
    AdminMethod[AdminMethod["FallFeedback"] = 7] = "FallFeedback";
  })(AdminMethod = VayyarCare.AdminMethod || (VayyarCare.AdminMethod = {}));
  let FallClassification;
  (function (FallClassification) {
    FallClassification["TRUE_POSITIVE"] = "TRUE_POSITIVE";
    FallClassification["FALSE_POSITIVE"] = "FALSE_POSITIVE";
    FallClassification["FALSE_NEGATIVE"] = "FALSE_NEGATIVE";
    FallClassification["TEST_FALL"] = "TEST_FALL";
  })(FallClassification = VayyarCare.FallClassification || (VayyarCare.FallClassification = {}));
  let MqttConfPayload;
  (function (MqttConfPayload) {
    MqttConfPayload[MqttConfPayload["test"] = 0] = "test";
    MqttConfPayload[MqttConfPayload["prod"] = 1] = "prod";
  })(MqttConfPayload = VayyarCare.MqttConfPayload || (VayyarCare.MqttConfPayload = {}));
  VayyarCare.mqttConf = {
    [MqttConfPayload.test]: {
      host: "mqtt://mqtt.bridge.co-assist.fr",
      port: 8883,
      username: "coassist",
      password: "maud1989"
    },
    [MqttConfPayload.prod]: {
      host: "mqtt://mqtt.bridge.co-assist.fr",
      port: 8883,
      username: "vayyar",
      password: "azerty"
    }
  };
  let APICommandType;
  (function (APICommandType) {
    APICommandType["reboot"] = "Reboot";
    APICommandType["uploadLogs"] = "UploadLog";
    APICommandType["updateWifiCredentials"] = "UpdateWifiCredentials";
  })(APICommandType = VayyarCare.APICommandType || (VayyarCare.APICommandType = {}));
})(VayyarCare || (VayyarCare = {}));
function isAMobileDevice(deviceType) {
  switch (deviceType) {
    case DeviceType.ARF8170BCA:
    case DeviceType.ARF8171BA:
    case DeviceType.BSLora:
    case DeviceType.BSSigfox:
    case DeviceType.CALAU:
    case DeviceType.CALDC:
    case DeviceType.CALDS:
    case DeviceType.CALSB:
    case DeviceType.CALBC:
    case DeviceType.CALP:
    case DeviceType.CALT:
    case DeviceType.CAU:
    case DeviceType.I870SF:
    case DeviceType.I870LR:
    case DeviceType.LHT65NLR:
    case DeviceType.LDS02DS:
    case DeviceType.LDS02SB:
    case DeviceType.LUNA4G:
    case DeviceType.VH2BBUS01:
    case DeviceType.NETWORKDEVICE:
    case DeviceType.SP4BUT:
    case DeviceType.SP4MAG:
    case DeviceType.TAGID:
    case DeviceType.X870LS:
    case DeviceType.X865LS:
    case DeviceType.X860LS:
    case DeviceType.X855LS:
    case DeviceType.ZEECDMINOLR:
    case DeviceType.ZEPRLR:
      return false;
    case DeviceType.CAB:
    case DeviceType.CAW:
    case DeviceType.CALWB:
    case DeviceType.EV07B:
    case DeviceType.GH5200:
    case DeviceType.LA66USB:
    case DeviceType.SMARTPHONE:
    case DeviceType.TMT250:
      return true;
    default:
      return false;
  }
}
/* istanbul ignore next */
function getDeviceProfile(deviceType, group, moduleGeneral) {
  var _a, _b, _c, _d, _e;
  const ret = defaultScheme;
  if (!deviceType) {
    return ret;
  }
  const unavailableAlerts = (_a = group === null || group === void 0 ? void 0 : group.unavailableAlerts) !== null && _a !== void 0 ? _a : [];
  const unavailableModuleSettings = (_b = group === null || group === void 0 ? void 0 : group.unavailableModuleSettings) !== null && _b !== void 0 ? _b : [];
  const groupAcknowledgeableAlerts = (_c = group === null || group === void 0 ? void 0 : group.acknowledgeableAlerts) !== null && _c !== void 0 ? _c : [];
  ret.availableAlerts = getAlertTypes(deviceType, unavailableAlerts);
  ret.availableSettings = getConfigurableSettings(deviceType, unavailableModuleSettings);
  ret.acknowledgeableAlert = getAcknowledgeableAlertTypes(deviceType, groupAcknowledgeableAlerts);
  ret.delayableAlerts = getDelayableAlertTypes(deviceType);
  ret.isMobile = isAMobileDevice(deviceType);
  switch (deviceType) {
    case DeviceType.CAW:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: true,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT]
      });
    case DeviceType.CAB:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT]
      });
    case DeviceType.BSSigfox:
    case DeviceType.BSLora:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: false,
        isAlertConfigurationEnable: false,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.IN_DEFAULT]
      });
    case DeviceType.SP4MAG:
    case DeviceType.SP4BUT:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT]
      });
    case DeviceType.I870SF:
    case DeviceType.I870LR:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT]
      });
    case DeviceType.GH5200:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: true,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT],
        stickyAlerts: ((_d = moduleGeneral) === null || _d === void 0 ? void 0 : _d.phoneNumber) ? [AlertType.BUTTON_CALL] : [],
        stickySettings: [Group.Setting.REAL_TIME_TRACKER]
      });
    case DeviceType.TMT250:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: true,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT],
        stickySettings: [Group.Setting.REAL_TIME_TRACKER]
      });
    case DeviceType.EV07B:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: true,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT],
        stickyAlerts: ((_e = moduleGeneral) === null || _e === void 0 ? void 0 : _e.phoneNumber) ? [AlertType.BUTTON_CALL] : [],
        stickySettings: [Group.Setting.REAL_TIME_TRACKER]
      });
    case DeviceType.SMARTPHONE:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: false,
        isAlertConfigurationEnable: false,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT]
      });
    case DeviceType.CAU:
    case DeviceType.CALAU:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT]
      });
    case DeviceType.ARF8170BCA:
    case DeviceType.ARF8171BA:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT]
      });
    case DeviceType.CALDC:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT, STATETYPE.DC_STATE]
      });
    case DeviceType.CALDS:
    case DeviceType.CALSB:
    case DeviceType.LDS02DS:
    case DeviceType.LDS02SB:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT]
      });
    case DeviceType.VH2BBUS01:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        filteredB2BConfigAlerts: [AlertType.ZONE_EXIT],
        availableStates: [STATETYPE.IN_DEFAULT],
        inOutLocalisation: true
      });
    case DeviceType.LA66USB:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: false,
        isAlertConfigurationEnable: false,
        isDeviceConfigurationEnable: false,
        availableStates: []
      });
    case DeviceType.CALP:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT]
      });
    case DeviceType.LUNA4G:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.IN_DEFAULT]
      });
    case DeviceType.TAGID:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: false,
        isDeviceConfigurationEnable: false,
        availableStates: [],
        isPassive: true
      });
    case DeviceType.CALT:
    case DeviceType.CALWB:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.BATTERY_LEVEL, STATETYPE.IN_DEFAULT]
      });
    case DeviceType.ZEPRLR:
    case DeviceType.ZEECDMINOLR:
    case DeviceType.LHT65NLR:
    case DeviceType.X870LS:
    case DeviceType.X865LS:
    case DeviceType.X860LS:
    case DeviceType.X855LS:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: true,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.IN_DEFAULT]
      });
    case DeviceType.NETWORKDEVICE:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: false,
        isAlertConfigurationEnable: false,
        isDeviceConfigurationEnable: false,
        availableStates: []
      });
    case DeviceType.WSM02:
      return Object.assign(Object.assign({}, ret), {
        isAssociableToUser: true,
        isAlertConfigurationEnable: false,
        isDeviceConfigurationEnable: false,
        availableStates: [STATETYPE.IN_DEFAULT]
      });
    default:
      return ret;
  }
}
const defaultScheme = {
  availableAlerts: [],
  availableSettings: [],
  acknowledgeableAlert: [],
  delayableAlerts: [],
  stickyAlerts: [],
  stickySettings: [],
  isAssociableToUser: false,
  isAlertConfigurationEnable: false,
  isDeviceConfigurationEnable: false,
  availableStates: [],
  isPassive: false,
  isMobile: false
};
var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAlertTypes: getAlertTypes,
  getAcknowledgeableAlertTypes: getAcknowledgeableAlertTypes,
  getDelayableAlertTypes: getDelayableAlertTypes,
  get STATUS() {
    return STATUS;
  },
  get DATATYPE_BASE() {
    return DATATYPE_BASE;
  },
  get STATETYPE() {
    return STATETYPE;
  },
  get IN_DEFAULT_VALUE() {
    return IN_DEFAULT_VALUE;
  },
  get DOOR_STATE_VALUE() {
    return DOOR_STATE_VALUE;
  },
  get BatteryLevel() {
    return BatteryLevel;
  },
  get ModuleState() {
    return ModuleState$1;
  },
  get Connectivity() {
    return Connectivity;
  },
  EMBED_FEATURE_STATE_ALTIMETER_ID: EMBED_FEATURE_STATE_ALTIMETER_ID,
  EMBED_FEATURE_STATE_ACCELEROMETER_ID: EMBED_FEATURE_STATE_ACCELEROMETER_ID,
  EMBED_FEATURE_STATE_INFERRED_FALL_ID: EMBED_FEATURE_STATE_INFERRED_FALL_ID,
  EMBED_STATE_MAP: EMBED_STATE_MAP,
  UPLINK_MESSAGE_LENGTH: UPLINK_MESSAGE_LENGTH,
  DOWNLINK_MESSAGE_LENGTH: DOWNLINK_MESSAGE_LENGTH,
  ALERT_HEADER: ALERT_HEADER,
  HANDLING_HEADER: HANDLING_HEADER,
  REPORT_HEADER: REPORT_HEADER,
  ACKNOWLEDGMENT_DOWNLINK_HEADER: ACKNOWLEDGMENT_DOWNLINK_HEADER,
  GPSFIX_HEADER: GPSFIX_HEADER,
  PULL_HEADER: PULL_HEADER,
  ADMINISTRATION_HEADER: ADMINISTRATION_HEADER,
  SYSTEM_ERROR: SYSTEM_ERROR,
  DOWNLINK_ERROR: DOWNLINK_ERROR,
  POWER_ENERGY: POWER_ENERGY,
  GPS_TEST: GPS_TEST,
  BATTERY_REPORT: BATTERY_REPORT,
  ALTI_ERROR: ALTI_ERROR,
  FEATURE_STATE_MAP: FEATURE_STATE_MAP,
  CRON_ERROR: CRON_ERROR,
  FEATURES_STATE_MAP_ID: FEATURES_STATE_MAP_ID,
  FEATURES_STATE_MAP_STATE: FEATURES_STATE_MAP_STATE,
  BUTTON_ALERT_SOURCE: BUTTON_ALERT_SOURCE,
  INACTIVITY_ALERT_SOURCE: INACTIVITY_ALERT_SOURCE,
  FALL_ALERT_SOURCE: FALL_ALERT_SOURCE,
  ZONE_EXIT_ALERT_SOURCE: ZONE_EXIT_ALERT_SOURCE,
  WANDERING_ALERT_SOURCE: WANDERING_ALERT_SOURCE,
  LOW_BATTERY_ALERT_SOURCE: LOW_BATTERY_ALERT_SOURCE,
  CRITICAL_BATTERY_ALERT_SOURCE: CRITICAL_BATTERY_ALERT_SOURCE,
  LOW_BATTERY_ALERT_LEVEL: LOW_BATTERY_ALERT_LEVEL,
  CRITICAL_BATTERY_ALERT_LEVEL: CRITICAL_BATTERY_ALERT_LEVEL,
  NEW_ALERT_ACTION: NEW_ALERT_ACTION,
  CANCEL_ALERT_ACTION: CANCEL_ALERT_ACTION,
  ACQUIT_ALERT_ACTION: ACQUIT_ALERT_ACTION,
  POSITION_ACTION: POSITION_ACTION,
  EMPTY_DOWNLINK_MESSAGE: EMPTY_DOWNLINK_MESSAGE,
  DOWNLINK_BITS_NUMBER: DOWNLINK_BITS_NUMBER,
  DOWNLINK_PAYLOAD_OFFSET: DOWNLINK_PAYLOAD_OFFSET,
  ASK_NEW_DOWNLINK_IN_AKNOWLEDGMENT: ASK_NEW_DOWNLINK_IN_AKNOWLEDGMENT,
  NO_OTHER_DOWNLINK_IN_AKNOWLEDGMENT: NO_OTHER_DOWNLINK_IN_AKNOWLEDGMENT,
  SETTING_ID_LENGTH: SETTING_ID_LENGTH,
  POSITION_PAYLOAD_LENGTH: POSITION_PAYLOAD_LENGTH,
  ASK_NEW_DOWNLINK_LENGTH: ASK_NEW_DOWNLINK_LENGTH,
  DOWNLINK_DATA_ID_LENGTH: DOWNLINK_DATA_ID_LENGTH,
  NO_MORE_SETTING_ID: NO_MORE_SETTING_ID,
  DOWNLINK_MESSAGE_HEADER_ASK_NEW_DOWNLINK: DOWNLINK_MESSAGE_HEADER_ASK_NEW_DOWNLINK,
  DOWNLINK_MESSAGE_HEADER_NO_OTHER_DOWNLINK_NEEDED: DOWNLINK_MESSAGE_HEADER_NO_OTHER_DOWNLINK_NEEDED,
  NO_MORE_SETTING: NO_MORE_SETTING,
  WDOG_LOG_NO_EVENT: WDOG_LOG_NO_EVENT,
  WDOG_LOG_ALERT_FALL: WDOG_LOG_ALERT_FALL,
  WDOG_LOG_ALERT_ZONE_EXIT: WDOG_LOG_ALERT_ZONE_EXIT,
  WDOG_LOG_ALERT_BUTTON: WDOG_LOG_ALERT_BUTTON,
  WDOG_LOG_ALERT_LOW_BATTERY: WDOG_LOG_ALERT_LOW_BATTERY,
  WDOG_LOG_ALERT_CRITICAL_BATTERY: WDOG_LOG_ALERT_CRITICAL_BATTERY,
  WDOG_LOG_CANCEL_ALERT: WDOG_LOG_CANCEL_ALERT,
  WDOG_LOG_ACQUIT_ALERT: WDOG_LOG_ACQUIT_ALERT,
  WDOG_LOG_GPS: WDOG_LOG_GPS,
  WDOG_LOG_BATTERY_CHECK: WDOG_LOG_BATTERY_CHECK,
  WDOG_LOG_SIGFOX_SIMPLE: WDOG_LOG_SIGFOX_SIMPLE,
  WDOG_LOG_SIGFOX_DOWNLINK: WDOG_LOG_SIGFOX_DOWNLINK,
  WDOG_LOG_RESET: WDOG_LOG_RESET,
  WDOG_LOG_INITIAL_STATE: WDOG_LOG_INITIAL_STATE,
  MAX_WATCHDOG_NUMBER: MAX_WATCHDOG_NUMBER,
  WDOG_LOG_NO_EVENT_NAME: WDOG_LOG_NO_EVENT_NAME,
  WDOG_LOG_ALERT_FALL_NAME: WDOG_LOG_ALERT_FALL_NAME,
  WDOG_LOG_ALERT_ZONE_EXIT_NAME: WDOG_LOG_ALERT_ZONE_EXIT_NAME,
  WDOG_LOG_ALERT_BUTTON_NAME: WDOG_LOG_ALERT_BUTTON_NAME,
  WDOG_LOG_ALERT_LOW_BATTERY_NAME: WDOG_LOG_ALERT_LOW_BATTERY_NAME,
  WDOG_LOG_ALERT_CRITICAL_BATTERY_NAME: WDOG_LOG_ALERT_CRITICAL_BATTERY_NAME,
  WDOG_LOG_CANCEL_ALERT_NAME: WDOG_LOG_CANCEL_ALERT_NAME,
  WDOG_LOG_ACQUIT_ALERT_NAME: WDOG_LOG_ACQUIT_ALERT_NAME,
  WDOG_LOG_GPS_NAME: WDOG_LOG_GPS_NAME,
  WDOG_LOG_BATTERY_CHECK_NAME: WDOG_LOG_BATTERY_CHECK_NAME,
  WDOG_LOG_SIGFOX_SIMPLE_NAME: WDOG_LOG_SIGFOX_SIMPLE_NAME,
  WDOG_LOG_SIGFOX_DOWNLINK_NAME: WDOG_LOG_SIGFOX_DOWNLINK_NAME,
  WDOG_LOG_RESET_NAME: WDOG_LOG_RESET_NAME,
  WDOG_LOG_INITIAL_STATE_NAME: WDOG_LOG_INITIAL_STATE_NAME,
  settingByName: settingByName,
  settings: settings,
  settingById: settingById,
  get ReleasableFields() {
    return ReleasableFields;
  },
  get CAWCondition() {
    return CAWCondition;
  },
  get BSSigfoxCommunicationStatus() {
    return BSSigfoxCommunicationStatus;
  },
  get PositionState() {
    return PositionState;
  },
  get VayyarCare() {
    return VayyarCare;
  },
  isAMobileDevice: isAMobileDevice,
  getDeviceProfile: getDeviceProfile,
  defaultScheme: defaultScheme,
  get CAL_PROTOCOL_VERSIONS() {
    return CAL_PROTOCOL_VERSIONS;
  },
  get CAL_HARDWARE_VERSIONS() {
    return CAL_HARDWARE_VERSIONS;
  },
  get CAL_SOFTWARE_VERSIONS() {
    return CAL_SOFTWARE_VERSIONS;
  },
  get CAB_HARDWARE_VERSIONS() {
    return CAB_HARDWARE_VERSIONS;
  },
  get CAW_HARDWARE_VERSIONS() {
    return CAW_HARDWARE_VERSIONS;
  },
  get CAB_SOFTWARE_VERSIONS() {
    return CAB_SOFTWARE_VERSIONS;
  },
  get SP4_SOFTWARE_VERSIONS() {
    return SP4_SOFTWARE_VERSIONS;
  },
  get SOFTWARE_VERSIONS() {
    return SOFTWARE_VERSIONS;
  },
  get VERSION_FEATURE() {
    return VERSION_FEATURE;
  },
  getConfigurableSettings: getConfigurableSettings,
  get UnitOfMeasure() {
    return UnitOfMeasure;
  },
  get Temperature() {
    return Temperature;
  }
});

// Constantes de report
const REPORT_INCLUDE_ACTIVITY = '1';
const REPORT_WITHOUT_ACTIVITY = '0';
const NO_BATTERY_LEVEL_MEASURED = 254;
const NO_BATTERY_LEVEL_AVAILABLE = 255;
const DEVICE_NOT_WORN = 0;
const DEVICE_WORN = 1;
const ACTIVITY_REPORT_DATA_TYPE$1 = "activityReport";
var reportConst = /*#__PURE__*/Object.freeze({
  __proto__: null,
  REPORT_INCLUDE_ACTIVITY: REPORT_INCLUDE_ACTIVITY,
  REPORT_WITHOUT_ACTIVITY: REPORT_WITHOUT_ACTIVITY,
  NO_BATTERY_LEVEL_MEASURED: NO_BATTERY_LEVEL_MEASURED,
  NO_BATTERY_LEVEL_AVAILABLE: NO_BATTERY_LEVEL_AVAILABLE,
  DEVICE_NOT_WORN: DEVICE_NOT_WORN,
  DEVICE_WORN: DEVICE_WORN,
  ACTIVITY_REPORT_DATA_TYPE: ACTIVITY_REPORT_DATA_TYPE$1
});
const PULL_PAYLOAD_OFFSET = 10;
const PULL_SETTING_SEPARATE = 2;
var pullConst = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PULL_PAYLOAD_OFFSET: PULL_PAYLOAD_OFFSET,
  PULL_SETTING_SEPARATE: PULL_SETTING_SEPARATE
});
var TEMPLATE$1 = /*#__PURE__*/function (TEMPLATE) {
  TEMPLATE["HTML"] = "invoice-pdf.template.pug";
  TEMPLATE["CSS"] = "invoice-pdf.css";
  return TEMPLATE;
}(TEMPLATE$1 || {});
var TYPE = /*#__PURE__*/function (TYPE) {
  TYPE["INVOICE"] = "invoice";
  TYPE["CREDIT_NOTE"] = "creditNote";
  return TYPE;
}(TYPE || {});
var PREFIX = /*#__PURE__*/function (PREFIX) {
  PREFIX["invoice"] = "F";
  PREFIX["creditNote"] = "A";
  return PREFIX;
}(PREFIX || {});
;
var LINE_CODE = /*#__PURE__*/function (LINE_CODE) {
  LINE_CODE["ECOWATCH"] = "ECOWATCH";
  LINE_CODE["ECOWATCH3"] = "ECOWATCH3";
  LINE_CODE["ECOREPEAT"] = "ECOREPEAT";
  LINE_CODE["ECOREPEAT2"] = "ECOREPEAT2";
  LINE_CODE["ECOSTATION"] = "ECOSTATION";
  LINE_CODE["LIBWATCH"] = "LIBWATCH";
  LINE_CODE["LIBWATCH2"] = "LIBWATCH2";
  LINE_CODE["LIBREPEAT"] = "LIBREPEAT";
  LINE_CODE["LIBREPEAT2"] = "LIBREPEAT2";
  LINE_CODE["LIBSTATION"] = "LIBSTATION";
  LINE_CODE["SERVICEINC"] = "SERVICEINC";
  LINE_CODE["SERVICEREC"] = "SERVICEREC";
  LINE_CODE["SERVICEREC2"] = "SERVICEREC2";
  LINE_CODE["EQUIPCHARGER"] = "EQUIPCHARGER";
  LINE_CODE["EQUIPBRACELET"] = "EQUIPBRACELET";
  LINE_CODE["EQUIPBUTTON"] = "EQUIPBUTTON";
  LINE_CODE["EQUIPSCREEN"] = "EQUIPSCREEN";
  LINE_CODE["EQUIPOVERSHELL"] = "EQUIPOVERSHELL";
  LINE_CODE["EQUIPCABLE"] = "EQUIPCABLE";
  LINE_CODE["EQUIPTRANSFO"] = "EQUIPTRANSFO";
  LINE_CODE["DEPWATCH"] = "DEPWATCH";
  LINE_CODE["DEPREPEATER"] = "DEPREPEATER";
  LINE_CODE["DEPANTENNA"] = "DEPANTENNA";
  LINE_CODE["SERVICETELECARE"] = "SERVICETELECARE";
  LINE_CODE["FEE"] = "FEE";
  LINE_CODE["CUSTOM"] = "CUSTOM";
  return LINE_CODE;
}(LINE_CODE || {});
var LINE_i18n = /*#__PURE__*/function (LINE_i18n) {
  LINE_i18n["ECOWATCH"] = "economy.watch";
  LINE_i18n["ECOWATCH3"] = "economy.watch";
  LINE_i18n["ECOREPEAT"] = "economy.repeater";
  LINE_i18n["ECOREPEAT2"] = "economy.repeater";
  LINE_i18n["ECOSTATION"] = "economy.basestation";
  LINE_i18n["LIBWATCH"] = "liberty.watch";
  LINE_i18n["LIBWATCH2"] = "liberty.watch";
  LINE_i18n["LIBREPEAT"] = "liberty.repeater";
  LINE_i18n["LIBREPEAT2"] = "liberty.repeater";
  LINE_i18n["LIBSTATION"] = "liberty.basestation";
  LINE_i18n["SERVICEINC"] = "service.included";
  LINE_i18n["SERVICEREC"] = "service.recurring";
  LINE_i18n["SERVICEREC2"] = "service.recurring";
  LINE_i18n["EQUIPCHARGER"] = "equipment.charger";
  LINE_i18n["EQUIPBRACELET"] = "equipment.bracelet";
  LINE_i18n["EQUIPBUTTON"] = "equipment.button";
  LINE_i18n["EQUIPSCREEN"] = "equipment.screen";
  LINE_i18n["EQUIPCABLE"] = "equipment.cable";
  LINE_i18n["EQUIPTRANSFO"] = "equipment.transformer";
  LINE_i18n["EQUIPOVERSHELL"] = "equipment.overshell";
  LINE_i18n["DEPWATCH"] = "deposit.watch";
  LINE_i18n["DEPREPEATER"] = "deposit.repeater";
  LINE_i18n["DEPANTENNA"] = "deposit.basestation";
  LINE_i18n["SERVICETELECARE"] = "service.telecare";
  LINE_i18n["FEE"] = "service.fee";
  return LINE_i18n;
}(LINE_i18n || {});
var LINE_PRICE = /*#__PURE__*/function (LINE_PRICE) {
  LINE_PRICE[LINE_PRICE["ECOWATCH"] = 249.99] = "ECOWATCH";
  LINE_PRICE[LINE_PRICE["ECOWATCH3"] = 269.99] = "ECOWATCH3";
  LINE_PRICE[LINE_PRICE["ECOREPEAT"] = 100] = "ECOREPEAT";
  LINE_PRICE[LINE_PRICE["ECOREPEAT2"] = 60] = "ECOREPEAT2";
  LINE_PRICE[LINE_PRICE["ECOSTATION"] = 900] = "ECOSTATION";
  LINE_PRICE[LINE_PRICE["LIBWATCH"] = 10] = "LIBWATCH";
  LINE_PRICE[LINE_PRICE["LIBWATCH2"] = 15] = "LIBWATCH2";
  LINE_PRICE[LINE_PRICE["LIBREPEAT"] = 8] = "LIBREPEAT";
  LINE_PRICE[LINE_PRICE["LIBREPEAT2"] = 4] = "LIBREPEAT2";
  LINE_PRICE[LINE_PRICE["LIBSTATION"] = 45] = "LIBSTATION";
  LINE_PRICE[LINE_PRICE["SERVICEINC"] = 0] = "SERVICEINC";
  LINE_PRICE[LINE_PRICE["SERVICEREC"] = 15] = "SERVICEREC";
  LINE_PRICE[LINE_PRICE["SERVICEREC2"] = 29.99] = "SERVICEREC2";
  LINE_PRICE[LINE_PRICE["SERVICEREC_RE"] = 26] = "SERVICEREC_RE";
  LINE_PRICE[LINE_PRICE["EQUIPCHARGER"] = 40] = "EQUIPCHARGER";
  LINE_PRICE[LINE_PRICE["EQUIPBRACELET"] = 12] = "EQUIPBRACELET";
  LINE_PRICE[LINE_PRICE["EQUIPBUTTON"] = 95] = "EQUIPBUTTON";
  LINE_PRICE[LINE_PRICE["EQUIPSCREEN"] = 190] = "EQUIPSCREEN";
  LINE_PRICE[LINE_PRICE["EQUIPCABLE"] = 10] = "EQUIPCABLE";
  LINE_PRICE[LINE_PRICE["EQUIPTRANSFO"] = 10] = "EQUIPTRANSFO";
  LINE_PRICE[LINE_PRICE["EQUIPOVERSHELL"] = 30] = "EQUIPOVERSHELL";
  LINE_PRICE[LINE_PRICE["DEPWATCH"] = 190] = "DEPWATCH";
  LINE_PRICE[LINE_PRICE["DEPREPEATER"] = 100] = "DEPREPEATER";
  LINE_PRICE[LINE_PRICE["DEPANTENNA"] = 900] = "DEPANTENNA";
  LINE_PRICE[LINE_PRICE["SERVICETELECARE"] = 10] = "SERVICETELECARE";
  LINE_PRICE[LINE_PRICE["FEE"] = 79] = "FEE";
  return LINE_PRICE;
}(LINE_PRICE || {});
var BILLING_METHOD = /*#__PURE__*/function (BILLING_METHOD) {
  BILLING_METHOD["CREDIT_CARD"] = "CREDIT_CARD";
  BILLING_METHOD["SEPA_DIRECT"] = "SEPA_DIRECT";
  BILLING_METHOD["CHEQUE"] = "CHEQUE";
  BILLING_METHOD["TRANSFER"] = "TRANSFER";
  return BILLING_METHOD;
}(BILLING_METHOD || {});
;
var CURRENCY = /*#__PURE__*/function (CURRENCY) {
  CURRENCY["EUR"] = "EUR";
  CURRENCY["CHF"] = "CHF";
  return CURRENCY;
}(CURRENCY || {});
var CURRENCY_SYMBOL = /*#__PURE__*/function (CURRENCY_SYMBOL) {
  CURRENCY_SYMBOL["EUR"] = "\u20AC";
  CURRENCY_SYMBOL["CHF"] = "CHF";
  return CURRENCY_SYMBOL;
}(CURRENCY_SYMBOL || {});
var SUBSCRIPTION = /*#__PURE__*/function (SUBSCRIPTION) {
  SUBSCRIPTION["economy"] = "economy";
  SUBSCRIPTION["liberty"] = "liberty";
  return SUBSCRIPTION;
}(SUBSCRIPTION || {});
const DEFAULT_TAX_RATE = 0.2;
const START_YEAR = 2019;
const START_MONTH = 12;
var invoice_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get TEMPLATE() {
    return TEMPLATE$1;
  },
  get TYPE() {
    return TYPE;
  },
  get PREFIX() {
    return PREFIX;
  },
  get LINE_CODE() {
    return LINE_CODE;
  },
  get LINE_i18n() {
    return LINE_i18n;
  },
  get LINE_PRICE() {
    return LINE_PRICE;
  },
  get BILLING_METHOD() {
    return BILLING_METHOD;
  },
  get CURRENCY() {
    return CURRENCY;
  },
  get CURRENCY_SYMBOL() {
    return CURRENCY_SYMBOL;
  },
  get SUBSCRIPTION() {
    return SUBSCRIPTION;
  },
  DEFAULT_TAX_RATE: DEFAULT_TAX_RATE,
  START_YEAR: START_YEAR,
  START_MONTH: START_MONTH
});
var TEMPLATE = /*#__PURE__*/function (TEMPLATE) {
  TEMPLATE["HTML"] = "contract-pdf.template.pug";
  TEMPLATE["CSS"] = "contract-pdf.css";
  return TEMPLATE;
}(TEMPLATE || {});
var Contract$1 = /*#__PURE__*/function (Contract) {
  Contract["NONE"] = "";
  Contract["ONECLICK"] = "ONECLICK";
  Contract["RECURRING"] = "RECURRING";
  return Contract;
}(Contract$1 || {});
var contract_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get TEMPLATE() {
    return TEMPLATE;
  },
  get Contract() {
    return Contract$1;
  }
});
const type$3 = 'discount';
var Applicability = /*#__PURE__*/function (Applicability) {
  Applicability["WATCH"] = "WATCH";
  Applicability["ALL"] = "ALL";
  Applicability["SERVICE"] = "SERVICE";
  Applicability["OPTION"] = "OPTION";
  Applicability["SHIPPING"] = "SHIPPING";
  Applicability["NONE"] = "NONE";
  return Applicability;
}(Applicability || {});
var Periodicity = /*#__PURE__*/function (Periodicity) {
  Periodicity["ONCE"] = "ONCE";
  Periodicity["RECURRENT"] = "RECURRENT";
  return Periodicity;
}(Periodicity || {});
var DiscountType = /*#__PURE__*/function (DiscountType) {
  DiscountType["EUR"] = "EUR";
  DiscountType["PERCENT"] = "%";
  return DiscountType;
}(DiscountType || {});
var discount_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  type: type$3,
  get Applicability() {
    return Applicability;
  },
  get Periodicity() {
    return Periodicity;
  },
  get DiscountType() {
    return DiscountType;
  }
});
const type$2 = 'option';
var OptionType = /*#__PURE__*/function (OptionType) {
  OptionType["PURCHASE"] = "purchase";
  OptionType["RENTING"] = "renting";
  return OptionType;
}(OptionType || {});
var OptionEquipment = /*#__PURE__*/function (OptionEquipment) {
  OptionEquipment["REPEATER"] = "repeater";
  OptionEquipment["ANTENNA"] = "antenna";
  OptionEquipment["FEE"] = "fee";
  OptionEquipment["SERVICE"] = "service";
  return OptionEquipment;
}(OptionEquipment || {});
var option_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  type: type$2,
  get OptionType() {
    return OptionType;
  },
  get OptionEquipment() {
    return OptionEquipment;
  }
});
const DAY_IN_MIN = 1440;
const DAY_IN_MS = 86400000;
const NOW = new Date().getTime();
/**
 * Return today's date at midnight
 */
function getCurrentDate() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}
/**
 * Return a date in US format
 * @param date date to format; default will be today
 * @returns in this format: mm/dd/yyyy
 */
function getFormattedDate(date = new Date()) {
  const pad = n => n.toString().padStart(2, '0');
  return pad(date.getMonth() + 1) + '/' + pad(date.getDate()) + '/' + date.getFullYear();
}
/**
 * Return the offset in minutes of the passed TimeZone
 * @param timeZone like Europe/Paris, America/New_York (https://en.wikipedia.org/wiki/List_of_tz_database_time_zones)
 * @param date Date format
 * @returns the {timeZone} offset in minutes
 */
function getTimezoneOffset(timeZone, date) {
  const d = date || new Date();
  d.setMilliseconds(0); // for nice rounding
  const localOffset = d.getTimezoneOffset() / 60 * -1;
  const tzOffset = d.toLocaleString('en-US', {
    timeZone
  });
  const tzDate = new Date(tzOffset);
  const diffHrs = (tzDate.getTime() - d.getTime()) / 1000 / 60 / 60;
  const tzOffsetInHours = localOffset + diffHrs;
  return tzOffsetInHours * 60;
}
/**
 * Return true if the given date match the format 'YYYY-MM'
 * @param date must only match this format : YYYY-MM
 * @returns boolean
 */
function isValidShortCalendarDateFormat(date) {
  return typeof date === 'string' && yearMonthRegex.test(date);
}
/**
 * Return true if the given date match the format 'YYYY-MM-DD'
 * @param date must only match this format : 'YYYY-MM-DD'
 * @returns boolean
 */
function isValidFullCalendarDateFormat(date) {
  return typeof date === 'string' && yearMonthDayRegex.test(date);
}
/**
 * @param from timestamp
 * @param to timestamp
 * @returns for each covered year, the rate of days covered, the number of days covered
 */
function getProrata(from, to) {
  const result = [];
  const yearsResumes = splitByYear(from, to);
  for (let yearResume of yearsResumes) {
    result.push({
      year: yearResume.year,
      rate: getRateOnTheYear(yearResume.from, yearResume.to),
      numberOfDays: getNumberOfDaysBetweenInterval(yearResume.from, yearResume.to)
    });
  }
  return result;
}
/**
 * Get the rate of days covered on the given period
 * @param from timestamp
 * @param to timestamp
 * @returns a numeric value rounded after two decimals
 */
function getRateOnTheYear(from, to) {
  const numberOfDays = getNumberOfDaysInTheYear(new Date(from).getFullYear());
  return roundDecimalPart(getNumberOfDaysBetweenInterval(from, to) / numberOfDays, 4);
}
/**
 * Get the number of days on the given period
 * @param from timestamp
 * @param to timestamp
 * @returns an integer rounded
 */
function getNumberOfDaysBetweenInterval(from, to) {
  return roundDecimalPart((to - from) / DAY_IN_MS) + 1;
}
/**
 * Split by year the given period in order to get for each year distinct start/end by year
 * @param from timestamp
 * @param to timestamp
 * @returns the distribution per year of the given period
 */
function splitByYear(from, to) {
  const coveredYears = new Date(to).getFullYear() - new Date(from).getFullYear() + 1;
  const startingYear = new Date(from).getFullYear();
  const result = [];
  for (let i = 0; i < coveredYears; i++) {
    const endOfThisYear = new Date(startingYear + i, 11, 31);
    const _from = i === 0 ? from : new Date(startingYear + i, 0, 1).getTime();
    const _to = to > endOfThisYear.getTime() ? endOfThisYear.getTime() : to;
    result.push({
      year: startingYear + i,
      to: _to,
      from: _from
    });
  }
  return result;
}
/**
 * Return the number of year of the given year
 */
function getNumberOfDaysInTheYear(year) {
  return (new Date(year, 11, 31).getTime() - new Date(year, 0, 1).getTime()) / 86400000 + 1;
}
/**
 * Returns a supplied numeric expression rounded to the nearest number
 * @param val number
 * @param numberOfDecimal (optionnal) number
 * @returns a number
 */
function roundDecimalPart(val, numberOfDecimal = 0) {
  const pow = Math.pow(10, numberOfDecimal);
  return Math.round(val * pow) / pow;
}
const yearMonthRegex = new RegExp('^[0-9]{4}[-](1[0-2]|0[1-9])$');
const yearMonthDayRegex = new RegExp('^[0-9]{4}[-](1[0-2]|0[1-9])[-](3[0-1]|2[0-9]|1[0-9]|0[1-9])$');
var time_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DAY_IN_MIN: DAY_IN_MIN,
  DAY_IN_MS: DAY_IN_MS,
  NOW: NOW,
  getCurrentDate: getCurrentDate,
  getFormattedDate: getFormattedDate,
  getTimezoneOffset: getTimezoneOffset,
  isValidShortCalendarDateFormat: isValidShortCalendarDateFormat,
  isValidFullCalendarDateFormat: isValidFullCalendarDateFormat,
  getProrata: getProrata,
  getRateOnTheYear: getRateOnTheYear,
  getNumberOfDaysBetweenInterval: getNumberOfDaysBetweenInterval,
  splitByYear: splitByYear,
  getNumberOfDaysInTheYear: getNumberOfDaysInTheYear,
  roundDecimalPart: roundDecimalPart
});
const type$1 = 'subscription';
var Coverage = /*#__PURE__*/function (Coverage) {
  Coverage["UNKNOWN"] = "UNKNOWN";
  Coverage["OK"] = "OK";
  Coverage["WEAK"] = "WEAK";
  Coverage["UNSUFFICIENT"] = "UNSUFFICIENT";
  Coverage["KO"] = "KO";
  return Coverage;
}(Coverage || {});
var subscription_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  type: type$1,
  get Coverage() {
    return Coverage;
  }
});
var PaymentMethod = /*#__PURE__*/function (PaymentMethod) {
  PaymentMethod["CARD"] = "CREDIT_CARD";
  PaymentMethod["SEPA"] = "SEPA_DIRECT";
  PaymentMethod["TOKEN"] = "TOKEN";
  PaymentMethod["MANDATE"] = "MANDATE";
  PaymentMethod["NONE"] = "NONE";
  return PaymentMethod;
}(PaymentMethod || {});
var payment_conts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get PaymentMethod() {
    return PaymentMethod;
  }
});
var ConvertMethodsNames = /*#__PURE__*/function (ConvertMethodsNames) {
  ConvertMethodsNames["stringify"] = "stringify";
  ConvertMethodsNames["htmlToPdf"] = "htmlToPdf";
  return ConvertMethodsNames;
}(ConvertMethodsNames || {});
var AutoCompletionType = /*#__PURE__*/function (AutoCompletionType) {
  AutoCompletionType["USER"] = "userList";
  AutoCompletionType["GROUP"] = "groupList";
  return AutoCompletionType;
}(AutoCompletionType || {});
var ItemImageManagementActions = /*#__PURE__*/function (ItemImageManagementActions) {
  ItemImageManagementActions["ADD"] = "ADD";
  ItemImageManagementActions["DELETE"] = "DELETE";
  ItemImageManagementActions["UPDATE"] = "UPDATE";
  ItemImageManagementActions["GET_BUCKET"] = "GET_BUCKET";
  return ItemImageManagementActions;
}(ItemImageManagementActions || {});
var file_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get ConvertMethodsNames() {
    return ConvertMethodsNames;
  },
  get AutoCompletionType() {
    return AutoCompletionType;
  },
  get ItemImageManagementActions() {
    return ItemImageManagementActions;
  }
});
var validationMethodTypes = /*#__PURE__*/function (validationMethodTypes) {
  validationMethodTypes["EMAIL"] = "Email";
  validationMethodTypes["CALL"] = "Call";
  validationMethodTypes["SMS"] = "SMS";
  return validationMethodTypes;
}(validationMethodTypes || {});
var authenticationRegistration_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get validationMethodTypes() {
    return validationMethodTypes;
  }
});
var Operations = /*#__PURE__*/function (Operations) {
  Operations["createSubscriber"] = "createSubscriber";
  Operations["updateSubscriber"] = "updateSubscriber";
  Operations["deleteSubscriber"] = "deleteSubscriber";
  Operations["createContact"] = "createContact";
  Operations["updateContact"] = "updateContact";
  Operations["deleteContact"] = "deleteContact";
  Operations["linkContactToSubscriber"] = "linkContactToSubscriber";
  Operations["updateLinkContactToSubscriber"] = "updateLinkContactToSubscriber";
  Operations["unlinkContactFromSubscriber"] = "unlinkContactFromSubscriber";
  Operations["getContactsIds"] = "getContactsIds";
  Operations["createModule"] = "createModule";
  Operations["linkModule"] = "linkModule";
  Operations["unlinkModule"] = "unlinkModule";
  Operations["addService"] = "addService";
  return Operations;
}(Operations || {});
;
var bluelinea_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get Operations() {
    return Operations;
  }
});
var StockTransferType = /*#__PURE__*/function (StockTransferType) {
  StockTransferType["DELIVERY"] = "BL";
  StockTransferType["RECEIPT"] = "BR";
  StockTransferType["PRODUCTION_ASSEMBLY"] = "BPA";
  StockTransferType["PRODUCTION_DISASSEMBLY"] = "BPD";
  return StockTransferType;
}(StockTransferType || {});
var DialogOption = /*#__PURE__*/function (DialogOption) {
  DialogOption["WATCHBAND_SIZE"] = "WATCHBAND_SIZE";
  return DialogOption;
}(DialogOption || {});
var StockOptions = /*#__PURE__*/function (StockOptions) {
  StockOptions["REPLENISHMENT"] = "REPLENISHMENT";
  StockOptions["END_OF_SERIES"] = "END_OF_SERIES";
  return StockOptions;
}(StockOptions || {});
var StockTransferCategories = /*#__PURE__*/function (StockTransferCategories) {
  StockTransferCategories["SAV"] = "SAV";
  StockTransferCategories["PRODUCTION"] = "PRODUCTION";
  StockTransferCategories["STOCK_ADJUSTMENT"] = "STOCK_ADJUSTMENT";
  StockTransferCategories["B2B"] = "B2B";
  StockTransferCategories["B2C"] = "B2C";
  StockTransferCategories["PURCHASE"] = "PURCHASE";
  return StockTransferCategories;
}(StockTransferCategories || {});
var stock_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get StockTransferType() {
    return StockTransferType;
  },
  get DialogOption() {
    return DialogOption;
  },
  get StockOptions() {
    return StockOptions;
  },
  get StockTransferCategories() {
    return StockTransferCategories;
  }
});
var CrudOperation = /*#__PURE__*/function (CrudOperation) {
  CrudOperation["create"] = "create";
  CrudOperation["read"] = "read";
  CrudOperation["update"] = "update";
  CrudOperation["delete"] = "delete";
  return CrudOperation;
}(CrudOperation || {});
var db_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get CrudOperation() {
    return CrudOperation;
  }
});
var GeolocationAlgorithm = /*#__PURE__*/function (GeolocationAlgorithm) {
  GeolocationAlgorithm["BaseStationRssi"] = "BaseStationRssi";
  GeolocationAlgorithm["BeaconScanSimple"] = "BeaconScanSimple";
  GeolocationAlgorithm["BeaconScanML"] = "BeaconScanML";
  return GeolocationAlgorithm;
}(GeolocationAlgorithm || {});
var geolocation_const = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get GeolocationAlgorithm() {
    return GeolocationAlgorithm;
  }
});

/*** DATATYPE ***/
const GENERAL_DATA_TYPE = 'general';
const MESSAGE_DATA_TYPE = 'messageUser';
const POSITION_DATA_TYPE = 'position';
const TEMPERATURE_DATA_TYPE = 'temperature';
const ALERT_DATA_TYPE = 'alert';
const HANDLE_ALERT_DATA_TYPE = 'handleAlert';
const CLOSE_ALERT_DATA_TYPE = 'closeAlert';
const INTERRUPTED_ALERT_DATA_TYPE = 'interruptAlert';
const ACQUITTED_ALERT_DATA_TYPE = 'acquitAlert';
const REPORT_DATA_TYPE = 'report';
const ACTIVITY_REPORT_DATA_TYPE = 'activityReport';
var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  GENERAL_DATA_TYPE: GENERAL_DATA_TYPE,
  MESSAGE_DATA_TYPE: MESSAGE_DATA_TYPE,
  POSITION_DATA_TYPE: POSITION_DATA_TYPE,
  TEMPERATURE_DATA_TYPE: TEMPERATURE_DATA_TYPE,
  ALERT_DATA_TYPE: ALERT_DATA_TYPE,
  HANDLE_ALERT_DATA_TYPE: HANDLE_ALERT_DATA_TYPE,
  CLOSE_ALERT_DATA_TYPE: CLOSE_ALERT_DATA_TYPE,
  INTERRUPTED_ALERT_DATA_TYPE: INTERRUPTED_ALERT_DATA_TYPE,
  ACQUITTED_ALERT_DATA_TYPE: ACQUITTED_ALERT_DATA_TYPE,
  REPORT_DATA_TYPE: REPORT_DATA_TYPE,
  ACTIVITY_REPORT_DATA_TYPE: ACTIVITY_REPORT_DATA_TYPE,
  Access: access_const,
  ActionSet: actionSet_const,
  Admin: admin_const,
  Alert: alert_const,
  Error: error_const,
  GpsPosition: gpsPositionConst,
  Mask: maskConst,
  Module: index$3,
  Option: option_const,
  Report: reportConst,
  Pull: pullConst,
  Invoice: invoice_const,
  Entity: entity_const,
  Contract: contract_const,
  Discount: discount_const,
  Subscription: subscription_const,
  Time: time_const,
  Payment: payment_conts,
  File: file_const,
  AuthenticationRegistration: authenticationRegistration_const,
  Bluelinea: bluelinea_const,
  Stock: stock_const,
  DB: db_const,
  Geolocation: geolocation_const
});
;
;
;
;
var EV07BButton = /*#__PURE__*/function (EV07BButton) {
  EV07BButton[EV07BButton["SOSButton"] = 0] = "SOSButton";
  EV07BButton[EV07BButton["call1Button"] = 1] = "call1Button";
  return EV07BButton;
}(EV07BButton || {});
var EV07BButtonMode = /*#__PURE__*/function (EV07BButtonMode) {
  EV07BButtonMode[EV07BButtonMode["longPress"] = 0] = "longPress";
  EV07BButtonMode[EV07BButtonMode["doubleClick"] = 1] = "doubleClick";
  return EV07BButtonMode;
}(EV07BButtonMode || {});
var EV07BButtonFeedback = /*#__PURE__*/function (EV07BButtonFeedback) {
  EV07BButtonFeedback[EV07BButtonFeedback["noFeedback"] = 0] = "noFeedback";
  EV07BButtonFeedback[EV07BButtonFeedback["vibrate"] = 1] = "vibrate";
  EV07BButtonFeedback[EV07BButtonFeedback["voice"] = 2] = "voice";
  EV07BButtonFeedback[EV07BButtonFeedback["vibrateAndVoice"] = 3] = "vibrateAndVoice";
  return EV07BButtonFeedback;
}(EV07BButtonFeedback || {});
var RemoteAccessActions = /*#__PURE__*/function (RemoteAccessActions) {
  RemoteAccessActions[RemoteAccessActions["getGatewayConnectivity"] = 0] = "getGatewayConnectivity";
  RemoteAccessActions[RemoteAccessActions["getWireguardClientIP"] = 1] = "getWireguardClientIP";
  RemoteAccessActions[RemoteAccessActions["rebootGateway"] = 2] = "rebootGateway";
  RemoteAccessActions[RemoteAccessActions["addWireguardClient"] = 3] = "addWireguardClient";
  return RemoteAccessActions;
}(RemoteAccessActions || {});
var MeasurementType = /*#__PURE__*/function (MeasurementType) {
  MeasurementType["waterLog"] = "waterLog";
  return MeasurementType;
}(MeasurementType || {});
var Granularity = /*#__PURE__*/function (Granularity) {
  Granularity[Granularity["daily"] = 0] = "daily";
  Granularity[Granularity["monthly"] = 1] = "monthly";
  Granularity[Granularity["limits"] = 2] = "limits";
  return Granularity;
}(Granularity || {});
var module = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get EV07BButton() {
    return EV07BButton;
  },
  get EV07BButtonMode() {
    return EV07BButtonMode;
  },
  get EV07BButtonFeedback() {
    return EV07BButtonFeedback;
  },
  get RemoteAccessActions() {
    return RemoteAccessActions;
  },
  get MeasurementType() {
    return MeasurementType;
  },
  get Granularity() {
    return Granularity;
  }
});
var payment = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var user = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var file = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var alert = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var ActionOnEndpoint = /*#__PURE__*/function (ActionOnEndpoint) {
  ActionOnEndpoint[ActionOnEndpoint["attachEndpointToUser"] = 0] = "attachEndpointToUser";
  ActionOnEndpoint[ActionOnEndpoint["detachEndpointFromUser"] = 1] = "detachEndpointFromUser";
  ActionOnEndpoint[ActionOnEndpoint["flagEndpointAsDisabled"] = 2] = "flagEndpointAsDisabled";
  ActionOnEndpoint[ActionOnEndpoint["sendNotificationToEndpoint"] = 3] = "sendNotificationToEndpoint";
  return ActionOnEndpoint;
}(ActionOnEndpoint || {});
var DetachEndpoint = /*#__PURE__*/function (DetachEndpoint) {
  DetachEndpoint[DetachEndpoint["logout"] = 0] = "logout";
  DetachEndpoint[DetachEndpoint["renewToken"] = 1] = "renewToken";
  return DetachEndpoint;
}(DetachEndpoint || {});
var NotificationUnregisterEnum = /*#__PURE__*/function (NotificationUnregisterEnum) {
  NotificationUnregisterEnum["EndpointDisabled"] = "EndpointDisabled";
  NotificationUnregisterEnum["EndpointDoesNotExist"] = "EndpointDoesNotExist";
  return NotificationUnregisterEnum;
}(NotificationUnregisterEnum || {});
var ManageLoginIDEAction = /*#__PURE__*/function (ManageLoginIDEAction) {
  ManageLoginIDEAction[ManageLoginIDEAction["update"] = 0] = "update";
  ManageLoginIDEAction[ManageLoginIDEAction["get"] = 1] = "get";
  return ManageLoginIDEAction;
}(ManageLoginIDEAction || {});
var authenticationRegistration = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get ActionOnEndpoint() {
    return ActionOnEndpoint;
  },
  get DetachEndpoint() {
    return DetachEndpoint;
  },
  get NotificationUnregisterEnum() {
    return NotificationUnregisterEnum;
  },
  get ManageLoginIDEAction() {
    return ManageLoginIDEAction;
  }
});
var administration$1 = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Module: module,
  User: user,
  Payment: payment,
  File: file,
  Alert: alert,
  AuthenticationRegistration: authenticationRegistration,
  Administration: administration$1
});
const NUMBER_OF_BIN_IN_HEXA = 4;
function ConvertBase(num) {
  return {
    from: function (baseFrom) {
      return {
        to: function (baseTo) {
          return parseInt(num, baseFrom).toString(baseTo);
        }
      };
    }
  };
}
;
// binary to decimal
function bin2dec(num) {
  return ConvertBase(num).from(2).to(10);
}
;
// binary to hexadecimal
function bin2hex(num) {
  let bitsNumber = num.length;
  let hex = "";
  let bin = "";
  // Convert step by step in order to avoid overflow
  for (var i = bitsNumber; i > 0; i -= 4) {
    var min = i - 4;
    if (i - 4 < 0) {
      min = 0;
    }
    bin = num.slice(min, i);
    bin = reformatHexa(bin);
    hex = ConvertBase(bin).from(2).to(16) + hex;
  }
  return hex;
}
;
// decimal to binary
// only works with positive numbers
function dec2bin(num) {
  if (parseInt(num, 10) < 0) return "ERROR : impossible to deal with negatif numbers";
  return ConvertBase(num).from(10).to(2);
}
;
// decimal to hexadecimal
function dec2hex(num) {
  return ConvertBase(num).from(10).to(16);
}
;
// hexadecimal to binary
function hex2bin(num) {
  let binary = "";
  let temp = "";
  // Convert step by step in order to avoid overflow
  for (var i = 0; i < num.length; i++) {
    temp = ConvertBase(num[i]).from(16).to(2);
    binary += reformatHexa(temp);
  }
  return binary;
}
;
// hexadecimal to decimal
function hex2dec(num) {
  return Number.parseInt(ConvertBase(num).from(16).to(10), 10);
}
;
/*
 * Usage example:
 * ConvertBase.bin2dec('111'); // '7'
 * ConvertBase.dec2hex('42'); // '2a'
 * ConvertBase.hex2bin('f8'); // '11111000'
 * ConvertBase.dec2bin('22'); // '10110'
 */
/**
 * Add the 0 deleted during the convertion.
 *
 * @param string illFormatedBinMessage binary with potential lacking 0.
 * @returns any
 */
function reformatHexa(illFormatedBinMessage) {
  let numberOfLackingZeros = NUMBER_OF_BIN_IN_HEXA - illFormatedBinMessage.length;
  if (numberOfLackingZeros > 0) {
    return '0'.repeat(numberOfLackingZeros) + illFormatedBinMessage;
  } else {
    return illFormatedBinMessage;
  }
}
;
function reformatBin(bin, binLength) {
  const lackingZeros = binLength - bin.length;
  if (lackingZeros > 0) {
    return '0'.repeat(lackingZeros) + bin;
  } else if (lackingZeros < 0) {
    return bin.slice(0, binLength);
  } else {
    return bin;
  }
}
;
/**
 * Formatting according to the length.
 *
 * @param bin binary message.
 * @param binLength wished length.
 * @return
 */
function reformatBinPosition(bin, binLength) {
  if (bin.length < 32) {
    const lackingZeros = 32 - bin.length;
    bin = '0'.repeat(lackingZeros) + bin;
  }
  return bin.slice(0, binLength);
}
;
/**
 * Formatting according to the length ("add 1 on left if needed").
 *
 * @param bin binary message.
 * @param binLength wished length.
 * @return any
 */
function reformatBinNegativePosition(bin, binLength) {
  if (bin.length < 32) {
    const lackingZeros = 32 - bin.length;
    bin = '1'.repeat(lackingZeros) + bin;
  }
  return bin.slice(0, binLength);
}
;
/**
 * Convert an hexa into a signed int (16 bits).
 * @param hex hexadecimal
 * @return
 */
function hexToSignedInt(hex) {
  if (hex.length % 2 != 0) {
    hex = '0' + hex;
  }
  let num = parseInt(hex, 16);
  let maxVal = Math.pow(2, hex.length / 2 * 8);
  if (num > maxVal / 2 - 1) {
    num = num - maxVal;
  }
  return num;
}
;
/**
 * Convert an integer into a binary signed and formated
 * (dec2FormatSignedBin // reformatBinNegativePosition)
 * Used for position parsing (OBSOLETE).
 * @param dec
 * @param binLength
 * @return binary
 */
function dec2FormatSignedBin(dec, binLength) {
  if (dec >= 0) {
    return reformatBinPosition(dec2bin(dec.toString(10)), binLength);
  } else {
    var binaryUnsigned = dec2bin(Math.abs(dec).toString(10));
    var binaryUnsignedFormater = calibrateBin(binaryUnsigned); // adjust length%4 = 0
    var binaryInverse = reverseBin(binaryUnsignedFormater);
    var numCompletementaire = bin2dec(binaryInverse);
    var numSigned = parseInt(numCompletementaire) + 1;
    var binarySigned = calibrateBin(dec2bin(numSigned.toString(10))); // convert into binaire and adjust length%4 =0
    return reformatBinNegativePosition(binarySigned, binLength);
  }
}
;
/**
 * Convert a signed int into a 2's complement signed binary.
 *
 * @param int dec to convert : could be negatif
 * @param int bin length of the expected binary
 * @return binary OR Error
 */
function dec2SignedBin(dec, binLength) {
  if (binLength < 2) return "ERROR : binLength should at least be of two bits";
  if (dec >= 0) {
    let rawBin = dec.toString(2);
    if (rawBin.length == binLength) return rawBin;else if (rawBin.length > binLength) return "ERROR : binLength expected below the raw convert from dec2bin";else if (rawBin.length < binLength) {
      let lackingZeros = binLength - rawBin.length;
      let posBin = '0'.repeat(lackingZeros) + rawBin;
      return posBin;
    } else return "ERROR : impossible to compare rawBin.length & binLength";
  } else {
    let binaryUnsigned = dec2bin(Math.abs(dec).toString(10));
    let binaryInverse = reverseBin(binaryUnsigned);
    let numCompletementaire = bin2dec(binaryInverse);
    let numSigned = parseInt(numCompletementaire) + 1;
    let rawBin = numSigned.toString(2);
    let lackingZeros = binaryUnsigned.length - rawBin.length; // back to the initial state
    rawBin = '0'.repeat(lackingZeros) + rawBin;
    if (rawBin.length >= binLength) return 'ERROR : binLength expected below the raw convert from dec2bin';else if (rawBin.length < binLength) {
      let lackingOne = binLength - rawBin.length;
      let complBin = "1".repeat(lackingOne) + rawBin;
      return complBin;
    } else return 'ERROR : impossible to compare rawBin.length & binLength';
  }
}
;
/**
 * Reverse 1 and 0 into a string.
 *
 * @param bin
 * @returns string|XML|void|*
 */
function reverseBin(bin) {
  var all_0 = /0/gi;
  var all_1 = /1/gi;
  var all_2 = /2/gi;
  var binReverse = bin.replace(all_1, '2');
  binReverse = binReverse.replace(all_0, '1');
  binReverse = binReverse.replace(all_2, '0');
  return binReverse;
}
;
/**
 * Format a binary number in order to have a length multiple of 4.
 *
 * @param bin
 * @returns *
 */
function calibrateBin(bin) {
  while (bin.length % 4 != 0) {
    bin = '0'.repeat(1) + bin;
  }
  return bin;
}
;
/**
 * Apply a, Exclusive OR between to Hexa, in string, of the same length. Return an hexa.
 * @param hexa1
 * @param hexa2
 * @returns *
 */
function XORhexa(hexa1, hexa2) {
  if (hexa1.length != hexa2.length) {
    throw new Error("hexa1 et hexa2 different length " + hexa1 + ", " + hexa2);
  }
  let bin1 = hex2bin(hexa1);
  bin1 = calibrateBin(bin1);
  let bin2 = hex2bin(hexa2);
  bin2 = calibrateBin(bin2);
  let XORinBin = "";
  for (let i = 0; i < bin1.length; i++) {
    if (bin1[i] != bin2[i]) {
      XORinBin = XORinBin + "1";
    } else {
      XORinBin = XORinBin + "0";
    }
  }
  return bin2hex(XORinBin);
}
;
var baseConverter = /*#__PURE__*/Object.freeze({
  __proto__: null,
  NUMBER_OF_BIN_IN_HEXA: NUMBER_OF_BIN_IN_HEXA,
  ConvertBase: ConvertBase,
  bin2dec: bin2dec,
  bin2hex: bin2hex,
  dec2bin: dec2bin,
  dec2hex: dec2hex,
  hex2bin: hex2bin,
  hex2dec: hex2dec,
  reformatHexa: reformatHexa,
  reformatBin: reformatBin,
  reformatBinPosition: reformatBinPosition,
  reformatBinNegativePosition: reformatBinNegativePosition,
  hexToSignedInt: hexToSignedInt,
  dec2FormatSignedBin: dec2FormatSignedBin,
  dec2SignedBin: dec2SignedBin,
  reverseBin: reverseBin,
  calibrateBin: calibrateBin,
  XORhexa: XORhexa
});
const userIDRegex = new RegExp('^[A-Za-z0-9.+\-]+$');
const groupIDRegex = new RegExp('^[a-z0-9_]+$');
const macAddressRegex = new RegExp('^([0-9A-F]{2}[:]){5}([0-9A-F]{2})$');
const imeiRegex = new RegExp('^[0-9]{15,17}$');
const sigfoxIDRegex = new RegExp('^[0-9A-F]{6,8}$');
const moduleIDRegex = new RegExp('^([0-9a-f]{8})$');
const loraDevEUIRegex = new RegExp('^([0-9a-f]{16})$');
const iccidRegex = new RegExp('^[0-9]{18,20}$');
const withingsDeviceIDRegex = new RegExp('^[a-f0-9]{40}$');
/**
 * Application d'un masque sur le binaire du message en paramètre
 * @param message : message sigfox en string d'héxadécimaux
 * @param offset : bit à partir du quel la lecture commence
 * @param length : nombre de bits à lire
 * @returns string|*|String
 */
function applyMask(message, offset, length) {
  // Convert in binary
  var binMessage = hex2bin(message);
  // Apply mask
  var binData = binMessage.slice(offset, offset + length);
  // Convert in hex
  var hexData = bin2hex(binData).toString();
  return hexData;
}
/**
 * Extraction des bits du messages qui correspondent au masque en paramètre.
 * Les masques se trouvent dans le fichier constants.js
 * @param message : string message sigfox en string d'héxadécimaux
 * @param mask : liste de deux nombre [0] offset -> bit à partir du quel la lecture commence,
 * [1] -> nombre de bits à lire
 * @return données en héxa extraites à l'aide du masque
 */
function extractDataFromMessage(message, mask) {
  if (mask[0] < 0 || mask[0] > message.length * NUMBER_OF_BIN_IN_HEXA || mask[1] <= 0 || mask[1] > message.length * NUMBER_OF_BIN_IN_HEXA) {
    return "";
  }
  return applyMask(message, mask[0], mask[1]);
}
/**
 * Extraction des informations d'un message et parsage en nombre
 * @param message : message sigfox en string d'héxadécimaux
 * @param mask : liste de deux nombre [0] offset -> bit à partir du quel la lecture commence,
 * [1] -> nombre de bits à lire
 */
function extractNumberFromMessage(message, mask) {
  var hexData = extractDataFromMessage(message, mask);
  return hex2dec(hexData);
}
function fromHexaToAscii(frame) {
  let str = '';
  for (var n = 0; n < frame.length; n += 2) {
    str += String.fromCharCode(parseInt(frame.slice(n, n + 2), 16));
  }
  return str;
}
var parser = /*#__PURE__*/Object.freeze({
  __proto__: null,
  userIDRegex: userIDRegex,
  groupIDRegex: groupIDRegex,
  macAddressRegex: macAddressRegex,
  imeiRegex: imeiRegex,
  sigfoxIDRegex: sigfoxIDRegex,
  moduleIDRegex: moduleIDRegex,
  loraDevEUIRegex: loraDevEUIRegex,
  iccidRegex: iccidRegex,
  withingsDeviceIDRegex: withingsDeviceIDRegex,
  applyMask: applyMask,
  extractDataFromMessage: extractDataFromMessage,
  extractNumberFromMessage: extractNumberFromMessage,
  fromHexaToAscii: fromHexaToAscii
});
class Decoder {
  toJSON() {
    let obj = {};
    for (const property in this) {
      obj[property] = this[property];
    }
    return obj;
  }
}
const RSSI_CONVERTION_OFFSET = 20;
const DL_SKIP_UPDATE_VALUE = 0xff;
class CALDecoder extends Decoder {
  constructor(message, deviceType) {
    super();
    this.protocolVersion = this.getProtocolVersion(message);
    this.softwareVersion = this.getSoftwareVersion(message);
    this.frameType = this.getFrameType(message);
    if (this.frameType === CAL.FrameType.REPORT) {
      this.hardwareVersion = this.getHardwareVersion(message);
      this.batteryLevel = this.getBatteryLevel(message, deviceType);
      this.rawBatteryLevel = this.getRawBatteryLevel(message);
      if (this.protocolVersion !== CAL_PROTOCOL_VERSIONS.ZERO) {
        this.firstIOStatus = this.getIOStatus(CAL.ReportProtocolFirstHexa.BTN1_STATUS, 0, message);
        this.rsStatus = this.getIOStatus(CAL.ReportProtocolFirstHexa.RS_STATUS, 4, message);
        this.secondIOStatus = this.getIOStatus(CAL.ReportProtocolFirstHexa.BTN2_STATUS, 4, message);
        this.firstIOHighCounter = this.getCounter(CAL.ReportProtocolFirstHexa.BTN1_COUNTER, message);
        this.secondIOHighCounter = this.getCounter(CAL.ReportProtocolFirstHexa.BTN2_COUNTER, message);
        this.reedSwitchCounter = this.getCounter(CAL.ReportProtocolFirstHexa.RS_COUNTER, message);
        this.adr = this.getAdr(message);
        this.operatingMod = this.getOperatingMod(message);
        if (this.protocolVersion != CAL_PROTOCOL_VERSIONS.ONE) {
          this.thirdIOHighCounter = this.getCounter(CAL.ReportProtocolFirstHexa.BTN3_COUNTER, message);
          this.thirdIOStatus = this.getIOStatus(CAL.ReportProtocolFirstHexa.BTN3_STATUS, 0, message);
          if (this.protocolVersion != CAL_PROTOCOL_VERSIONS.TWO && this.protocolVersion != CAL_PROTOCOL_VERSIONS.THREE) {
            this.beaconing = this.getBeaconingStatus(message);
            this.beaconStrength = extractNumberFromMessage(message, [CAL.ReportProtocolFirstHexa.BEACONING_STRENGTH * 8, 8]);
            this.beacScanning = this.getBeaconScanningSetting(message);
          }
        }
      } else {
        this.firstIOHighCounter = extractNumberFromMessage(message, [CAL.ProtocolFirstHexa.PROT_FIRST_HEXA_IO_1ST_HIGH_COUNTER * 8, 24]);
        this.reedSwitchCounter = extractNumberFromMessage(message, [CAL.ProtocolFirstHexa.PROT_FIRST_HEXA_REED_SWITCH_HIGH_COUNTER * 8, 24]);
        this.firstIOStatus = extractNumberFromMessage(message, [CAL.ProtocolFirstHexa.PROT_FIRST_HEXA_SENSORS_STATUS * 8 + 3, 1]) === 0 ? CAL.IOStatus.LOW : CAL.IOStatus.HIGH;
        this.rsStatus = extractNumberFromMessage(message, [CAL.ProtocolFirstHexa.PROT_FIRST_HEXA_SENSORS_STATUS * 8, 1]) === 0 ? CAL.IOStatus.HIGH : CAL.IOStatus.LOW;
      }
    }
    if (this.frameType === CAL.FrameType.ALERT) {
      this.alertAction = this.getAlertAction(message);
      this.alertSource = this.getAlertSource(message);
    }
    /* istanbul ignore if */
    if (this.frameType === CAL.FrameType.KEEP_ALIVE) {
      this.batteryLevel = this.getBatteryLevel(message, deviceType);
      this.rawBatteryLevel = this.getRawBatteryLevel(message);
    }
    if (this.frameType === CAL.FrameType.BEACON_POSITIONNING) {
      if (Object.values([CAL_PROTOCOL_VERSIONS.ZERO, CAL_PROTOCOL_VERSIONS.ONE, CAL_PROTOCOL_VERSIONS.TWO, CAL_PROTOCOL_VERSIONS.THREE]).includes(this.protocolVersion)) throw new Error(`Uncoherent protocol version for this frame type : ${this.protocolVersion}`);
      this.scannedBeacons = this.getScannedBeaconsItem(message);
    }
  }
  getProtocolVersion(message) {
    const protocolVersion = extractNumberFromMessage(message, [CAL.ProtocolFirstHexa.PROT_FIRST_HEXA_PROTOCOL_VERSION * 8, 8]);
    if (Object.values(CAL_PROTOCOL_VERSIONS).includes(protocolVersion)) {
      return protocolVersion;
    } else {
      throw new Error(`Unknown CAL protocol version : ${protocolVersion}`);
    }
  }
  getFrameType(message) {
    if (this.protocolVersion === CAL_PROTOCOL_VERSIONS.ZERO) return CAL.FrameType.REPORT;
    return extractNumberFromMessage(message, [CAL.BaseProtocolFirstHexa.FRAME_TYPE * 8, 8]);
  }
  getScannedBeaconsItem(message) {
    const moduleIDSize = 8;
    const headerSize = 8;
    const rssiSize = 2;
    const moduloSize = 1;
    const weightSize = 1;
    const beacSize = moduleIDSize + rssiSize + moduloSize + weightSize;
    const nbOfScan = (message.length - headerSize) / beacSize;
    const scannedBeacons = [];
    function convert(a) {
      let b = parseInt(a, 16);
      if ((b & 0x80) > 0) {
        b = b - 0x100;
      }
      return b;
    }
    for (let i = 0; i < nbOfScan; ++i) {
      const moduleID = message.slice(headerSize + beacSize * i, headerSize + beacSize * i + moduleIDSize);
      let rssi = convert(message.slice(headerSize + beacSize * i + moduleIDSize, headerSize + beacSize * i + moduleIDSize + rssiSize)) - RSSI_CONVERTION_OFFSET;
      const modulo = convert(message.slice(headerSize + beacSize * i + moduleIDSize + rssiSize, headerSize + beacSize * i + moduleIDSize + rssiSize + moduloSize));
      const samples = convert(message.slice(headerSize + beacSize * i + moduleIDSize + rssiSize + moduloSize, headerSize + beacSize * i + moduleIDSize + rssiSize + moduloSize + weightSize));
      rssi = rssi - modulo / samples;
      scannedBeacons.push({
        moduleID,
        rssi,
        samples
      });
    }
    return scannedBeacons;
  }
  getRawBatteryLevel(message) {
    let batteryVoltage;
    if (this.protocolVersion === CAL_PROTOCOL_VERSIONS.ZERO) {
      batteryVoltage = extractNumberFromMessage(message, [CAL.ProtocolFirstHexa.PROT_FIRST_HEXA_BATTERY_LVL_MV * 8, 16]);
    } else {
      batteryVoltage = extractNumberFromMessage(message, [CAL.ReportProtocolFirstHexa.BATTERY_LVL_MV * 8, 16]);
    }
    return batteryVoltage;
  }
  /**
   *
   * @param message
   * @param deviceType HardwareVersion should be used instead
   * @returns
   */
  getBatteryLevel(message, deviceType) {
    const batteryVoltage = this.getRawBatteryLevel(message);
    switch (deviceType) {
      case DeviceType.CALT:
      case DeviceType.CALP:
      case DeviceType.CALWB:
        return this.coinCellType(batteryVoltage);
      case DeviceType.CALDC:
      case DeviceType.CALDS:
      case DeviceType.CALSB:
      case DeviceType.CALBC:
        return this.cellAAAType(batteryVoltage);
      default:
        throw new Error(`Invalid deviceType : ${deviceType}`);
    }
  }
  cellAAAType(batteryVoltage) {
    if (batteryVoltage >= 2800) {
      return BatteryLevel.High;
    } else if (batteryVoltage >= 2300) {
      return BatteryLevel.Medium;
    } else if (batteryVoltage >= 2000) {
      return BatteryLevel.Low;
    } else {
      return BatteryLevel.Critical;
    }
  }
  coinCellType(batteryVoltage) {
    if (batteryVoltage >= 3300) {
      return BatteryLevel.Unknown;
    } else if (batteryVoltage >= 2800) {
      return BatteryLevel.High;
    } else if (batteryVoltage >= 2710) {
      return BatteryLevel.Medium;
    } else if (batteryVoltage >= 2690) {
      return BatteryLevel.Low;
    } else if (batteryVoltage >= 2500) {
      return BatteryLevel.Critical;
    } else {
      return BatteryLevel.Unknown;
    }
  }
  static isCALFrame(message) {
    const protocolVersion = extractNumberFromMessage(message, [CAL.ProtocolFirstHexa.PROT_FIRST_HEXA_PROTOCOL_VERSION * 8, 8]);
    if (protocolVersion === CAL_PROTOCOL_VERSIONS.ZERO) {
      return message.length === 28;
    } else {
      const expectedSize = extractNumberFromMessage(message, [CAL.BaseProtocolFirstHexa.SIZE_FRAME * 8, 8]);
      const calculatedSize = message.length / 2;
      return expectedSize === calculatedSize;
    }
  }
  getSoftwareVersion(message) {
    if (this.protocolVersion === CAL_PROTOCOL_VERSIONS.ZERO) {
      return CAL_SOFTWARE_VERSIONS.ZERO;
    }
    const softwareVersion = extractNumberFromMessage(message, [CAL.BaseProtocolFirstHexa.SOFTWARE_VERSION * 8, 8]);
    if (Object.values(CAL_SOFTWARE_VERSIONS).includes(softwareVersion.toString())) {
      return softwareVersion.toString();
    } else {
      throw new Error(`Unknown CAL software version : ${softwareVersion}`);
    }
  }
  getHardwareVersion(message) {
    if (this.protocolVersion === CAL_PROTOCOL_VERSIONS.ZERO) return;
    if (this.protocolVersion === CAL_PROTOCOL_VERSIONS.ONE || this.protocolVersion === CAL_PROTOCOL_VERSIONS.TWO) {
      return CAL_HARDWARE_VERSIONS.HW_VERS_CAL_1_1;
    }
    const hardwareVersion = extractNumberFromMessage(message, [CAL.BaseProtocolFirstHexa.HARDWARE_VERSION * 8, 8]);
    if (Object.values(CAL_HARDWARE_VERSIONS).includes(hardwareVersion)) {
      return hardwareVersion;
    } else {
      throw new Error(`Unknown CAL hardwareVersion version : ${hardwareVersion}`);
    }
  }
  getIOStatus(report, toAdd, message) {
    return extractNumberFromMessage(message, [report * 8 + toAdd, 4]) === 0 ? CAL.IOStatus.LOW : CAL.IOStatus.HIGH;
  }
  getCounter(report, message) {
    return extractNumberFromMessage(message, [report * 8, 16]);
  }
  getAdr(message) {
    return extractNumberFromMessage(message, [CAL.ReportProtocolFirstHexa.ADRPROFILE_OPERATINGMOD * 8, 4]);
  }
  getOperatingMod(message) {
    return extractNumberFromMessage(message, [CAL.ReportProtocolFirstHexa.ADRPROFILE_OPERATINGMOD * 8 + 4, 4]);
  }
  getBeaconScanningSetting(message) {
    return extractNumberFromMessage(message, [CAL.ReportProtocolFirstHexa.BEACSCANNING_BEACONING * 8, 4]);
  }
  getBeaconingStatus(message) {
    return !!extractNumberFromMessage(message, [CAL.ReportProtocolFirstHexa.BEACSCANNING_BEACONING * 8 + 4, 4]);
  }
  getAlertAction(message) {
    return extractNumberFromMessage(message, [CAL.AlertProtocolFirstHexa.ALERT_EVENT * 8, 4]);
  }
  getAlertSource(message) {
    return extractNumberFromMessage(message, [CAL.AlertProtocolFirstHexa.ALERT_SOURCE * 8 + 4, 4]);
  }
  static getConfiguration(deviceType) {
    switch (deviceType) {
      case DeviceType.CALDC:
      case DeviceType.CALDS:
        return {
          hw: CAL_HARDWARE_VERSIONS.HW_VERS_LDWS_2_2,
          adr: CAL.AdrProfile.SMTC_MODEM_ADR_PROFILE_NETWORK_CONTROLLED,
          mod: CAL.ModId.MOD_REPORT,
          beacScanning: CAL.BeaconScanning.INACTIVE,
          beaconing: false,
          beacStrength: 33
        };
      case DeviceType.CALP:
      case DeviceType.CALT:
        return {
          hw: CAL_HARDWARE_VERSIONS.HW_VERS_CAL_1_1,
          adr: CAL.AdrProfile.SMTC_MODEM_ADR_PROFILE_NETWORK_CONTROLLED,
          mod: CAL.ModId.MOD_DEFAULT,
          beacScanning: CAL.BeaconScanning.INACTIVE,
          beaconing: false,
          beacStrength: 33
        };
      case DeviceType.CALWB:
        return {
          hw: CAL_HARDWARE_VERSIONS.HW_VERS_CAL_1_1,
          adr: CAL.AdrProfile.SMTC_MODEM_ADR_PROFILE_MOBILE_LONG_RANGE,
          mod: CAL.ModId.MOD_DEFAULT,
          beacScanning: CAL.BeaconScanning.INACTIVE,
          beaconing: false,
          beacStrength: 33
        };
      case DeviceType.CALSB:
        return {
          hw: CAL_HARDWARE_VERSIONS.HW_VERS_LDWS_2_2,
          adr: CAL.AdrProfile.SMTC_MODEM_ADR_PROFILE_NETWORK_CONTROLLED,
          mod: CAL.ModId.MOD_DEFAULT,
          beacScanning: CAL.BeaconScanning.INACTIVE,
          beaconing: false,
          beacStrength: 33
        };
      case DeviceType.CALBC:
        return {
          hw: CAL_HARDWARE_VERSIONS.HW_VERS_CAL_1_1,
          adr: CAL.AdrProfile.SMTC_MODEM_ADR_PROFILE_NETWORK_CONTROLLED,
          mod: CAL.ModId.MOD_DEFAULT,
          beacScanning: CAL.BeaconScanning.INACTIVE,
          beaconing: true,
          beacStrength: 27
        };
      case DeviceType.CALAU:
      default:
        throw new Error(`Invalid DeviceType - 2 : ${deviceType}`);
    }
  }
  static matchSoftwareToProtocolVersion(softwareVersion) {
    switch (softwareVersion) {
      case CAL_SOFTWARE_VERSIONS.ZERO:
      case CAL_SOFTWARE_VERSIONS.ONE:
      case CAL_SOFTWARE_VERSIONS.TWO:
      case CAL_SOFTWARE_VERSIONS.THREE:
      case CAL_SOFTWARE_VERSIONS.FOUR:
        return CAL_PROTOCOL_VERSIONS.ONE;
      case CAL_SOFTWARE_VERSIONS.FIVE:
        return CAL_PROTOCOL_VERSIONS.TWO;
      case CAL_SOFTWARE_VERSIONS.SIX:
      case CAL_SOFTWARE_VERSIONS.SEVEN:
      case CAL_SOFTWARE_VERSIONS.EIGHT:
      case CAL_SOFTWARE_VERSIONS.NINE:
        return CAL_PROTOCOL_VERSIONS.THREE;
      case CAL_SOFTWARE_VERSIONS.TEN:
      default:
        return CAL_PROTOCOL_VERSIONS.FOUR;
    }
  }
  /**
   * Ask for beacon scanning is avalaible as of SW version 10 on any CAL device.
   * @param softwareVersion
   * @returns [SV, 0, 2, 4] BAACBA==
   */
  static buildDLAskForBeaconPositionMsg(softwareVersion) {
    const protocolVersion = this.matchSoftwareToProtocolVersion(softwareVersion);
    if (Object.values([CAL_PROTOCOL_VERSIONS.ZERO, CAL_PROTOCOL_VERSIONS.ONE, CAL_PROTOCOL_VERSIONS.TWO, CAL_PROTOCOL_VERSIONS.THREE]).includes(protocolVersion)) return;
    const msg = [0];
    msg[0] = protocolVersion; // Useless
    msg[1] = 0; // Unused -> available
    msg[2] = CAL.DLFrameType.ASK_FOR_BEACON_POSITIONNING;
    msg[3] = CAL.MessageSize.SIZE_DL_FRAME_ASK_FOR_BEACON_SCANNING;
    return msg;
  }
  /**
   * Ask device to reset is avalaible as of SW version 10 on any CAL device.
   * @param softwareVersion
   * @returns [SV, 0, 3, 4] BAADBA==
   */
  static buildDLAskForResetMsg(softwareVersion) {
    const protocolVersion = this.matchSoftwareToProtocolVersion(softwareVersion);
    if (Object.values([CAL_PROTOCOL_VERSIONS.ZERO, CAL_PROTOCOL_VERSIONS.ONE, CAL_PROTOCOL_VERSIONS.TWO, CAL_PROTOCOL_VERSIONS.THREE]).includes(protocolVersion)) return;
    const msg = [0];
    msg[0] = protocolVersion; // Useless
    msg[1] = 0; // Unused -> available
    msg[2] = CAL.DLFrameType.ASK_FOR_RESET;
    msg[3] = CAL.MessageSize.SIZE_DL_FRAME_ASK_FOR_RESET;
    return msg;
  }
  static isConfigurationCorrect(decoded, deviceType, configurationCustom) {
    var _a, _b, _c, _d, _e, _f;
    if (decoded.frameType !== CAL.FrameType.REPORT || decoded.protocolVersion === CAL_PROTOCOL_VERSIONS.ZERO) {
      return undefined;
    }
    const {
      mod,
      hw,
      adr,
      beacScanning: beacScanning,
      beaconing,
      beacStrength
    } = this.getConfiguration(deviceType);
    const targetedMod = (_a = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.mod) !== null && _a !== void 0 ? _a : mod;
    const targetedHW = (_b = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.hw) !== null && _b !== void 0 ? _b : hw;
    const targetedAdr = (_c = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.adr) !== null && _c !== void 0 ? _c : adr;
    if (decoded.hardwareVersion !== targetedHW || decoded.adr !== targetedAdr || decoded.operatingMod !== targetedMod) {
      return false;
    }
    if (decoded.protocolVersion > CAL_PROTOCOL_VERSIONS.THREE) {
      const targetedBeacPositioning = (_d = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.beacScanning) !== null && _d !== void 0 ? _d : beacScanning;
      const targetedBeaconing = (_e = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.beaconing) !== null && _e !== void 0 ? _e : beaconing;
      const targetedBeacStrength = (_f = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.beacStrength) !== null && _f !== void 0 ? _f : beacStrength;
      if (decoded.beacScanning !== targetedBeacPositioning || decoded.beaconing !== targetedBeaconing || decoded.beaconStrength !== targetedBeacStrength) {
        return false;
      }
    }
    return true;
  }
  static buildDLConfiguration(deviceType, softwareVersion, configurationCustom) {
    var _a, _b, _c, _d, _e, _f;
    const protocolVersion = this.matchSoftwareToProtocolVersion(softwareVersion);
    if (Object.values([CAL_PROTOCOL_VERSIONS.ZERO, CAL_PROTOCOL_VERSIONS.ONE, CAL_PROTOCOL_VERSIONS.TWO]).includes(protocolVersion)) return;
    const {
      mod,
      hw,
      adr,
      beacScanning,
      beaconing,
      beacStrength
    } = this.getConfiguration(deviceType);
    const newMod = (_a = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.mod) !== null && _a !== void 0 ? _a : mod;
    const newHW = (_b = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.hw) !== null && _b !== void 0 ? _b : hw;
    const newAdr = (_c = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.adr) !== null && _c !== void 0 ? _c : adr;
    const msg = [0];
    msg[0] = protocolVersion;
    msg[1] = 0; // Unused -> available
    msg[2] = CAL.FrameType.REPORT;
    msg[4] = 0; //battery lvl
    msg[5] = 0; //battery lvl
    msg[6] = 0; // IO statuts
    msg[7] = 0; // IO statuts
    msg[8] = 0; // IO counter
    msg[9] = 0; // IO counter
    msg[10] = 0; // IO counter
    msg[11] = 0; // IO counter
    msg[12] = 0; // IO counter
    msg[13] = 0; // IO counter
    msg[14] = (newAdr & 0x0f) << 4 | newMod & 0x0f;
    msg[15] = 0; // IO counter
    msg[16] = 0; // IO counter
    msg[17] = newHW;
    if (protocolVersion === CAL_PROTOCOL_VERSIONS.THREE) msg[3] = CAL.MessageSize.SIZE_FRAME_REPORT_3;else {
      msg[3] = CAL.MessageSize.SIZE_FRAME_REPORT_4;
      const newBeacPositioning = (_d = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.beacScanning) !== null && _d !== void 0 ? _d : beacScanning;
      const newBeaconing = (_e = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.beaconing) !== null && _e !== void 0 ? _e : beaconing;
      const newBeacStrengh = (_f = configurationCustom === null || configurationCustom === void 0 ? void 0 : configurationCustom.beacStrength) !== null && _f !== void 0 ? _f : beacStrength;
      msg[18] = (newBeacPositioning & 0x0f) << 4 | +newBeaconing & 0x0f;
      msg[19] = newBeacStrengh;
    }
    return msg;
  }
}
var CAL;
(function (CAL) {
  let AdrProfile;
  (function (AdrProfile) {
    AdrProfile[AdrProfile["SMTC_MODEM_ADR_PROFILE_NETWORK_CONTROLLED"] = 0] = "SMTC_MODEM_ADR_PROFILE_NETWORK_CONTROLLED";
    AdrProfile[AdrProfile["SMTC_MODEM_ADR_PROFILE_MOBILE_LONG_RANGE"] = 1] = "SMTC_MODEM_ADR_PROFILE_MOBILE_LONG_RANGE";
    AdrProfile[AdrProfile["SMTC_MODEM_ADR_PROFILE_MOBILE_LOW_POWER"] = 2] = "SMTC_MODEM_ADR_PROFILE_MOBILE_LOW_POWER";
    AdrProfile[AdrProfile["SMTC_MODEM_ADR_PROFILE_CUSTOM"] = 3] = "SMTC_MODEM_ADR_PROFILE_CUSTOM";
  })(AdrProfile = CAL.AdrProfile || (CAL.AdrProfile = {}));
  let IOStatus;
  (function (IOStatus) {
    IOStatus[IOStatus["LOW"] = 0] = "LOW";
    IOStatus[IOStatus["HIGH"] = 1] = "HIGH";
  })(IOStatus = CAL.IOStatus || (CAL.IOStatus = {}));
  let ProtocolFirstHexa;
  (function (ProtocolFirstHexa) {
    ProtocolFirstHexa[ProtocolFirstHexa["PROT_FIRST_HEXA_PROTOCOL_VERSION"] = 0] = "PROT_FIRST_HEXA_PROTOCOL_VERSION";
    ProtocolFirstHexa[ProtocolFirstHexa["PROT_FIRST_HEXA_SOFTWARE_VERSION"] = 1] = "PROT_FIRST_HEXA_SOFTWARE_VERSION";
    ProtocolFirstHexa[ProtocolFirstHexa["PROT_FIRST_HEXA_BATTERY_LVL_MV"] = 2] = "PROT_FIRST_HEXA_BATTERY_LVL_MV";
    ProtocolFirstHexa[ProtocolFirstHexa["PROT_FIRST_HEXA_SENSORS_STATUS"] = 4] = "PROT_FIRST_HEXA_SENSORS_STATUS";
    ProtocolFirstHexa[ProtocolFirstHexa["PROT_FIRST_HEXA_IO_1ST_HIGH_COUNTER"] = 5] = "PROT_FIRST_HEXA_IO_1ST_HIGH_COUNTER";
    ProtocolFirstHexa[ProtocolFirstHexa["PROT_FIRST_HEXA_IO_2ND_HIGH_COUNTER"] = 8] = "PROT_FIRST_HEXA_IO_2ND_HIGH_COUNTER";
    ProtocolFirstHexa[ProtocolFirstHexa["PROT_FIRST_HEXA_REED_SWITCH_HIGH_COUNTER"] = 11] = "PROT_FIRST_HEXA_REED_SWITCH_HIGH_COUNTER";
    ProtocolFirstHexa[ProtocolFirstHexa["PROT_LAST_HEXA"] = 14] = "PROT_LAST_HEXA";
  })(ProtocolFirstHexa = CAL.ProtocolFirstHexa || (CAL.ProtocolFirstHexa = {}));
  let ReportProtocolFirstHexa;
  (function (ReportProtocolFirstHexa) {
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["BATTERY_LVL_MV"] = 4] = "BATTERY_LVL_MV";
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["BTN1_STATUS"] = 6] = "BTN1_STATUS";
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["BTN2_STATUS"] = 6] = "BTN2_STATUS";
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["RS_STATUS"] = 7] = "RS_STATUS";
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["BTN3_STATUS"] = 7] = "BTN3_STATUS";
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["BTN1_COUNTER"] = 8] = "BTN1_COUNTER";
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["BTN2_COUNTER"] = 10] = "BTN2_COUNTER";
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["RS_COUNTER"] = 12] = "RS_COUNTER";
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["ADRPROFILE_OPERATINGMOD"] = 14] = "ADRPROFILE_OPERATINGMOD";
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["BTN3_COUNTER"] = 15] = "BTN3_COUNTER";
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["BEACSCANNING_BEACONING"] = 18] = "BEACSCANNING_BEACONING";
    ReportProtocolFirstHexa[ReportProtocolFirstHexa["BEACONING_STRENGTH"] = 19] = "BEACONING_STRENGTH";
  })(ReportProtocolFirstHexa = CAL.ReportProtocolFirstHexa || (CAL.ReportProtocolFirstHexa = {}));
  let AlertProtocolFirstHexa;
  (function (AlertProtocolFirstHexa) {
    AlertProtocolFirstHexa[AlertProtocolFirstHexa["ALERT_EVENT"] = 4] = "ALERT_EVENT";
    AlertProtocolFirstHexa[AlertProtocolFirstHexa["ALERT_SOURCE"] = 4] = "ALERT_SOURCE";
  })(AlertProtocolFirstHexa = CAL.AlertProtocolFirstHexa || (CAL.AlertProtocolFirstHexa = {}));
  let FrameType;
  (function (FrameType) {
    FrameType[FrameType["REPORT"] = 0] = "REPORT";
    FrameType[FrameType["ALERT"] = 1] = "ALERT";
    FrameType[FrameType["BEACON_POSITIONNING"] = 2] = "BEACON_POSITIONNING";
    FrameType[FrameType["KEEP_ALIVE"] = 3] = "KEEP_ALIVE";
  })(FrameType = CAL.FrameType || (CAL.FrameType = {}));
  let DLFrameType;
  (function (DLFrameType) {
    DLFrameType[DLFrameType["REPORT"] = 0] = "REPORT";
    DLFrameType[DLFrameType["ASK_FOR_BEACON_POSITIONNING"] = 2] = "ASK_FOR_BEACON_POSITIONNING";
    DLFrameType[DLFrameType["ASK_FOR_RESET"] = 3] = "ASK_FOR_RESET";
  })(DLFrameType = CAL.DLFrameType || (CAL.DLFrameType = {}));
  let AlertAction;
  (function (AlertAction) {
    AlertAction[AlertAction["ALERT"] = 0] = "ALERT";
    AlertAction[AlertAction["ACKNOWLEDGMENT"] = 1] = "ACKNOWLEDGMENT";
  })(AlertAction = CAL.AlertAction || (CAL.AlertAction = {}));
  let AlertSource;
  (function (AlertSource) {
    AlertSource[AlertSource["UNKNOWN"] = 0] = "UNKNOWN";
    AlertSource[AlertSource["ALERT_1"] = 1] = "ALERT_1";
    AlertSource[AlertSource["ALERT_2"] = 2] = "ALERT_2";
    AlertSource[AlertSource["ALERT_3"] = 3] = "ALERT_3";
    AlertSource[AlertSource["REED_SWITCH"] = 4] = "REED_SWITCH";
  })(AlertSource = CAL.AlertSource || (CAL.AlertSource = {}));
  let BeaconScanning;
  (function (BeaconScanning) {
    BeaconScanning[BeaconScanning["INACTIVE"] = 0] = "INACTIVE";
    BeaconScanning[BeaconScanning["ACTIVE_ON_ALERT_ONCE"] = 1] = "ACTIVE_ON_ALERT_ONCE";
    BeaconScanning[BeaconScanning["ACTIVE_ON_ALERT_FULL"] = 2] = "ACTIVE_ON_ALERT_FULL";
  })(BeaconScanning = CAL.BeaconScanning || (CAL.BeaconScanning = {}));
  let BaseProtocolFirstHexa;
  (function (BaseProtocolFirstHexa) {
    BaseProtocolFirstHexa[BaseProtocolFirstHexa["PROTOCOL_VERSION"] = 0] = "PROTOCOL_VERSION";
    BaseProtocolFirstHexa[BaseProtocolFirstHexa["SOFTWARE_VERSION"] = 1] = "SOFTWARE_VERSION";
    BaseProtocolFirstHexa[BaseProtocolFirstHexa["FRAME_TYPE"] = 2] = "FRAME_TYPE";
    BaseProtocolFirstHexa[BaseProtocolFirstHexa["SIZE_FRAME"] = 3] = "SIZE_FRAME";
    BaseProtocolFirstHexa[BaseProtocolFirstHexa["HARDWARE_VERSION"] = 17] = "HARDWARE_VERSION";
  })(BaseProtocolFirstHexa = CAL.BaseProtocolFirstHexa || (CAL.BaseProtocolFirstHexa = {}));
  let ModId;
  (function (ModId) {
    ModId[ModId["MOD_DEFAULT"] = 0] = "MOD_DEFAULT";
    ModId[ModId["MOD_REPORT"] = 1] = "MOD_REPORT";
  })(ModId = CAL.ModId || (CAL.ModId = {}));
  let MessageSize;
  (function (MessageSize) {
    MessageSize[MessageSize["SIZE_FRAME_REPORT_3"] = 18] = "SIZE_FRAME_REPORT_3";
    MessageSize[MessageSize["SIZE_FRAME_REPORT_4"] = 20] = "SIZE_FRAME_REPORT_4";
    MessageSize[MessageSize["SIZE_FRAME_ALERT_N_ACK"] = 5] = "SIZE_FRAME_ALERT_N_ACK";
    MessageSize[MessageSize["SIZE_DL_FRAME_ASK_FOR_BEACON_SCANNING"] = 4] = "SIZE_DL_FRAME_ASK_FOR_BEACON_SCANNING";
    MessageSize[MessageSize["SIZE_DL_FRAME_ASK_FOR_RESET"] = 4] = "SIZE_DL_FRAME_ASK_FOR_RESET";
  })(MessageSize = CAL.MessageSize || (CAL.MessageSize = {}));
})(CAL || (CAL = {}));
const headerSize = 8;
class DMDecoder extends Decoder {
  constructor(frame) {
    super();
    this.hasCrashLog = false;
    this.hasDMInfoUpload = false;
    this.hasDMInfoAlCSync = false;
    let binPtr = 0;
    while (binPtr < frame.length * 4) {
      let header = this.getHeader(frame, binPtr);
      if (header === DM.dm_info_field.DM_INFO_CRASHLOG) {
        this.hasCrashLog = true;
        break;
      }
      if (header === DM.dm_info_field.DM_INFO_UPLOAD) {
        this.hasDMInfoUpload = true;
        break;
      }
      if (header === DM.dm_info_field.DM_INFO_ALCSYNC) {
        this.hasDMInfoAlCSync = true;
        break;
      }
      let size = this.sizeOf(header);
      if (!size) break;
      binPtr += headerSize;
      let body = extractNumberFromMessage(frame, [binPtr, size * 8]);
      binPtr += size * 8;
      this.setField(header, body);
    }
  }
  getHeader(msg, ptr) {
    return extractNumberFromMessage(msg, [ptr, headerSize]);
  }
  setField(header, body) {
    switch (header) {
      case DM.dm_info_field.DM_INFO_STATUS:
        this.status = `DM_INFO_STATUS : 0b${hex2bin(body.toString(16))} - Offset : Brownout : 0, Crash : 1, Mute : 2, Joined : 3, Suspend : 4, Joining :6`;
      case DM.dm_info_field.DM_INFO_CHARGE:
        this.charge = Number(`${body % 256}${Math.trunc(body / 256)}`);
      case DM.dm_info_field.DM_INFO_VOLTAGE:
        this.voltage = body * 3000 / 255;
      case DM.dm_info_field.DM_INFO_TEMP:
        this.temp = body;
      case DM.dm_info_field.DM_INFO_SIGNAL:
        this.signal = {
          RSSI: Math.trunc(body / 256) - 64,
          SNR: body % 256 * 0.25
        };
      case DM.dm_info_field.DM_INFO_UPTIME:
        this.upTime = Number(`${body % 256}${Math.trunc(body / 256)}`);
      //h - duration since last reset
      case DM.dm_info_field.DM_INFO_RXTIME:
        this.rxTime = Number(`${body % 256}${Math.trunc(body / 256)}`);
      // h - duration since last downlink
      case DM.dm_info_field.DM_INFO_FIRMWARE:
        this.firmware = body;
      case DM.dm_info_field.DM_INFO_ADRMODE:
        this.adrMode = `${body} - ADR profile 0:static, 1:mobil`;
      case DM.dm_info_field.DM_INFO_JOINEUI:
        this.joinEUI = body.toString(16);
      case DM.dm_info_field.DM_INFO_INTERVAL:
        this.interval = `0x${body.toString(16)} - reporting interval [values 0-63, units s/m/h/d]`;
      case DM.dm_info_field.DM_INFO_REGION:
        this.region = `0x${body.toString(16)} - Unknown : 0, EU868 : 1, Other: Error`;
      case DM.dm_info_field.DM_INFO_RSTCOUNT:
        this.rstCount = Number(`${body % 256}${Math.trunc(body / 256)}`);
      // - modem reset count
      case DM.dm_info_field.DM_INFO_DEVEUI:
        this.devEUI = body.toString(16);
      case DM.dm_info_field.DM_INFO_SESSION:
        this.session = Number(`${(body % 256 + Math.trunc(body / 256)).toString(16)}`);
      case DM.dm_info_field.DM_INFO_CHIPEUI:
        this.chipEUI = body.toString(16);
      case DM.dm_info_field.DM_INFO_ALMSTATUS:
        this.almStatus = body.toString(16);
      case DM.dm_info_field.DM_INFO_RFU_0:
        this.rfu0 = body.toString(16);
      case DM.dm_info_field.DM_INFO_RFU_1:
        this.rfu1 = body.toString(16);
      default:
        this.extra += `header: ${header}, body: ${body.toString(16)}`;
    }
  }
  sizeOf(header) {
    switch (header) {
      case DM.dm_info_field.DM_INFO_STATUS:
      case DM.dm_info_field.DM_INFO_VOLTAGE:
      case DM.dm_info_field.DM_INFO_TEMP:
      case DM.dm_info_field.DM_INFO_ADRMODE:
      case DM.dm_info_field.DM_INFO_INTERVAL:
      case DM.dm_info_field.DM_INFO_REGION:
        return 1;
      case DM.dm_info_field.DM_INFO_CHARGE:
      case DM.dm_info_field.DM_INFO_SIGNAL:
      case DM.dm_info_field.DM_INFO_UPTIME:
      case DM.dm_info_field.DM_INFO_RXTIME:
      case DM.dm_info_field.DM_INFO_RSTCOUNT:
      case DM.dm_info_field.DM_INFO_RFU_1:
      case DM.dm_info_field.DM_INFO_SESSION:
        return 2;
      case DM.dm_info_field.DM_INFO_RFU_0:
        return 4;
      case DM.dm_info_field.DM_INFO_ALMSTATUS:
        return 7;
      case DM.dm_info_field.DM_INFO_FIRMWARE:
      case DM.dm_info_field.DM_INFO_JOINEUI:
      case DM.dm_info_field.DM_INFO_DEVEUI:
      case DM.dm_info_field.DM_INFO_CHIPEUI:
        return 8;
      default:
        return 0;
    }
  }
}
var DM;
(function (DM) {
  //from https://github.com/Lora-net/SWL2001 (last update : 12/09/2022, v3.2.4)
  /**
   * @brief Definition of the DAS downlink request opcodes
   *
   * @enum dm_opcode_t
   */
  let dm_info_field;
  (function (dm_info_field) {
    dm_info_field[dm_info_field["DM_INFO_STATUS"] = 0] = "DM_INFO_STATUS";
    dm_info_field[dm_info_field["DM_INFO_CHARGE"] = 1] = "DM_INFO_CHARGE";
    dm_info_field[dm_info_field["DM_INFO_VOLTAGE"] = 2] = "DM_INFO_VOLTAGE";
    dm_info_field[dm_info_field["DM_INFO_TEMP"] = 3] = "DM_INFO_TEMP";
    dm_info_field[dm_info_field["DM_INFO_SIGNAL"] = 4] = "DM_INFO_SIGNAL";
    dm_info_field[dm_info_field["DM_INFO_UPTIME"] = 5] = "DM_INFO_UPTIME";
    dm_info_field[dm_info_field["DM_INFO_RXTIME"] = 6] = "DM_INFO_RXTIME";
    dm_info_field[dm_info_field["DM_INFO_FIRMWARE"] = 7] = "DM_INFO_FIRMWARE";
    dm_info_field[dm_info_field["DM_INFO_ADRMODE"] = 8] = "DM_INFO_ADRMODE";
    dm_info_field[dm_info_field["DM_INFO_JOINEUI"] = 9] = "DM_INFO_JOINEUI";
    dm_info_field[dm_info_field["DM_INFO_INTERVAL"] = 10] = "DM_INFO_INTERVAL";
    dm_info_field[dm_info_field["DM_INFO_REGION"] = 11] = "DM_INFO_REGION";
    dm_info_field[dm_info_field["DM_INFO_RFU_0"] = 12] = "DM_INFO_RFU_0";
    dm_info_field[dm_info_field["DM_INFO_CRASHLOG"] = 13] = "DM_INFO_CRASHLOG";
    dm_info_field[dm_info_field["DM_INFO_UPLOAD"] = 14] = "DM_INFO_UPLOAD";
    dm_info_field[dm_info_field["DM_INFO_RSTCOUNT"] = 15] = "DM_INFO_RSTCOUNT";
    dm_info_field[dm_info_field["DM_INFO_DEVEUI"] = 16] = "DM_INFO_DEVEUI";
    dm_info_field[dm_info_field["DM_INFO_RFU_1"] = 17] = "DM_INFO_RFU_1";
    dm_info_field[dm_info_field["DM_INFO_SESSION"] = 18] = "DM_INFO_SESSION";
    dm_info_field[dm_info_field["DM_INFO_CHIPEUI"] = 19] = "DM_INFO_CHIPEUI";
    dm_info_field[dm_info_field["DM_INFO_STREAM"] = 20] = "DM_INFO_STREAM";
    dm_info_field[dm_info_field["DM_INFO_STREAMPAR"] = 21] = "DM_INFO_STREAMPAR";
    dm_info_field[dm_info_field["DM_INFO_APPSTATUS"] = 22] = "DM_INFO_APPSTATUS";
    dm_info_field[dm_info_field["DM_INFO_ALCSYNC"] = 23] = "DM_INFO_ALCSYNC";
    dm_info_field[dm_info_field["DM_INFO_ALMSTATUS"] = 24] = "DM_INFO_ALMSTATUS";
    dm_info_field[dm_info_field["DM_INFO_DBGRSP"] = 25] = "DM_INFO_DBGRSP";
    dm_info_field[dm_info_field["DM_INFO_GNSSLOC"] = 26] = "DM_INFO_GNSSLOC";
    dm_info_field[dm_info_field["DM_INFO_WIFILOC"] = 27] = "DM_INFO_WIFILOC";
    dm_info_field[dm_info_field["DM_INFO_MAX"] = 28] = "DM_INFO_MAX"; //!< number of elements
  })(dm_info_field = DM.dm_info_field || (DM.dm_info_field = {}));
})(DM || (DM = {}));
function valueOf(message, range) {
  return parseInt(extractDataFromMessage(message, range), 16);
}
function scaleOf(value, range, coef, handleOffset = false) {
  const mappedValue = (handleOffset ? range[0] : 0) + value * (coef !== null && coef !== void 0 ? coef : 1);
  if (mappedValue > range[1]) {
    throw `mapped value ${mappedValue} out of range [${range[0]} - ${range[1]}]`;
  }
  return mappedValue;
}
function getBatteryLevel(battlevel) {
  switch (battlevel) {
    case 0:
      return BatteryLevel.High;
    case 1:
      return BatteryLevel.Medium;
    case 2:
      return BatteryLevel.Low;
    case 3:
      return BatteryLevel.Critical;
    default:
      return BatteryLevel.Unknown;
  }
}
function getAirAnalysisRange(airAnalysisIndex) {
  switch (airAnalysisIndex) {
    case 0:
      return 0.025;
    case 1:
      return 0.075;
    case 2:
      return 0.125;
    case 3:
      return 0.175;
    case 4:
      return 0.225;
    case 5:
      return 0.300;
    case 6:
      return 0.400;
    case 7:
      return 0.500;
    case 8:
      return 0.600;
    case 9:
      return 0.700;
    case 10:
      return 0.775;
    case 11:
      return 0.825;
    case 12:
      return 0.875;
    case 13:
      return 0.925;
    case 14:
      return 1;
    default:
      throw `Air analysis index ${airAnalysisIndex} is out of range`;
  }
}
/**
 * Add a specfic number of months and weeks to the current date
 *
 * @param week number of weeks to add
 * @param months number of months to add
 * @returns timestamp
 */
function getMatchingDate({
  weeks,
  months
}) {
  const date = new Date();
  return date.setUTCDate(date.getUTCDate() + 30 * (months !== null && months !== void 0 ? months : 0) + 7 * (weeks !== null && weeks !== void 0 ? weeks : 0));
}
const threeMonths = 3 * 30 * 24 * 3600 * 1000;
var ProductType = /*#__PURE__*/function (ProductType) {
  ProductType[ProductType["insafeOriginSigfox"] = 1] = "insafeOriginSigfox";
  ProductType[ProductType["insafeOriginLora"] = 162] = "insafeOriginLora";
  return ProductType;
}(ProductType || {});
var HardwareRevision = /*#__PURE__*/function (HardwareRevision) {
  HardwareRevision[HardwareRevision["C027A"] = 0] = "C027A";
  return HardwareRevision;
}(HardwareRevision || {});
var SoftwareRevision = /*#__PURE__*/function (SoftwareRevision) {
  SoftwareRevision[SoftwareRevision["S077A"] = 0] = "S077A";
  return SoftwareRevision;
}(SoftwareRevision || {});
var SensorFaultStatus = /*#__PURE__*/function (SensorFaultStatus) {
  SensorFaultStatus[SensorFaultStatus["ok"] = 0] = "ok";
  SensorFaultStatus[SensorFaultStatus["sensorFault"] = 1] = "sensorFault";
  return SensorFaultStatus;
}(SensorFaultStatus || {});
var SensorFaultMode = /*#__PURE__*/function (SensorFaultMode) {
  SensorFaultMode[SensorFaultMode["nonActivated"] = 0] = "nonActivated";
  SensorFaultMode[SensorFaultMode["activated"] = 1] = "activated";
  return SensorFaultMode;
}(SensorFaultMode || {});
var JoinRequestScheduled = /*#__PURE__*/function (JoinRequestScheduled) {
  JoinRequestScheduled[JoinRequestScheduled["notJoined"] = 0] = "notJoined";
  JoinRequestScheduled[JoinRequestScheduled["joined"] = 1] = "joined";
  return JoinRequestScheduled;
}(JoinRequestScheduled || {});
var SmokeAlarmStatus = /*#__PURE__*/function (SmokeAlarmStatus) {
  SmokeAlarmStatus[SmokeAlarmStatus["nonActivated"] = 0] = "nonActivated";
  SmokeAlarmStatus[SmokeAlarmStatus["activated"] = 1] = "activated";
  return SmokeAlarmStatus;
}(SmokeAlarmStatus || {});
var SmokeAlarmHushReason = /*#__PURE__*/function (SmokeAlarmHushReason) {
  SmokeAlarmHushReason[SmokeAlarmHushReason["noSmokeAnymore"] = 0] = "noSmokeAnymore";
  SmokeAlarmHushReason[SmokeAlarmHushReason["centralButtonPress"] = 1] = "centralButtonPress";
  return SmokeAlarmHushReason;
}(SmokeAlarmHushReason || {});
var SmokeTestStatus = /*#__PURE__*/function (SmokeTestStatus) {
  SmokeTestStatus[SmokeTestStatus["off"] = 0] = "off";
  SmokeTestStatus[SmokeTestStatus["running"] = 1] = "running";
  return SmokeTestStatus;
}(SmokeTestStatus || {});
var MaintenanceStatus = /*#__PURE__*/function (MaintenanceStatus) {
  MaintenanceStatus[MaintenanceStatus["ok"] = 0] = "ok";
  MaintenanceStatus[MaintenanceStatus["notDone"] = 1] = "notDone";
  return MaintenanceStatus;
}(MaintenanceStatus || {});
var HumidityRange = /*#__PURE__*/function (HumidityRange) {
  HumidityRange[HumidityRange["ok"] = 0] = "ok";
  HumidityRange[HumidityRange["nok"] = 1] = "nok";
  return HumidityRange;
}(HumidityRange || {});
var TemperatureRange = /*#__PURE__*/function (TemperatureRange) {
  TemperatureRange[TemperatureRange["ok"] = 0] = "ok";
  TemperatureRange[TemperatureRange["nok"] = 1] = "nok";
  return TemperatureRange;
}(TemperatureRange || {});
var IndoorAirQualityLevel = /*#__PURE__*/function (IndoorAirQualityLevel) {
  IndoorAirQualityLevel[IndoorAirQualityLevel["Excellent"] = 0] = "Excellent";
  IndoorAirQualityLevel[IndoorAirQualityLevel["Good"] = 1] = "Good";
  IndoorAirQualityLevel[IndoorAirQualityLevel["Fair"] = 2] = "Fair";
  IndoorAirQualityLevel[IndoorAirQualityLevel["Poor"] = 3] = "Poor";
  IndoorAirQualityLevel[IndoorAirQualityLevel["Bad"] = 4] = "Bad";
  IndoorAirQualityLevel[IndoorAirQualityLevel["NotUsed0"] = 5] = "NotUsed0";
  IndoorAirQualityLevel[IndoorAirQualityLevel["NotUsed1"] = 6] = "NotUsed1";
  IndoorAirQualityLevel[IndoorAirQualityLevel["Error"] = 7] = "Error";
  return IndoorAirQualityLevel;
}(IndoorAirQualityLevel || {});
var IndoorAirQualitySource = /*#__PURE__*/function (IndoorAirQualitySource) {
  IndoorAirQualitySource[IndoorAirQualitySource["All"] = 0] = "All";
  IndoorAirQualitySource[IndoorAirQualitySource["DrynessIndicator"] = 1] = "DrynessIndicator";
  IndoorAirQualitySource[IndoorAirQualitySource["MouldIndicator"] = 2] = "MouldIndicator";
  IndoorAirQualitySource[IndoorAirQualitySource["DustMitesIndicator"] = 3] = "DustMitesIndicator";
  IndoorAirQualitySource[IndoorAirQualitySource["CO"] = 4] = "CO";
  IndoorAirQualitySource[IndoorAirQualitySource["CO2"] = 5] = "CO2";
  IndoorAirQualitySource[IndoorAirQualitySource["NotUsed0"] = 6] = "NotUsed0";
  IndoorAirQualitySource[IndoorAirQualitySource["NotUsed1"] = 7] = "NotUsed1";
  IndoorAirQualitySource[IndoorAirQualitySource["NotUsed2"] = 8] = "NotUsed2";
  IndoorAirQualitySource[IndoorAirQualitySource["NotUsed3"] = 9] = "NotUsed3";
  IndoorAirQualitySource[IndoorAirQualitySource["NotUsed4"] = 10] = "NotUsed4";
  IndoorAirQualitySource[IndoorAirQualitySource["NotUsed5"] = 11] = "NotUsed5";
  IndoorAirQualitySource[IndoorAirQualitySource["NotUsed6"] = 12] = "NotUsed6";
  IndoorAirQualitySource[IndoorAirQualitySource["NotUsed7"] = 13] = "NotUsed7";
  IndoorAirQualitySource[IndoorAirQualitySource["NotUsed9"] = 14] = "NotUsed9";
  IndoorAirQualitySource[IndoorAirQualitySource["Error"] = 15] = "Error";
  return IndoorAirQualitySource;
}(IndoorAirQualitySource || {});
var HygrothermalIndexObservation = /*#__PURE__*/function (HygrothermalIndexObservation) {
  HygrothermalIndexObservation[HygrothermalIndexObservation["NotObserved"] = 0] = "NotObserved";
  HygrothermalIndexObservation[HygrothermalIndexObservation["Observed"] = 1] = "Observed";
  return HygrothermalIndexObservation;
}(HygrothermalIndexObservation || {});
var i870Lib = /*#__PURE__*/Object.freeze({
  __proto__: null,
  valueOf: valueOf,
  scaleOf: scaleOf,
  getBatteryLevel: getBatteryLevel,
  getAirAnalysisRange: getAirAnalysisRange,
  getMatchingDate: getMatchingDate,
  threeMonths: threeMonths,
  get ProductType() {
    return ProductType;
  },
  get HardwareRevision() {
    return HardwareRevision;
  },
  get SoftwareRevision() {
    return SoftwareRevision;
  },
  get SensorFaultStatus() {
    return SensorFaultStatus;
  },
  get SensorFaultMode() {
    return SensorFaultMode;
  },
  get JoinRequestScheduled() {
    return JoinRequestScheduled;
  },
  get SmokeAlarmStatus() {
    return SmokeAlarmStatus;
  },
  get SmokeAlarmHushReason() {
    return SmokeAlarmHushReason;
  },
  get SmokeTestStatus() {
    return SmokeTestStatus;
  },
  get MaintenanceStatus() {
    return MaintenanceStatus;
  },
  get HumidityRange() {
    return HumidityRange;
  },
  get TemperatureRange() {
    return TemperatureRange;
  },
  get IndoorAirQualityLevel() {
    return IndoorAirQualityLevel;
  },
  get IndoorAirQualitySource() {
    return IndoorAirQualitySource;
  },
  get HygrothermalIndexObservation() {
    return HygrothermalIndexObservation;
  }
});
class I870SFDecoder extends Decoder {
  constructor(frame) {
    super();
    this.productType = this.getProductType(frame);
    if (this.productType === ProductType.insafeOriginSigfox) {
      switch (this.getMessageType(frame)) {
        case I870SF.MessageType.smokeAlarm:
          this.setSmokeAlarmMessage(frame);
          break;
        case I870SF.MessageType.airQualityV2:
          this.setDailyAirQualityMessage(frame);
          break;
      }
    }
  }
  getDeviceType() {
    return DeviceType.I870SF;
  }
  getProductType(frame) {
    return valueOf(frame, [0, 4]);
  }
  getMessageType(frame) {
    return valueOf(frame, [4, 4]);
  }
  setSmokeAlarmMessage(frame) {
    this.messageType = I870SF.MessageType.smokeAlarm;
    this.smokeAlarmHush = valueOf(frame, [8, 1]);
    this.smokeAlarmStatus = valueOf(frame, [9, 1]);
    this.smokeSensorFaultModeStatus = valueOf(frame, [10, 1]);
    this.smokeAlarmIsMaintenance = valueOf(frame, [11, 1]);
    this.smokeAlarmIsHumidity = valueOf(frame, [12, 1]);
    this.smokeAlarmIsTemperature = valueOf(frame, [13, 1]);
    this.batteryLevel = getBatteryLevel(valueOf(frame, [14, 2]));
    this.lastMaintenance = getMatchingDate({
      weeks: valueOf(frame, [16, 8])
    });
    this.remainingProductLifetime = getMatchingDate({
      months: scaleOf(valueOf(frame, [24, 8]), [0, 120])
    });
    this.frameIndex = scaleOf(valueOf(frame, [32, 3]), [0, 7]);
  }
  setDailyAirQualityMessage(frame) {
    this.messageType = I870SF.MessageType.airQualityV2;
    this.dryAirTimeRate = getAirAnalysisRange(valueOf(frame, [8, 4]));
    this.highHumidityTimeRate = getAirAnalysisRange(valueOf(frame, [12, 4]));
    this.highTempNHumidityTimeRate = getAirAnalysisRange(valueOf(frame, [16, 4]));
    this.optimalAirTimeRate = getAirAnalysisRange(valueOf(frame, [20, 4]));
    this.minTemperature = scaleOf(valueOf(frame, [24, 8]), [0, 50], 0.2);
    this.maxTemperature = scaleOf(valueOf(frame, [32, 8]), [0, 50], 0.2);
    this.averageTemperature = scaleOf(valueOf(frame, [40, 8]), [0, 50], 0.2);
    this.minRelativeHumidity = scaleOf(valueOf(frame, [48, 8]), [0, 100], 0.5);
    this.maxRelativeHumidity = scaleOf(valueOf(frame, [56, 8]), [0, 100], 0.5);
    this.averageRelativeHumidity = scaleOf(valueOf(frame, [64, 8]), [0, 100], 0.5);
    this.hygrothermalIndexGood = valueOf(frame, [72, 1]);
    this.hygrothermalIndexMedium = valueOf(frame, [73, 1]);
    this.hygrothermalIndexBad = valueOf(frame, [74, 1]);
    this.frameIndex = scaleOf(valueOf(frame, [75, 3]), [0, 7]);
    this.indoorAirQualityLevel = valueOf(frame, [78, 3]);
    this.indoorAirQualitySource = valueOf(frame, [81, 4]);
  }
  static isSFSmokeAlarmMessageType(decodedMessage) {
    return decodedMessage.messageType === I870SF.MessageType.smokeAlarm;
  }
  static isAirQualityV2(decodedMessage) {
    return decodedMessage.messageType === I870SF.MessageType.airQualityV2;
  }
}
var I870SF;
(function (I870SF) {
  let MessageType;
  (function (MessageType) {
    MessageType[MessageType["smokeAlarm"] = 0] = "smokeAlarm";
    MessageType[MessageType["airQualityV2"] = 3] = "airQualityV2";
  })(MessageType = I870SF.MessageType || (I870SF.MessageType = {}));
})(I870SF || (I870SF = {}));
class I870LRDecoder extends Decoder {
  constructor(frame) {
    super();
    this.productType = this.getProductType(frame);
    if (this.productType === ProductType.insafeOriginLora) {
      switch (this.getMessageType(frame)) {
        case I870LR.MessageType.productStatus:
          this.setProductStatus(frame);
          break;
        case I870LR.MessageType.keepAlive:
          this.setKeepAlive(frame);
          break;
        case I870LR.MessageType.smokeAlarmStatus:
          this.setSmokeAlarmStatus(frame);
          break;
        case I870LR.MessageType.dailyAirQuality:
          this.setDailyAirQuality(frame);
          break;
        case I870LR.MessageType.temperatureDataLog:
          this.setTemperatureDataLog(frame);
        case I870LR.MessageType.humidityDataLog:
          this.setHumidityDataLog(frame);
        default:
      }
    }
  }
  getDeviceType() {
    return DeviceType.I870LR;
  }
  getProductType(frame) {
    return valueOf(frame, [0, 8]);
  }
  getMessageType(frame) {
    return valueOf(frame, [8, 8]);
  }
  setProductStatus(frame) {
    this.messageType = I870LR.MessageType.productStatus;
    this.hardwareRevision = valueOf(frame, [16, 8]);
    this.softwareRevision = valueOf(frame, [24, 8]);
    this.remainingProductLifetime = getMatchingDate({
      months: scaleOf(valueOf(frame, [32, 8]), [0, 120])
    });
    this.smokeSensorStatus = valueOf(frame, [40, 1]);
    this.temperatureAndHumiditySensorStatus = valueOf(frame, [41, 1]);
    this.battery1Voltage = scaleOf(valueOf(frame, [48, 8]), [2000, 3250], 5, true);
    this.battery2Voltage = scaleOf(valueOf(frame, [56, 8]), [2000, 3250], 5, true);
    this.batteryLevel = getBatteryLevel(valueOf(frame, [64, 2]));
    this.pendingJoin = valueOf(frame, [66, 1]);
    this.sentFrameCounter = scaleOf(valueOf(frame, [72, 16]), [0, 655350], 10);
    this.productDateYear = scaleOf(valueOf(frame, [88, 6]), [0, 63]);
    this.productDateMonth = scaleOf(valueOf(frame, [94, 4]), [1, 12]);
    this.productDateDay = scaleOf(valueOf(frame, [98, 5]), [1, 31]);
    this.productDateHour = scaleOf(valueOf(frame, [103, 5]), [0, 23]);
    this.productDateMinute = scaleOf(valueOf(frame, [108, 6]), [0, 59]);
    this.productDateSecond = scaleOf(valueOf(frame, [114, 6]), [0, 59]);
    this.remainingConnectivityDuration = getMatchingDate({
      months: scaleOf(valueOf(frame, [120, 8]), [0, 240])
    });
  }
  setKeepAlive(_) {
    this.messageType = I870LR.MessageType.keepAlive;
  }
  setSmokeAlarmStatus(frame) {
    this.messageType = I870LR.MessageType.smokeAlarmStatus;
    this.smokeAlarmStatus = valueOf(frame, [16, 1]);
    this.smokeAlarmHush = valueOf(frame, [17, 1]);
    this.smokeTest = valueOf(frame, [18, 1]);
    this.smokeAlarmIsMaintenance = valueOf(frame, [19, 1]);
    this.smokeAlarmIsHumidity = valueOf(frame, [20, 1]);
    this.smokeAlarmIsTemperature = valueOf(frame, [21, 1]);
    this.lastMaintenance = getMatchingDate({
      weeks: valueOf(frame, [24, 8])
    });
    this.frameIndex = scaleOf(valueOf(frame, [32, 3]), [0, 7]);
  }
  setDailyAirQuality(frame) {
    this.messageType = I870LR.MessageType.dailyAirQuality;
    this.indoorAirQualityLevel = valueOf(frame, [16, 3]);
    this.indoorAirQualitySource = valueOf(frame, [19, 4]);
    this.minTemperature = scaleOf(valueOf(frame, [24, 8]), [0, 50], 0.2);
    this.maxTemperature = scaleOf(valueOf(frame, [32, 8]), [0, 50], 0.2);
    this.averageTemperature = scaleOf(valueOf(frame, [40, 8]), [0, 50], 0.2);
    this.minRelativeHumidity = scaleOf(valueOf(frame, [48, 8]), [0, 100], 0.5);
    this.maxRelativeHumidity = scaleOf(valueOf(frame, [56, 8]), [0, 100], 0.5);
    this.averageRelativeHumidity = scaleOf(valueOf(frame, [64, 8]), [0, 100], 0.5);
    this.frameIndex = scaleOf(valueOf(frame, [72, 3]), [0, 7]);
  }
  setTemperatureDataLog(_) {
    this.messageType = I870LR.MessageType.temperatureDataLog;
  }
  setHumidityDataLog(_) {
    this.messageType = I870LR.MessageType.humidityDataLog;
  }
  static isProductStatusMessageType(decodedMessage) {
    return decodedMessage.messageType === I870LR.MessageType.productStatus;
  }
  static isLRSmokeAlarmMessageType(decodedMessage) {
    return decodedMessage.messageType === I870LR.MessageType.smokeAlarmStatus;
  }
  static isDailyAirQualityMessageType(decodedMessage) {
    return decodedMessage.messageType === I870LR.MessageType.dailyAirQuality;
  }
}
var I870LR;
(function (I870LR) {
  let MessageType;
  (function (MessageType) {
    MessageType[MessageType["productStatus"] = 0] = "productStatus";
    MessageType[MessageType["keepAlive"] = 2] = "keepAlive";
    MessageType[MessageType["smokeAlarmStatus"] = 3] = "smokeAlarmStatus";
    MessageType[MessageType["dailyAirQuality"] = 4] = "dailyAirQuality";
    MessageType[MessageType["temperatureDataLog"] = 6] = "temperatureDataLog";
    MessageType[MessageType["humidityDataLog"] = 7] = "humidityDataLog";
  })(MessageType = I870LR.MessageType || (I870LR.MessageType = {}));
})(I870LR || (I870LR = {}));
class LDS02Decoder extends Decoder {
  constructor(message) {
    super();
    //checkFrame
    if (message.length !== 20) {
      throw new Error(`Uncoherent frame length LDS02 message: ${message}`);
    }
    //checkMod
    this.mod = this.getMod(message);
    if (this.mod !== 3) {
      throw new Error(`Unhandled LDS02 mod: ${this.mod}`);
    }
    this.eventCounter = this.getEventCounter(message);
    this.batteryLevel = this.getBatteryLevel(message);
    this.reedSwitchOpen = this.getDoorOpenStatus(message);
    this.firstIOHigh = this.getWaterLeakStatus(message);
    this.statusDuration = this.getStatusDuration(message);
    this.alarm = this.getAlarm(message);
  }
  getMod(message) {
    return extractNumberFromMessage(message, [16, 8]);
  }
  getBatteryLevel(message) {
    const batteryVoltage = extractNumberFromMessage(message, [2, 14]);
    console.log(`batteryVoltage ${batteryVoltage}mV`);
    if (batteryVoltage >= 2800) {
      return BatteryLevel.High;
    } else if (batteryVoltage >= 2300) {
      return BatteryLevel.Medium;
    } else if (batteryVoltage >= 2000) {
      return BatteryLevel.Low;
    } else {
      return BatteryLevel.Critical;
    }
  }
  getDoorOpenStatus(message) {
    return Boolean(extractNumberFromMessage(message, [0, 1]));
  }
  getWaterLeakStatus(message) {
    return Boolean(extractNumberFromMessage(message, [1, 1]));
  }
  getEventCounter(message) {
    return extractNumberFromMessage(message, [24, 24]);
  }
  getStatusDuration(message) {
    return extractNumberFromMessage(message, [48, 24]);
  }
  getAlarm(message) {
    return Boolean(extractNumberFromMessage(message, [79, 1]));
  }
}
class LHT65NLRDecoder extends Decoder {
  constructor(message) {
    super();
    this.batteryVoltage = this.decodeBatteryVoltage(message.substring(0, 4));
    this.batteryStatus = this.decodeBatteryStatus();
    this.internalTemperature = this.decodeTemperature(message.substring(4, 8));
    this.internalHumidity = this.decodeInternalHumidity(message.substring(8, 12));
    this.externalTemperature = this.decodeTemperature(message.substring(14, 18));
  }
  decodeBatteryStatus() {
    if (this.batteryVoltage < 2500) {
      return BatteryLevel.Critical;
    } else if (this.batteryVoltage < 2550) {
      return BatteryLevel.Low;
    } else if (this.batteryVoltage < 2650) {
      return BatteryLevel.Medium;
    } else {
      return BatteryLevel.High;
    }
  }
  decodeBatteryVoltage(hex) {
    const num = parseInt(hex, 16);
    const voltage = num & 0x3FFF;
    return voltage;
  }
  decodeTemperature(hex) {
    if (hex === '7fff') return undefined;
    let temperature;
    const num = parseInt(hex, 16);
    if (hex2bin(hex[0])[0] === '0') {
      // Temperature is positive
      temperature = num / 100;
    } else {
      // Temperature is negative
      temperature = (num - 65536) / 100;
    }
    return temperature;
  }
  decodeInternalHumidity(hex) {
    const num = parseInt(hex, 16);
    const humidity = num / 10;
    return humidity;
  }
}
class SP4Decoder extends Decoder {
  constructor(frame) {
    super();
    this.mode = this.getModeValue(frame);
    this.eventType = this.getEventType(frame);
    this.extractPayload(frame);
  }
  getModeValue(frame) {
    const n = parseInt(extractDataFromMessage(frame, [0, 8]), 16);
    switch (n) {
      case 0x00:
        return SP4.Mode.factory;
      case 0x01:
        return SP4.Mode.pressMe;
      case 0x02:
        return SP4.Mode.guardMe;
      case 0x03:
        return SP4.Mode.trackMe;
      case 0x04:
        return SP4.Mode.traceMe;
      case 0x05:
        return SP4.Mode.monitorMe;
      case 0x06:
        return SP4.Mode.putMeBack;
      case 0x07:
        return SP4.Mode.dontDropMe;
      case 0x08:
        return SP4.Mode.reedSwitchRedundancy;
      case 0x09:
        return SP4.Mode.doorMode;
      case 0x0A:
        return SP4.Mode.leakDetector;
      case 0x0B:
        return SP4.Mode.demoMode;
      case 0x0C:
        return SP4.Mode.reedSwitchOnOff;
      case 0x0D:
        return SP4.Mode.lightOnOff;
      case 0x0E:
        return SP4.Mode.temperatureThresholdWRedundancy;
      case 0x0F:
        return SP4.Mode.temperatureChangeWRedundancy;
      case 0x10:
        return SP4.Mode.temperatureThresholdAlert;
      case 0x11:
        return SP4.Mode.temperatureChangeAlert;
      case 0x12:
        return SP4.Mode.stupidMode1;
      case 0x13:
        return SP4.Mode.reedSwitchCounter;
      case 0x60:
        return SP4.Mode.blinker;
      case 0x61:
        return SP4.Mode.stupidMode2;
    }
  }
  getEventType(frame) {
    const n = parseInt(extractDataFromMessage(frame, [8, 8]), 16);
    switch (n) {
      case 0x00:
        return SP4.EventType.hearthBeat1;
      case 0x01:
        return SP4.EventType.hearthBeat2;
      case 0x10:
        return SP4.EventType.arming;
      case 0x11:
        return SP4.EventType.armed;
      case 0x14:
        return SP4.EventType.disarmed;
      case 0x15:
        return SP4.EventType.receivedDownlinkAndRequest;
      case 0x16:
        return SP4.EventType.receivedDownlink;
      case 0x30:
        return SP4.EventType.buttonShort;
      case 0x31:
        return SP4.EventType.buttonDouble;
      case 0x32:
        return SP4.EventType.buttonLong;
      case 0x62:
        return SP4.EventType.reedSwitchOn;
      case 0x63:
        return SP4.EventType.reedSwitchOff;
      case 0x81:
        return SP4.EventType.extraLongPress;
    }
  }
  extractPayload(frame) {
    if (!this.isEligibleToAppendPayload()) {
      return;
    }
    const maskInHexa = extractDataFromMessage(frame, [16, 8]);
    const extraDataLengthInBits = frame.length * 4 - 24;
    const extraData = extractDataFromMessage(frame, [24, extraDataLengthInBits]);
    const mask = hex2bin(maskInHexa);
    let offset = 0;
    for (let i = 0; i < mask.length; i++) {
      if (mask[i] === '1') {
        const extractionData = this.getPayloadConfiguration(i);
        this.extractData(extractionData.payload, extraData.slice(offset, extraData.length * 2));
        offset += extractionData.length * 2; // (1 byte <=> 2 chars)
      }
    }
  }
  isDownlinkRequest() {
    return typeof this.eventType !== 'undefined' && [SP4.EventType.extraLongPress, SP4.EventType.hearthBeat2].includes(this.eventType);
  }
  isEligibleToAppendPayload() {
    return typeof this.eventType !== 'undefined' && this.eventType !== SP4.EventType.extraLongPress;
  }
  isHearthBeat() {
    return typeof this.eventType !== 'undefined' && [SP4.EventType.hearthBeat1, SP4.EventType.hearthBeat2].includes(this.eventType);
  }
  isAnSP4BUTAlert() {
    return typeof this.eventType !== 'undefined' && [SP4.EventType.buttonShort, SP4.EventType.buttonDouble, SP4.EventType.buttonLong, SP4.EventType.reedSwitchOn].includes(this.eventType);
  }
  extractData(payload, message) {
    if (payload === SP4.AppendedPayload.voltage) {
      this.voltage = this.extractBatteryValue(message);
    } else if (payload === SP4.AppendedPayload.temperature) {
      this.temperature = this.extractTemperature(message);
    } else {
      this[payload] = message;
    }
  }
  /**
   * Returns the battery status from its voltage
   * @description https://ask.simplehw.eu/devices/battery-longevity-and-levels/#simplepack-3040-plus-rc1-and-rc3
  */
  extractBatteryValue(message) {
    const voltageInt = parseInt(extractDataFromMessage(message, [0, 4]), 16);
    const voltageDec = parseInt(extractDataFromMessage(message, [4, 4]), 16);
    const voltage = Number(`${voltageInt}.${voltageDec}`);
    if (voltage > 2.8) {
      return BatteryLevel.High; // 'Full power';
    } else if (voltage > 2.4) {
      return BatteryLevel.Medium; // 'Full power, medium range';
    } else if (voltage > 2.0) {
      return BatteryLevel.Low; // 'Weaker transmission range';
    } else if (voltage > 1.8) {
      return BatteryLevel.Critical; // 'Very low power';
    } else {
      return BatteryLevel.Critical; // 'Device stops transmitting';
    }
  }
  /**
   * Returns the temperature in Celsius
   * @description https://simplehw.atlassian.net/wiki/spaces/DOC/pages/23396515/API+6+Encoding#SimpleTemp
   */
  extractTemperature(message) {
    const tempInHex = parseInt(extractDataFromMessage(message, [0, 8]), 16);
    return -40 + tempInHex * 0.5;
  }
  getPayloadConfiguration(payloadIndex) {
    switch (payloadIndex) {
      case 0x00:
        return {
          payload: SP4.AppendedPayload.voltage,
          length: 1
        };
      case 0x01:
        return {
          payload: SP4.AppendedPayload.temperature,
          length: 1
        };
      case 0x02:
        return {
          payload: SP4.AppendedPayload.accelerometer,
          length: 3
        };
      case 0x03:
        return {
          payload: SP4.AppendedPayload.macAddress,
          length: 6
        };
      case 0x04:
        return {
          payload: SP4.AppendedPayload.threeBooleansValueAndHumidity,
          length: 1
        };
      case 0x05:
        return {
          payload: SP4.AppendedPayload.magnetometer,
          length: 3
        };
      case 0x06:
        return {
          payload: SP4.AppendedPayload.secondTemperature,
          length: 1
        };
      case 0x07:
      default:
        return {
          payload: SP4.AppendedPayload.specificBoolean,
          length: 1
        };
      // add default because max payload length is 8
    }
  }
}
var SP4;
(function (SP4) {
  let EventType;
  (function (EventType) {
    EventType["hearthBeat1"] = "hearthBeat1";
    EventType["hearthBeat2"] = "hearthBeat2";
    EventType["arming"] = "arming";
    EventType["armed"] = "armed";
    EventType["disarmed"] = "disarmed";
    EventType["receivedDownlinkAndRequest"] = "receivedDownlinkAndRequest";
    EventType["receivedDownlink"] = "receivedDownlink";
    EventType["buttonShort"] = "buttonShort";
    EventType["buttonDouble"] = "buttonDouble";
    EventType["buttonLong"] = "buttonLong";
    EventType["reedSwitchOn"] = "reedSwitchOn";
    EventType["reedSwitchOff"] = "reedSwitchOff";
    EventType["extraLongPress"] = "extraLongPress"; // Button press 6+ seconds, default way to request downlink
  })(EventType = SP4.EventType || (SP4.EventType = {}));
  let AppendedPayload;
  (function (AppendedPayload) {
    AppendedPayload["voltage"] = "voltage";
    AppendedPayload["temperature"] = "temperature";
    AppendedPayload["accelerometer"] = "accelerometer";
    AppendedPayload["macAddress"] = "macAddress";
    AppendedPayload["threeBooleansValueAndHumidity"] = "threeBooleansValueAndHumidity";
    AppendedPayload["magnetometer"] = "magnetometer";
    AppendedPayload["secondTemperature"] = "secondTemperature";
    AppendedPayload["specificBoolean"] = "specificBoolean";
  })(AppendedPayload = SP4.AppendedPayload || (SP4.AppendedPayload = {}));
  let Mode;
  (function (Mode) {
    Mode["factory"] = "factory";
    Mode["pressMe"] = "pressMe";
    Mode["guardMe"] = "guardMe";
    Mode["trackMe"] = "trackMe";
    Mode["traceMe"] = "traceMe";
    Mode["monitorMe"] = "monitorMe";
    Mode["putMeBack"] = "putMeBack";
    Mode["dontDropMe"] = "dontDropMe";
    Mode["reedSwitchRedundancy"] = "reedSwitchRedundancy";
    Mode["doorMode"] = "doorMode";
    Mode["leakDetector"] = "leakDetector";
    Mode["demoMode"] = "demoMode";
    Mode["reedSwitchOnOff"] = "reedSwitchOnOff";
    Mode["lightOnOff"] = "lightOnOff";
    Mode["temperatureThresholdWRedundancy"] = "temperatureThresholdWRedundancy";
    Mode["temperatureChangeWRedundancy"] = "temperatureChangeWRedundancy";
    Mode["temperatureThresholdAlert"] = "temperatureThresholdAlert";
    Mode["temperatureChangeAlert"] = "temperatureChangeAlert";
    Mode["reedSwitchCounter"] = "reedSwitchCounter";
    Mode["blinker"] = "blinker";
    Mode["stupidMode1"] = "stupidMode1";
    Mode["stupidMode2"] = "stupidMode2";
  })(Mode = SP4.Mode || (SP4.Mode = {}));
})(SP4 || (SP4 = {}));

// Doc : https://support.nexelec.fr/fr/support/solutions/articles/80001140735-guide-technique-guard-lorawan
class X8xxDecoder extends Decoder {
  constructor(frame) {
    super();
    this.productType = this.getProductType(frame);
    this.deviceType = this.getDeviceType();
    switch (this.getMessageType(frame)) {
      case X8xxLS.MessageType.productStatus:
        this.messageType = X8xxLS.MessageType.productStatus;
        this.setProductStatus(frame);
        break;
      case X8xxLS.MessageType.productConfiguration:
        this.messageType = X8xxLS.MessageType.productConfiguration;
        this.setProductConfiguration(frame);
        break;
      case X8xxLS.MessageType.smokeAlarmStatus:
        this.messageType = X8xxLS.MessageType.smokeAlarmStatus;
        this.setSmokeAlarmStatus(frame);
        break;
      case X8xxLS.MessageType.dailyAirQuality:
        this.messageType = X8xxLS.MessageType.dailyAirQuality;
        this.setDailyAirQuality(frame);
        break;
      case X8xxLS.MessageType.realTime:
        this.messageType = X8xxLS.MessageType.realTime;
        this.setRealTimeDataOutput(frame);
        break;
      case X8xxLS.MessageType.temperatureDataLog:
        this.messageType = X8xxLS.MessageType.temperatureDataLog;
        this.setTemperatureDataLog(frame);
        break;
      default:
        throw `unknown Message Type ${frame}`;
    }
  }
  getProductType(frame) {
    return valueOf(frame, [0, 8]);
  }
  getDeviceType() {
    switch (this.productType) {
      case X8xxLS.ProductType.originPlusLoRa:
        return DeviceType.X870LS;
      case X8xxLS.ProductType.originLoRa:
        return DeviceType.X865LS;
      case X8xxLS.ProductType.guardPlusLoRa:
        return DeviceType.X860LS;
      case X8xxLS.ProductType.guardLoRa:
        return DeviceType.X855LS;
      default:
        return;
    }
  }
  getMessageType(frame) {
    return valueOf(frame, [8, 8]);
  }
  setProductStatus(frame) {
    this.hardwareRevision = valueOf(frame, [16, 8]);
    this.softwareRevision = valueOf(frame, [24, 8]);
    this.remainingProductLifetime = getMatchingDate({
      months: scaleOf(valueOf(frame, [32, 8]), [0, 120])
    });
    this.smokeSensorStatus = valueOf(frame, [40, 1]);
    this.temperatureAndHumiditySensorStatus = valueOf(frame, [41, 1]);
    this.antiTearDetectionStatus = valueOf(frame, [43, 3]);
    this.batteryLevel = getBatteryLevel(valueOf(frame, [45, 2]));
    const a = valueOf(frame, [47, 8]);
    this.batteryVoltage = scaleOf(valueOf(frame, [47, 8]), [2000, 3250], 5, true);
  }
  setProductConfiguration(frame) {
    this.reconfigurationSource = valueOf(frame, [16, 3]);
    this.reconfigurationStatus = valueOf(frame, [19, 2]);
    this.datalogEnable = !!valueOf(frame, [21, 1]);
    this.dailyAirEnable = !!valueOf(frame, [22, 1]);
    this.pendingJoin = !!valueOf(frame, [24, 1]);
    this.nfcStatus = valueOf(frame, [25, 2]);
    this.datalogNewMeasure = valueOf(frame, [31, 6]);
    this.datalogMeasureRepetition = valueOf(frame, [37, 5]);
    this.transmissionIntervalDatalog = valueOf(frame, [42, 8]);
    this.d2dNetworkID = valueOf(frame, [50, 17]);
    this.timeZone = valueOf(frame, [67, 5]);
    this.downlinkCnt = valueOf(frame, [72, 16]);
  }
  setSmokeAlarmStatus(frame) {
    this.smokeAlarmStatus = valueOf(frame, [16, 2]);
    this.smokeAlarmHush = valueOf(frame, [18, 2]);
    this.smokeLocalProductTest = valueOf(frame, [20, 2]);
    this.timeSinceLastTest = valueOf(frame, [22, 8]);
    this.maintenanceDone = !!valueOf(frame, [30, 1]);
    this.lastMaintenance = getMatchingDate({
      weeks: valueOf(frame, [31, 8])
    });
    const rawTemperature = valueOf(frame, [39, 10]);
    this.currentTemperature = rawTemperature === 1022 ? undefined : scaleOf(rawTemperature, [-30, 70], 0.1, true);
  }
  setDailyAirQuality(frame) {
    this.minTemperature = scaleOf(valueOf(frame, [16, 10]), [-30, 70], 0.1);
    this.maxTemperature = scaleOf(valueOf(frame, [26, 10]), [-30, 70], 0.1);
    this.averageTemperature = scaleOf(valueOf(frame, [36, 10]), [-30, 70], 0.1);
    this.minRelativeHumidity = scaleOf(valueOf(frame, [46, 8]), [0, 100], 0.5);
    this.maxRelativeHumidity = scaleOf(valueOf(frame, [54, 8]), [0, 100], 0.5);
    this.averageRelativeHumidity = scaleOf(valueOf(frame, [62, 8]), [0, 100], 0.5);
  }
  setRealTimeDataOutput(frame) {
    this.averageTemperature = scaleOf(valueOf(frame, [16, 10]), [-30, 70], 0.1);
    this.averageRelativeHumidity = scaleOf(valueOf(frame, [26, 8]), [0, 100], 0.5);
  }
  setTemperatureDataLog(frame) {
    //Not implemented
  }
  static isProductStatusMessageType(decodedMessage) {
    return decodedMessage.messageType === X8xxLS.MessageType.productStatus;
  }
  static isSmokeAlarmMessageType(decodedMessage) {
    return decodedMessage.messageType === X8xxLS.MessageType.smokeAlarmStatus;
  }
  static isDailyAirQualityMessageType(decodedMessage) {
    return decodedMessage.messageType === X8xxLS.MessageType.dailyAirQuality;
  }
}
;
var X8xxLS;
(function (X8xxLS) {
  let ProductType;
  (function (ProductType) {
    ProductType[ProductType["originPlusLoRa"] = 189] = "originPlusLoRa";
    ProductType[ProductType["originLoRa"] = 178] = "originLoRa";
    ProductType[ProductType["guardPlusLoRa"] = 179] = "guardPlusLoRa";
    ProductType[ProductType["guardLoRa"] = 180] = "guardLoRa";
  })(ProductType = X8xxLS.ProductType || (X8xxLS.ProductType = {}));
  let MessageType;
  (function (MessageType) {
    MessageType[MessageType["productStatus"] = 0] = "productStatus";
    MessageType[MessageType["productConfiguration"] = 1] = "productConfiguration";
    MessageType[MessageType["smokeAlarmStatus"] = 2] = "smokeAlarmStatus";
    MessageType[MessageType["dailyAirQuality"] = 3] = "dailyAirQuality";
    MessageType[MessageType["realTime"] = 4] = "realTime";
    MessageType[MessageType["temperatureDataLog"] = 5] = "temperatureDataLog";
  })(MessageType = X8xxLS.MessageType || (X8xxLS.MessageType = {}));
  let AntiTearDetectionStatus;
  (function (AntiTearDetectionStatus) {
    AntiTearDetectionStatus[AntiTearDetectionStatus["magBaseNotDetected"] = 0] = "magBaseNotDetected";
    AntiTearDetectionStatus[AntiTearDetectionStatus["magBaseDetected"] = 1] = "magBaseDetected";
    AntiTearDetectionStatus[AntiTearDetectionStatus["tearJustDetected"] = 2] = "tearJustDetected";
    AntiTearDetectionStatus[AntiTearDetectionStatus["magBaseJustDetected"] = 3] = "magBaseJustDetected";
    AntiTearDetectionStatus[AntiTearDetectionStatus["magBaseNeverDetected"] = 4] = "magBaseNeverDetected";
  })(AntiTearDetectionStatus = X8xxLS.AntiTearDetectionStatus || (X8xxLS.AntiTearDetectionStatus = {}));
  let ReconfigurationSource;
  (function (ReconfigurationSource) {
    ReconfigurationSource[ReconfigurationSource["NFC"] = 0] = "NFC";
    ReconfigurationSource[ReconfigurationSource["Downlink"] = 1] = "Downlink";
    ReconfigurationSource[ReconfigurationSource["ProductStartUp"] = 2] = "ProductStartUp";
    ReconfigurationSource[ReconfigurationSource["Local"] = 5] = "Local";
  })(ReconfigurationSource = X8xxLS.ReconfigurationSource || (X8xxLS.ReconfigurationSource = {}));
  let ReconfigurationState;
  (function (ReconfigurationState) {
    ReconfigurationState[ReconfigurationState["TotalSuccess"] = 0] = "TotalSuccess";
    ReconfigurationState[ReconfigurationState["PartialSuccess"] = 1] = "PartialSuccess";
    ReconfigurationState[ReconfigurationState["TotalFailure"] = 2] = "TotalFailure";
    ReconfigurationState[ReconfigurationState["Reserved"] = 3] = "Reserved";
  })(ReconfigurationState = X8xxLS.ReconfigurationState || (X8xxLS.ReconfigurationState = {}));
  let NFCStatus;
  (function (NFCStatus) {
    NFCStatus[NFCStatus["Visible"] = 0] = "Visible";
    NFCStatus[NFCStatus["Unvisible"] = 1] = "Unvisible";
    NFCStatus[NFCStatus["RFU1"] = 2] = "RFU1";
    NFCStatus[NFCStatus["RFU2"] = 3] = "RFU2";
  })(NFCStatus = X8xxLS.NFCStatus || (X8xxLS.NFCStatus = {}));
  let SmokeAlarmStatus;
  (function (SmokeAlarmStatus) {
    SmokeAlarmStatus[SmokeAlarmStatus["nonActivated"] = 0] = "nonActivated";
    SmokeAlarmStatus[SmokeAlarmStatus["activatedShortRange"] = 1] = "activatedShortRange";
    SmokeAlarmStatus[SmokeAlarmStatus["activatedLongRange"] = 2] = "activatedLongRange";
  })(SmokeAlarmStatus = X8xxLS.SmokeAlarmStatus || (X8xxLS.SmokeAlarmStatus = {}));
  let SmokeAlarmHushReason;
  (function (SmokeAlarmHushReason) {
    SmokeAlarmHushReason[SmokeAlarmHushReason["noSmokeAnymore"] = 0] = "noSmokeAnymore";
    SmokeAlarmHushReason[SmokeAlarmHushReason["centralButtonPress"] = 1] = "centralButtonPress";
    SmokeAlarmHushReason[SmokeAlarmHushReason["distanceSilence"] = 2] = "distanceSilence";
  })(SmokeAlarmHushReason = X8xxLS.SmokeAlarmHushReason || (X8xxLS.SmokeAlarmHushReason = {}));
  let SmokeTestStatus;
  (function (SmokeTestStatus) {
    SmokeTestStatus[SmokeTestStatus["off"] = 0] = "off";
    SmokeTestStatus[SmokeTestStatus["localSmokeTest"] = 1] = "localSmokeTest";
    SmokeTestStatus[SmokeTestStatus["remoteSmokeTest"] = 2] = "remoteSmokeTest";
  })(SmokeTestStatus = X8xxLS.SmokeTestStatus || (X8xxLS.SmokeTestStatus = {}));
})(X8xxLS || (X8xxLS = {}));

// Definition of the different packet types and subtypes.
var EventType = /*#__PURE__*/function (EventType) {
  EventType[EventType["sp1"] = 1] = "sp1";
  EventType[EventType["sp4"] = 4] = "sp4";
  EventType[EventType["sp9"] = 9] = "sp9";
  EventType[EventType["ap1"] = 10] = "ap1"; //  (status code, status data): event based -> Max 5 AP packets per month, no retransmissions
  return EventType;
}(EventType || {});
var StdSubType = /*#__PURE__*/function (StdSubType) {
  StdSubType[StdSubType["bcdCoded"] = 0] = "bcdCoded";
  StdSubType[StdSubType["binUnitScal"] = 1] = "binUnitScal";
  StdSubType[StdSubType["binProdScal"] = 2] = "binProdScal";
  StdSubType[StdSubType["hNLTwoBytes"] = 3] = "hNLTwoBytes";
  StdSubType[StdSubType["bucket"] = 4] = "bucket";
  StdSubType[StdSubType["ch1BinCh2Ts"] = 5] = "ch1BinCh2Ts";
  StdSubType[StdSubType["six"] = 6] = "six";
  StdSubType[StdSubType["seven"] = 7] = "seven";
  StdSubType[StdSubType["eight"] = 8] = "eight";
  return StdSubType;
}(StdSubType || {});
var SP9SubType = /*#__PURE__*/function (SP9SubType) {
  SP9SubType[SP9SubType["sp9_0"] = 0] = "sp9_0";
  SP9SubType[SP9SubType["sp9_1"] = 1] = "sp9_1";
  SP9SubType[SP9SubType["sp9_2"] = 2] = "sp9_2";
  SP9SubType[SP9SubType["sp9_3"] = 3] = "sp9_3"; // sent immediately after first activation (max 2 retrans.), once the next day, and from then every 6 months -> no retransmission except on first day
  return SP9SubType;
}(SP9SubType || {});
var PRDayValue = /*#__PURE__*/function (PRDayValue) {
  PRDayValue[PRDayValue["BatteryEOL"] = 512] = "BatteryEOL";
  PRDayValue[PRDayValue["SmokeChamberPollutionPreWarning"] = 2048] = "SmokeChamberPollutionPreWarning";
  PRDayValue[PRDayValue["SmokeChamberPollutionWarningTestButtonFailure"] = 4096] = "SmokeChamberPollutionWarningTestButtonFailure";
  PRDayValue[PRDayValue["AcousticAlarmFailure"] = 8192] = "AcousticAlarmFailure";
  PRDayValue[PRDayValue["RemovalDetection"] = 32768] = "RemovalDetection";
  PRDayValue[PRDayValue["TestAlarm"] = 1] = "TestAlarm";
  PRDayValue[PRDayValue["SmokeAlarm"] = 2] = "SmokeAlarm";
  PRDayValue[PRDayValue["ObstructionDetection"] = 4] = "ObstructionDetection";
  PRDayValue[PRDayValue["SurroundingAreaMonitoring"] = 8] = "SurroundingAreaMonitoring";
  PRDayValue[PRDayValue["LEDFailure"] = 16] = "LEDFailure";
  return PRDayValue;
}(PRDayValue || {});
var PRStatusSummaryMasks = /*#__PURE__*/function (PRStatusSummaryMasks) {
  PRStatusSummaryMasks[PRStatusSummaryMasks["Removal"] = 256] = "Removal";
  PRStatusSummaryMasks[PRStatusSummaryMasks["BatteryEOL"] = 1024] = "BatteryEOL";
  PRStatusSummaryMasks[PRStatusSummaryMasks["AcousticAlarmFailure"] = 2048] = "AcousticAlarmFailure";
  PRStatusSummaryMasks[PRStatusSummaryMasks["ObstructionDetection"] = 4096] = "ObstructionDetection";
  PRStatusSummaryMasks[PRStatusSummaryMasks["SurroundingAreaMonitoring"] = 8192] = "SurroundingAreaMonitoring";
  return PRStatusSummaryMasks;
}(PRStatusSummaryMasks || {});
//TODO Mask non saisie
var EDCStatusSummaryMasks = /*#__PURE__*/function (EDCStatusSummaryMasks) {
  EDCStatusSummaryMasks[EDCStatusSummaryMasks["Removal"] = 256] = "Removal";
  EDCStatusSummaryMasks[EDCStatusSummaryMasks["BatteryWarning"] = 512] = "BatteryWarning";
  EDCStatusSummaryMasks[EDCStatusSummaryMasks["BatteryEOL"] = 1024] = "BatteryEOL";
  EDCStatusSummaryMasks[EDCStatusSummaryMasks["HWError"] = 2048] = "HWError";
  EDCStatusSummaryMasks[EDCStatusSummaryMasks["Tamper"] = 8192] = "Tamper";
  EDCStatusSummaryMasks[EDCStatusSummaryMasks["NoConsumption"] = 4096] = "NoConsumption";
  EDCStatusSummaryMasks[EDCStatusSummaryMasks["ReverseInstallation"] = 4096] = "ReverseInstallation";
  EDCStatusSummaryMasks[EDCStatusSummaryMasks["Leak"] = 4096] = "Leak";
  EDCStatusSummaryMasks[EDCStatusSummaryMasks["Burst"] = 4096] = "Burst"; // Bit 15
  return EDCStatusSummaryMasks;
}(EDCStatusSummaryMasks || {});
var AsyncStatusCode = /*#__PURE__*/function (AsyncStatusCode) {
  AsyncStatusCode[AsyncStatusCode["Tamper"] = 1] = "Tamper";
  AsyncStatusCode[AsyncStatusCode["Removal"] = 2] = "Removal";
  AsyncStatusCode[AsyncStatusCode["Leak"] = 3] = "Leak";
  AsyncStatusCode[AsyncStatusCode["ReverseInstallation"] = 4] = "ReverseInstallation";
  AsyncStatusCode[AsyncStatusCode["BatteryWarning"] = 5] = "BatteryWarning";
  AsyncStatusCode[AsyncStatusCode["Oversized"] = 6] = "Oversized";
  AsyncStatusCode[AsyncStatusCode["Undersized"] = 7] = "Undersized";
  AsyncStatusCode[AsyncStatusCode["Error"] = 8] = "Error";
  AsyncStatusCode[AsyncStatusCode["OneFMode"] = 9] = "OneFMode";
  AsyncStatusCode[AsyncStatusCode["NoConsumption"] = 10] = "NoConsumption";
  AsyncStatusCode[AsyncStatusCode["Burst"] = 11] = "Burst";
  AsyncStatusCode[AsyncStatusCode["BatteryEOL"] = 12] = "BatteryEOL";
  AsyncStatusCode[AsyncStatusCode["Dry"] = 13] = "Dry";
  AsyncStatusCode[AsyncStatusCode["Frost"] = 14] = "Frost";
  AsyncStatusCode[AsyncStatusCode["Backflow"] = 15] = "Backflow";
  AsyncStatusCode[AsyncStatusCode["BatteryPreWarning"] = 16] = "BatteryPreWarning";
  AsyncStatusCode[AsyncStatusCode["SmokeChamberPollutionForewarning"] = 19] = "SmokeChamberPollutionForewarning";
  AsyncStatusCode[AsyncStatusCode["SmokeChamberPollutionWarning"] = 20] = "SmokeChamberPollutionWarning";
  AsyncStatusCode[AsyncStatusCode["PushButtonFailure"] = 21] = "PushButtonFailure";
  AsyncStatusCode[AsyncStatusCode["HornDriveLevel"] = 22] = "HornDriveLevel";
  AsyncStatusCode[AsyncStatusCode["TestAlarmReleased"] = 24] = "TestAlarmReleased";
  AsyncStatusCode[AsyncStatusCode["SmokeAlarmReleased"] = 25] = "SmokeAlarmReleased";
  AsyncStatusCode[AsyncStatusCode["IngressAperturesObstructionDetection"] = 26] = "IngressAperturesObstructionDetection";
  AsyncStatusCode[AsyncStatusCode["LEDFailure"] = 27] = "LEDFailure";
  AsyncStatusCode[AsyncStatusCode["ObjectInTheSurroundingAreaDetected"] = 28] = "ObjectInTheSurroundingAreaDetected";
  AsyncStatusCode[AsyncStatusCode["StatusSummary"] = 29] = "StatusSummary";
  AsyncStatusCode[AsyncStatusCode["CommAdapterCommLost"] = 30] = "CommAdapterCommLost";
  AsyncStatusCode[AsyncStatusCode["CommAdapterBatteryEOL"] = 31] = "CommAdapterBatteryEOL";
  return AsyncStatusCode;
}(AsyncStatusCode || {});
class ZENNLRDecoder extends Decoder {
  constructor(message, deviceType) {
    super();
    const bytes = this.fromHexToBytes(message);
    this.packetType = bytes[0] >> 4;
    switch (this.packetType) {
      case EventType.sp1:
        this.packetSubtype = this.setStdSubType(bytes);
        this.packetTypeInfo = "Synchronous packet";
        this.statusInfo = "Daily packet";
        this.decodeDayValue(bytes[4] << 24 | bytes[3] << 16 | bytes[2] << 8 | bytes[1], deviceType);
        break;
      case EventType.sp4:
        this.packetSubtype = this.setStdSubType(bytes);
        this.packetTypeInfo = "Synchronous packet";
        this.statusInfo = "Transmit only after reaching key date, from then on every month, max. 4 retransmission";
        this.keyDate = this.decodeDateAndTime(bytes[1] << 8 | bytes[0], false);
        this.decodeDayValue(bytes[6] << 24 | bytes[5] << 16 | bytes[4] << 8 | bytes[3], deviceType);
        this.decodeStatusSummary(bytes[8] << 8 | bytes[7], deviceType);
        break;
      case EventType.sp9:
        this.packetTypeInfo = "Synchronous packet";
        this.packetSubtype = bytes[0] & 0x0F;
        switch (this.packetSubtype) {
          case SP9SubType.sp9_0:
            this.currentTime = this.decodeDateAndTime(bytes[1] << 24 | bytes[2] << 16 | bytes[3] << 8 | bytes[4], true);
            break;
          case SP9SubType.sp9_1:
            this.statusInfo = "Monthly packet with status summary";
            this.currentTime = this.decodeDateAndTime(bytes[1] << 24 | bytes[2] << 16 | bytes[3] << 8 | bytes[4], true);
            this.decodeStatusSummary(bytes[5] << 8 | bytes[6], deviceType);
            break;
          case SP9SubType.sp9_2:
            this.statusInfo = "Packet with device information (Sent immediately after first activation and from then on every 6 months)";
            this.firmwareVersion = ((bytes[1] << 24) + (bytes[2] << 16) + (bytes[3] << 8) + bytes[4]).toString(16).toUpperCase();
            this.loraWanVersion = bytes[5].toString(16) + "." + bytes[6].toString(16) + "." + bytes[7].toString(16);
            this.loraCommandVersion = bytes[9].toString(16) + "." + bytes[8].toString(16);
            this.deviceType = bytes[10].toString(16);
            this.meterId = Math.abs((bytes[11] << 24) + (bytes[12] << 16) + (bytes[13] << 8) + bytes[14]).toString(16).toUpperCase();
            break;
          case SP9SubType.sp9_3:
            this.statusInfo = "Packet with device information (sent immediately after first activation (max 2 retrans.), once the next day, and from then every 6 months -> no retransmission except on first day)";
            this.serialNumber = ((bytes[2] << 0) + (bytes[3] << 8) + (bytes[4] << 16) + (bytes[5] << 24)).toString(16).toUpperCase();
            break;
          default:
            throw new Error('Unknown SP9 Subtypes');
        }
        break;
      case EventType.ap1:
        this.packetTypeInfo = "Asynchronous packet";
        this.statusInfo = "Event based packet";
        this.decodeStatusCode(bytes[1], deviceType);
        break;
      default:
        throw new Error('Unhandled Std Subtype');
    }
  }
  fromHexToBytes(hex) {
    const bytes = [];
    for (let c = 0; c < hex.length; c += 2) bytes.push(parseInt(hex.slice(c, c + 2), 16));
    return bytes;
  }
  setStdSubType(bytes) {
    const n = bytes[0] & 0x0F;
    switch (n) {
      case StdSubType.binUnitScal:
        return StdSubType.binUnitScal;
      default:
        throw new Error('Unhandled Std Subtype');
    }
  }
  // if isTime = false, minute and hour are set to 0; and bytes only includes day, month, year
  decodeDateAndTime(bytes4, isTime) {
    const minute = isTime ? (bytes4 & 0x3F000000) >> 24 : 0;
    const hour = isTime ? (bytes4 & 0x001F0000) >> 16 : 0;
    const day = (bytes4 & 0x00001F00) >> 8;
    const month = bytes4 & 0x0000000F;
    const year = (bytes4 & 0x0000E000) >> 10 | (bytes4 & 0x000000F0) >> 4;
    const dateIso = "20" + year.toString().padStart(2, "0") + "-" + month.toString().padStart(2, "0") + "-" + day.toString().padStart(2, "0") + "T" + hour.toString().padStart(2, "0") + ":" + minute.toString().padStart(2, "0") + ":00Z";
    return new Date(dateIso);
  }
  decodeDayValue(dayValue4Bytes, deviceType) {
    if (deviceType === DeviceType.ZEPRLR) {
      this.isRemoval = (dayValue4Bytes & PRDayValue.RemovalDetection) === PRDayValue.RemovalDetection;
      this.isBatteryEOL = (dayValue4Bytes & PRDayValue.BatteryEOL) === PRDayValue.BatteryEOL;
      this.isObstructionDetect = (dayValue4Bytes & PRDayValue.ObstructionDetection) === PRDayValue.ObstructionDetection;
      this.isSmokeAlarm = (dayValue4Bytes & PRDayValue.SmokeAlarm) === PRDayValue.SmokeAlarm;
      this.isObjectSurrounding = (dayValue4Bytes & PRDayValue.SurroundingAreaMonitoring) === PRDayValue.SurroundingAreaMonitoring;
    } else {
      this.value = dayValue4Bytes;
    }
  }
  decodeStatusSummary(statusSum2Bytes, deviceType) {
    if (deviceType === DeviceType.ZEPRLR) {
      this.isRemoval = (statusSum2Bytes & PRStatusSummaryMasks.Removal) === PRStatusSummaryMasks.Removal;
      this.isBatteryEOL = (statusSum2Bytes & PRStatusSummaryMasks.BatteryEOL) === PRStatusSummaryMasks.BatteryEOL;
      this.isObstructionDetect = (statusSum2Bytes & PRStatusSummaryMasks.ObstructionDetection) === PRStatusSummaryMasks.ObstructionDetection;
      this.isObjectSurrounding = (statusSum2Bytes & PRStatusSummaryMasks.SurroundingAreaMonitoring) === PRStatusSummaryMasks.SurroundingAreaMonitoring;
    } else {
      this.isBatteryEOL = (statusSum2Bytes & EDCStatusSummaryMasks.BatteryEOL) === EDCStatusSummaryMasks.BatteryEOL;
      this.isTamper = (statusSum2Bytes & EDCStatusSummaryMasks.Tamper) === EDCStatusSummaryMasks.Tamper;
      this.isReverseInstallation = (statusSum2Bytes & EDCStatusSummaryMasks.ReverseInstallation) === EDCStatusSummaryMasks.ReverseInstallation;
      this.isFlowBlock = (statusSum2Bytes & EDCStatusSummaryMasks.NoConsumption) === EDCStatusSummaryMasks.NoConsumption;
      this.isLeak = (statusSum2Bytes & EDCStatusSummaryMasks.Leak) === EDCStatusSummaryMasks.Leak;
    }
  }
  decodeStatusCode(statusByte1, deviceType) {
    if (deviceType !== DeviceType.ZEECDMINOLR)
      // Removal not available on Minomess module
      this.isRemoval = statusByte1 === AsyncStatusCode.Removal;
    this.isTamper = statusByte1 === AsyncStatusCode.Tamper;
    this.isLeak = statusByte1 === AsyncStatusCode.Leak;
    this.isFlowBlock = statusByte1 === AsyncStatusCode.NoConsumption;
    const reverse = statusByte1 === AsyncStatusCode.ReverseInstallation;
    const backflow = statusByte1 === AsyncStatusCode.Backflow;
    this.isReverseInstallation = reverse || backflow;
    this.isBatteryEOL = statusByte1 === AsyncStatusCode.BatteryEOL;
    this.isSmokeAlarm = statusByte1 === AsyncStatusCode.SmokeAlarmReleased;
    this.isObstructionDetect = statusByte1 === AsyncStatusCode.IngressAperturesObstructionDetection;
    this.isObjectSurrounding = statusByte1 === AsyncStatusCode.ObjectInTheSurroundingAreaDetected;
  }
}
var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  I870Lib: i870Lib,
  CALDecoder: CALDecoder,
  get CAL() {
    return CAL;
  },
  Decoder: Decoder,
  DMDecoder: DMDecoder,
  get DM() {
    return DM;
  },
  I870SFDecoder: I870SFDecoder,
  get I870SF() {
    return I870SF;
  },
  I870LRDecoder: I870LRDecoder,
  get I870LR() {
    return I870LR;
  },
  LDS02Decoder: LDS02Decoder,
  LHT65NLRDecoder: LHT65NLRDecoder,
  SP4Decoder: SP4Decoder,
  get SP4() {
    return SP4;
  },
  X8xxDecoder: X8xxDecoder,
  get X8xxLS() {
    return X8xxLS;
  },
  get EventType() {
    return EventType;
  },
  ZENNLRDecoder: ZENNLRDecoder
});
let data;
function build() {
  const _message = new Map(),
    _header = new Map(),
    _type = new Map(),
    _mapModel = new Map();
  let source = new Map(),
    action = new Map(),
    position = new Map(),
    alert = new Map(),
    handling = new Map(),
    report = new Map(),
    reportAct = new Map(),
    reportBattery = new Map(),
    reportWorn = new Map(),
    acknowledgment = new Map(),
    gpsFix = new Map(),
    pull = new Map(),
    system = new Map(),
    events = new Map(),
    downlinkError = new Map(),
    administration = new Map(),
    messageUp = new Map(),
    messageDown = new Map(),
    uplink = new Map(),
    downlink = new Map();
  source.set('button', BUTTON_ALERT_SOURCE);
  source.set('inactivity', INACTIVITY_ALERT_SOURCE);
  source.set('fall', FALL_ALERT_SOURCE);
  source.set('zoneExit', ZONE_EXIT_ALERT_SOURCE);
  source.set('wandering', WANDERING_ALERT_SOURCE);
  source.set('lowBattery', LOW_BATTERY_ALERT_SOURCE);
  source.set('criticalBattery', CRITICAL_BATTERY_ALERT_SOURCE);
  action.set('start', NEW_ALERT_ACTION);
  action.set('interrupted', CANCEL_ALERT_ACTION);
  action.set('acquitted', ACQUIT_ALERT_ACTION);
  action.set('position', POSITION_ACTION);
  position.set('hdop', ALERT_POSITION_HDOP);
  position.set('latitude', ALERT_POSITION_LAT);
  position.set('longitude', ALERT_POSITION_LNG);
  alert.set('source', source);
  alert.set('action', action);
  reportAct.set('activity', REPORT_INCLUDE_ACTIVITY);
  reportAct.set('noActivity', REPORT_WITHOUT_ACTIVITY);
  reportBattery.set('notAvailable', NO_BATTERY_LEVEL_AVAILABLE);
  reportBattery.set('notMeasured', NO_BATTERY_LEVEL_MEASURED);
  reportWorn.set('worn', DEVICE_WORN);
  reportWorn.set('notWorn', DEVICE_NOT_WORN);
  report.set('activity', reportAct);
  report.set('battery', reportBattery);
  report.set('worn', reportWorn);
  acknowledgment.set('settings', settings);
  gpsFix.set('gpsOk', GPS_MESSAGE_OK);
  gpsFix.set('gpsFail', GPS_MESSAGE_ERROR);
  pull.set('settings', settings);
  events.set(WDOG_LOG_NO_EVENT_NAME, WDOG_LOG_NO_EVENT);
  events.set(WDOG_LOG_ALERT_FALL_NAME, WDOG_LOG_ALERT_FALL);
  events.set(WDOG_LOG_ALERT_ZONE_EXIT_NAME, WDOG_LOG_ALERT_ZONE_EXIT);
  events.set(WDOG_LOG_ALERT_BUTTON_NAME, WDOG_LOG_ALERT_BUTTON);
  events.set(WDOG_LOG_ALERT_LOW_BATTERY_NAME, WDOG_LOG_ALERT_LOW_BATTERY);
  events.set(WDOG_LOG_ALERT_CRITICAL_BATTERY_NAME, WDOG_LOG_ALERT_CRITICAL_BATTERY);
  events.set(WDOG_LOG_CANCEL_ALERT_NAME, WDOG_LOG_CANCEL_ALERT);
  events.set(WDOG_LOG_ACQUIT_ALERT_NAME, WDOG_LOG_ACQUIT_ALERT);
  events.set(WDOG_LOG_GPS_NAME, WDOG_LOG_GPS);
  events.set(WDOG_LOG_BATTERY_CHECK_NAME, WDOG_LOG_BATTERY_CHECK);
  events.set(WDOG_LOG_SIGFOX_SIMPLE_NAME, WDOG_LOG_SIGFOX_SIMPLE);
  events.set(WDOG_LOG_SIGFOX_DOWNLINK_NAME, WDOG_LOG_SIGFOX_DOWNLINK);
  events.set(WDOG_LOG_RESET_NAME, WDOG_LOG_RESET);
  events.set(WDOG_LOG_INITIAL_STATE_NAME, WDOG_LOG_INITIAL_STATE);
  system.set('maxEvents', MAX_WATCHDOG_NUMBER);
  system.set('events', events);
  downlinkError.set('settings', settings);
  administration.set('systemError', system);
  administration.set('downlinkError', downlinkError);
  administration.set('energy', POWER_ENERGY);
  administration.set('gps', GPS_TEST);
  administration.set('battery', BATTERY_REPORT);
  messageUp.set('alert', alert);
  messageUp.set('handling', handling);
  messageUp.set('report', report);
  messageUp.set('acknowledgment', acknowledgment);
  messageUp.set('gps_fix', gpsFix);
  messageUp.set('pull', pull);
  messageUp.set('administration', administration);
  uplink.set('length', UPLINK_MESSAGE_LENGTH);
  uplink.set('header', HEADER);
  uplink.set('message', messageUp);
  messageDown.set('header', DOWNLINK_MESSAGE_HEADER_ASK_NEW_DOWNLINK);
  messageDown.set('settings', settings);
  downlink.set('length', DOWNLINK_MESSAGE_LENGTH);
  downlink.set('message', messageDown);
  _type.set('systemError', SYSTEM_ERROR);
  _type.set('downlinkError', DOWNLINK_ERROR);
  _type.set('energy', POWER_ENERGY);
  _type.set('gps', GPS_TEST);
  _type.set('battery', BATTERY_REPORT);
  _header.set('alert', ALERT_HEADER);
  _header.set('handling', HANDLING_HEADER);
  _header.set('report', REPORT_HEADER);
  _header.set('acknowledgement', ACKNOWLEDGMENT_DOWNLINK_HEADER);
  _header.set('gpsFix', GPSFIX_HEADER);
  _header.set('pull', PULL_HEADER);
  _header.set('administration', ADMINISTRATION_HEADER);
  _message.set('uplink', UPLINK_MESSAGE_LENGTH);
  _message.set('downlink', DOWNLINK_MESSAGE_LENGTH);
  _mapModel.set('uplink', uplink);
  _mapModel.set('downlink', downlink);
  return {
    _type,
    _header,
    _message,
    _mapModel
  };
}
function get(type) {
  if (!data) {
    data = build();
  }
  switch (type) {
    case 'type':
      return data._type;
    case 'header':
      return data._header;
    case 'message':
      return data._message;
    case 'mapModel':
      return data._mapModel;
  }
}
const type = get('type');
const header = get('header');
const message = get('message');
const mapModel = get('mapModel');
var generalSchema = /*#__PURE__*/Object.freeze({
  __proto__: null,
  type: type,
  header: header,
  message: message,
  mapModel: mapModel
});
function initSettings(...settings) {
  return settings.map(setting => ({
    "name": setting.name,
    "updatedToModule": true,
    "value": setting.defaultValue
  }));
}
// currently not used
const full = {
  "moduleID": null,
  "sigfoxID": null,
  "moduleOwner": null,
  "settings": initSettings(...Object.values(settingByName))
};
const CAW_1 = {
  "moduleID": null,
  "sigfoxID": null,
  "moduleOwner": null,
  "settings": initSettings(settingByName.locked, settingByName.button, settingByName.fall, settingByName.inactivity, settingByName.cancel_alert, settingByName.real_time_tracking, settingByName.unlock_key, settingByName.transport_status, settingByName.utc_time_zone, settingByName.clock_mode_analogDigit)
};
const CAW_2 = {
  "moduleID": null,
  "sigfoxID": null,
  "moduleOwner": null,
  "settings": initSettings(settingByName.locked, settingByName.button, settingByName.fall, settingByName.inactivity, settingByName.cancel_alert, settingByName.real_time_tracking, settingByName.unlock_key, settingByName.transport_status, settingByName.utc_time_zone, settingByName.current_absolute_time, settingByName.clock_mode_analogDigit, settingByName.date_mode, settingByName.button_long_pressure)
};
const CAW_3 = {
  "settings": initSettings(settingByName.locked, settingByName.button, settingByName.fall, settingByName.real_time_tracking, settingByName.unlock_key, settingByName.transport_status, settingByName.utc_time_zone, settingByName.current_absolute_time, settingByName.clock_mode_analogDigit, settingByName.date_mode, settingByName.button_long_pressure, settingByName.network_operator)
};
const CAW_4 = {
  "settings": initSettings(settingByName.locked, settingByName.button, settingByName.fall, settingByName.real_time_tracking, settingByName.unlock_key, settingByName.transport_status, settingByName.utc_time_zone, settingByName.current_absolute_time, settingByName.clock_mode_analogDigit, settingByName.date_mode, settingByName.button_long_pressure, settingByName.network_operator, settingByName.rtc_comp_4days_remote, settingByName.rm_time_1st_alert_message)
};
var moduleSchema = /*#__PURE__*/Object.freeze({
  __proto__: null,
  full: full,
  CAW_1: CAW_1,
  CAW_2: CAW_2,
  CAW_3: CAW_3,
  CAW_4: CAW_4
});
var mainModel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generalSchema: generalSchema,
  moduleSchema: moduleSchema
});

/**
 * Returns true if another downlink is needed (no settings module with parameter updatedToModule to false),
 * false if not.
 * @param message information sent by the module.
 */
function isOtherDownlinkNeeded(message) {
  const askNewDownlinkInDecimal = extractNumberFromMessage(message, ASK_NEW_DOWNLINK_IN_AKNOWLEDGMENT$1);
  if (askNewDownlinkInDecimal === ASK_NEW_DOWNLINK_IN_AKNOWLEDGMENT) {
    return true;
  } else if (askNewDownlinkInDecimal === NO_OTHER_DOWNLINK_IN_AKNOWLEDGMENT) {
    return false;
  } else {
    return null;
  }
}
;
/**
 * Extraction of the setting's IDs.
 * @param message information sent by the module.
 */
function extractSettingsIDs(message) {
  let offset = DOWNLINK_PAYLOAD_OFFSET + ASK_NEW_DOWNLINK_LENGTH;
  const settingsIDs = [];
  // Loop up to the size of a uplink message because the aknowledgment of the downlink message is returned by a
  // uplink message.
  while (offset < UPLINK_MESSAGE_LENGTH) {
    const settingID = extractSettingID(message, offset);
    if (settingID === NO_MORE_SETTING_ID) {
      break;
    }
    const setting = getSettingByID(settingID);
    if (setting == null) {
      throw new Error(`Unknown setting for setting ID '${settingID}'`);
    }
    settingsIDs.push(settingID);
    offset += DOWNLINK_DATA_ID_LENGTH + setting.length;
  }
  return settingsIDs;
}
;
/**
 * Retrieving the setting id (see the settings id in the moduleHelper).
 *
 * @param message information sent by the module.
 * @param offset offset of the id to extract
 */
function extractSettingID(message, offset) {
  const hexSettingID = extractDataFromMessage(message, [offset, DOWNLINK_DATA_ID_LENGTH]);
  return hex2dec(hexSettingID);
}
/**
 * Get the setting associated to the given `settingId`.
 *
 * @param settingId id of the setting.
 * @returns the setting length in bits or `null` if the `settingId` is not found.
 */
function getSettingByID(settingId) {
  return settingById[settingId] || null;
}
/**
 * Get the setting associated to the given `settingName`.
 *
 * @param settingName name of the setting.
 * @returns the setting length in bits or `null` if the `settingName` is not found.
 */
function getSettingByName(settingName) {
  return settingByName[settingName] || null;
}
var acknowledgment = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isOtherDownlinkNeeded: isOtherDownlinkNeeded,
  extractSettingsIDs: extractSettingsIDs,
  extractSettingID: extractSettingID,
  getSettingByID: getSettingByID,
  getSettingByName: getSettingByName
});

/**
 * Construction of a readable message describing the type of watchdog.
 * @param watchdogEvent
 * @param module todo : typer correctement module
 * @return string
 */
function buildWatchdogErrorMessage(watchdogEvent, module) {
  const watchdogTypeTypeString = getWatchdogTypeString(watchdogEvent);
  const message = 'Module : ' + module.sigfoxID + '\n Watchdog Type : ' + watchdogTypeTypeString;
  return message;
}
/**
 * Returns the watchdog type readable.
 * todo : A migrer en enum
 * @param watchdogType
 * @return *
 */
function getWatchdogTypeString(watchdogType) {
  switch (watchdogType) {
    case WDOG_LOG_NO_EVENT:
      return 'WDOG_LOG_NO_EVENT';
    case WDOG_LOG_ALERT_FALL:
      return 'WDOG_LOG_ALERT_FALL';
    case WDOG_LOG_ALERT_ZONE_EXIT:
      return 'WDOG_LOG_ALERT_ZONE_EXIT';
    case WDOG_LOG_ALERT_BUTTON:
      return 'WDOG_LOG_ALERT_BUTTON';
    case WDOG_LOG_ALERT_LOW_BATTERY:
      return 'WDOG_LOG_ALERT_LOW_BATTERY';
    case WDOG_LOG_ALERT_CRITICAL_BATTERY:
      return 'WDOG_LOG_ALERT_CRITICAL_BATTERY';
    case WDOG_LOG_CANCEL_ALERT:
      return 'WDOG_LOG_CANCEL_ALERT';
    case WDOG_LOG_ACQUIT_ALERT:
      return 'WDOG_LOG_ACQUIT_ALERT';
    case WDOG_LOG_GPS:
      return 'WDOG_LOG_GPS';
    case WDOG_LOG_BATTERY_CHECK:
      return 'WDOG_LOG_BATTERY_CHECK';
    case WDOG_LOG_SIGFOX_SIMPLE:
      return 'WDOG_LOG_SIGFOX_SIMPLE';
    case WDOG_LOG_SIGFOX_DOWNLINK:
      return 'WDOG_LOG_SIGFOX_DOWNLINK';
    case WDOG_LOG_RESET:
      return 'WDOG_LOG_RESET';
    case WDOG_LOG_INITIAL_STATE:
      return 'WDOG_LOG_INITIAL_STATE';
    default:
      return 'Unknown watchdog type';
  }
}
/**
 * Extracting the power value from the sigfox message.
 *
 * @param string message
 * @return number
 */
function extractPower(message) {
  let powerHex = extractDataFromMessage(message, POWER_ENERGY_REPORT_MESSAGE);
  return hexToSignedInt(powerHex);
}
/**
 * Extracting the tension value from the sigfox message.
 *
 * @param string message
 * @return number
 */
function extractTension(message) {
  return extractNumberFromMessage(message, TENSION_ENERGY_REPORT_MESSAGE);
}
/**
 * Extracting the current value from sigfox message.
 *
 * @param string message
 * @return number
 */
function extractCurrent(message) {
  const currentHex = extractDataFromMessage(message, CURRENT_ENERGY_REPORT_MESSAGE);
  return hexToSignedInt(currentHex);
}
/**
 * Extracting the firstGap value from sigfox message.
 *
 * @param string message
 * @return number
 */
function extractFirstGap(message) {
  const currentHex = extractDataFromMessage(message, ALTI_FIRST_GAP);
  return hex2dec(currentHex);
}
/**
 * Extracting the nextGap value from sigfox message.
 *
 * @param string message
 * @return number
 */
function extractNextGap(message) {
  const currentHex = extractDataFromMessage(message, ALTI_NEXT_GAP);
  return hex2dec(currentHex);
}
/**
 * Extracting the strongOccurrence value from sigfox message.
 *
 * @param message
 * @return
 */
function strongOccurrence(message) {
  const currentHex = extractDataFromMessage(message, ALTI_STRONG_OCCURRENCE);
  return hex2dec(currentHex);
}
/**
 * Build the described message
 *
 * @param message -> must be a ati_report message
 * @return string
 */
function buildAltiMessage(message) {
  return {
    FirstGap: `${extractFirstGap(message)} Pa`,
    NextGap: `${extractNextGap(message)} Pa`,
    StrongOccurrence: strongOccurrence(message) === 1
  };
}
function buildFeaturesStateMap(message) {
  const features = [];
  const OFFSET = 8;
  const expectedSettings = FEATURES_STATE_MAP_ID.size;
  for (let offset = OFFSET; offset <= expectedSettings * OFFSET; offset += OFFSET) {
    const hexValue = extractDataFromMessage(message, [offset, 8]);
    const binValue = hex2bin(hexValue);
    const id = +bin2dec(binValue.slice(4, 6));
    const state = +bin2dec(binValue.slice(6, 8));
    features.push({
      key: FEATURES_STATE_MAP_ID.get(id),
      value: FEATURES_STATE_MAP_STATE.get(state)
    });
  }
  return features;
}
var administration = /*#__PURE__*/Object.freeze({
  __proto__: null,
  buildWatchdogErrorMessage: buildWatchdogErrorMessage,
  getWatchdogTypeString: getWatchdogTypeString,
  extractPower: extractPower,
  extractTension: extractTension,
  extractCurrent: extractCurrent,
  extractFirstGap: extractFirstGap,
  extractNextGap: extractNextGap,
  strongOccurrence: strongOccurrence,
  buildAltiMessage: buildAltiMessage,
  buildFeaturesStateMap: buildFeaturesStateMap
});
const POSITIVE_GPS_DIRECTION = "0";
const NEGATIVE_GPS_DIRECTION = "1";
var PositionMessageType = /*#__PURE__*/function (PositionMessageType) {
  PositionMessageType[PositionMessageType["GpsPosition"] = 0] = "GpsPosition";
  PositionMessageType[PositionMessageType["GpsError"] = 1] = "GpsError";
  PositionMessageType[PositionMessageType["Beacons"] = 2] = "Beacons";
  return PositionMessageType;
}(PositionMessageType || {});
var PositionSource = /*#__PURE__*/function (PositionSource) {
  PositionSource["gpsEmbed"] = "gpsEmbed";
  PositionSource["sigfox"] = "sigfoxMeasure";
  PositionSource["lora"] = "loraMeasure";
  PositionSource["applicationMeasure"] = "applicationMeasure";
  PositionSource["beaconMeasure"] = "beaconMeasure";
  return PositionSource;
}(PositionSource || {});
function extractPositionMessage(message) {
  const gpsMessageType = extractDataFromMessage(message, GPS_FIX);
  switch (gpsMessageType) {
    case GPS_MESSAGE_OK:
      return PositionMessageType.GpsPosition;
    case GPS_MESSAGE_BEACON:
      return PositionMessageType.Beacons;
    case GPS_MESSAGE_ERROR:
    default:
      return PositionMessageType.GpsError;
  }
}
;
function getBatteryLvlFromErrPositionMsg(message) {
  return extractNumberFromMessage(message, BATTERY_LEVEL);
}
;
/**
 * Extraction of position (lat and lng) and signal accuracy from sigfox message.
 *
 * @param message
 * @return object position:lat, lng, hdop
 */
function parsePosition(message) {
  return {
    lat: extractFloat(message, ALERT_POSITION_LAT),
    lng: extractFloat(message, ALERT_POSITION_LNG),
    accuracy: hex2dec(extractDataFromMessage(message, ALERT_POSITION_HDOP)),
    source: PositionSource.gpsEmbed
  };
}
;
/**
 * Building the float of the position using the sigfox message.
 *
 * @param valueMessage
 * @return
 */
function changePositionUnit(valueMessage) {
  return valueMessage / Math.pow(10, 7);
}
;
/**
 * Extracting float from sigfox message.
 *
 * @param message sigfox message.
 * @param mask mask to apply to recover latitude or longitude data.
 * @return
 */
function extractFloat(message, mask) {
  // Direction
  let hexaDir = extractDataFromMessage(message, mask);
  let dir = hexToSignedInt(hexaDir);
  return changePositionUnit(dir);
}
;
var gpsPosition = /*#__PURE__*/Object.freeze({
  __proto__: null,
  POSITIVE_GPS_DIRECTION: POSITIVE_GPS_DIRECTION,
  NEGATIVE_GPS_DIRECTION: NEGATIVE_GPS_DIRECTION,
  get PositionMessageType() {
    return PositionMessageType;
  },
  get PositionSource() {
    return PositionSource;
  },
  extractPositionMessage: extractPositionMessage,
  getBatteryLvlFromErrPositionMsg: getBatteryLvlFromErrPositionMsg,
  parsePosition: parsePosition,
  changePositionUnit: changePositionUnit,
  extractFloat: extractFloat
});
var RSSIRange = /*#__PURE__*/function (RSSIRange) {
  RSSIRange[RSSIRange["minimum"] = -140] = "minimum";
  RSSIRange[RSSIRange["maximum"] = -40] = "maximum";
  return RSSIRange;
}(RSSIRange || {});
var SNRRange = /*#__PURE__*/function (SNRRange) {
  SNRRange[SNRRange["minimum"] = -20] = "minimum";
  SNRRange[SNRRange["maximum"] = 10] = "maximum";
  return SNRRange;
}(SNRRange || {});
var SpreadingFactor = /*#__PURE__*/function (SpreadingFactor) {
  SpreadingFactor[SpreadingFactor["SF12"] = 12] = "SF12";
  SpreadingFactor[SpreadingFactor["SF11"] = 11] = "SF11";
  SpreadingFactor[SpreadingFactor["SF10"] = 10] = "SF10";
  SpreadingFactor[SpreadingFactor["SF9"] = 9] = "SF9";
  SpreadingFactor[SpreadingFactor["SF8"] = 8] = "SF8";
  SpreadingFactor[SpreadingFactor["SF7"] = 7] = "SF7";
  return SpreadingFactor;
}(SpreadingFactor || {});
;
var ProximityConfidenceLevel = /*#__PURE__*/function (ProximityConfidenceLevel) {
  ProximityConfidenceLevel[ProximityConfidenceLevel["HIGH"] = 0] = "HIGH";
  ProximityConfidenceLevel[ProximityConfidenceLevel["MEDIUM"] = 1] = "MEDIUM";
  ProximityConfidenceLevel[ProximityConfidenceLevel["LOW"] = 2] = "LOW";
  return ProximityConfidenceLevel;
}(ProximityConfidenceLevel || {});
;
// Minimal score that a signal must reach to be part of the "best gateways"
const MINIMAL_SCORE_ACCEPTABLE = 40;
const RssiIndicator = {
  [SpreadingFactor.SF12]: {
    [ProximityConfidenceLevel.HIGH]: -120,
    [ProximityConfidenceLevel.MEDIUM]: -130
  },
  [SpreadingFactor.SF11]: {
    [ProximityConfidenceLevel.HIGH]: -119,
    [ProximityConfidenceLevel.MEDIUM]: -129
  },
  [SpreadingFactor.SF10]: {
    [ProximityConfidenceLevel.HIGH]: -117,
    [ProximityConfidenceLevel.MEDIUM]: -127
  },
  [SpreadingFactor.SF9]: {
    [ProximityConfidenceLevel.HIGH]: -113,
    [ProximityConfidenceLevel.MEDIUM]: -123
  },
  [SpreadingFactor.SF8]: {
    [ProximityConfidenceLevel.HIGH]: -110,
    [ProximityConfidenceLevel.MEDIUM]: -120
  },
  [SpreadingFactor.SF7]: {
    [ProximityConfidenceLevel.HIGH]: -107,
    [ProximityConfidenceLevel.MEDIUM]: -117
  }
};
const SnrIndicator = {
  [SpreadingFactor.SF12]: {
    [ProximityConfidenceLevel.HIGH]: -5,
    [ProximityConfidenceLevel.MEDIUM]: -15
  },
  [SpreadingFactor.SF11]: {
    [ProximityConfidenceLevel.HIGH]: -2,
    [ProximityConfidenceLevel.MEDIUM]: -12
  },
  [SpreadingFactor.SF10]: {
    [ProximityConfidenceLevel.HIGH]: 0,
    [ProximityConfidenceLevel.MEDIUM]: -10
  },
  [SpreadingFactor.SF9]: {
    [ProximityConfidenceLevel.HIGH]: 2,
    [ProximityConfidenceLevel.MEDIUM]: -8
  },
  [SpreadingFactor.SF8]: {
    [ProximityConfidenceLevel.HIGH]: 5,
    [ProximityConfidenceLevel.MEDIUM]: -5
  },
  [SpreadingFactor.SF7]: {
    [ProximityConfidenceLevel.HIGH]: 10,
    [ProximityConfidenceLevel.MEDIUM]: 0
  }
};
// Fonction pour normaliser une valeur dans une plage donnée
function normalize(value, min, max) {
  return (value - min) / (max - min);
}
/**
 * Calculate the signal score
 * @param snr
 * @returns  a score (number)
 */
function calculateSignalScore(snr, rssi) {
  const snrWeight = 0.7; // Poids du SNR (priorité forte sur le SNR)
  const rssiWeight = 0.3; // Poids du RSSI
  // Normalisation des valeurs selon les plages spécifiques à LoRaWAN
  const normalizedSNR = normalize(snr, SNRRange.minimum, SNRRange.maximum);
  const normalizedRSSI = normalize(rssi, RSSIRange.minimum, RSSIRange.maximum);
  return Math.round((snrWeight * normalizedSNR + rssiWeight * normalizedRSSI) * 10000) / 100;
}
// https://website-stack-production.s3.eu-west-3.amazonaws.com/lorawan_signal_fr_d03e685c4c.pdf
function sortAndNotateProximityConfidence(spreadingFactor, receivers) {
  return receivers.map(r => {
    return Object.assign(Object.assign({}, r), {
      signalScore: calculateSignalScore(r.Snr, r.Rssi),
      rssiIndicator: getIndicatorByRSSI(spreadingFactor, r.Rssi),
      snrIndicator: getIndicatorBySNR(spreadingFactor, r.Snr)
    });
  }).sort((a, b) => b.signalScore - a.signalScore);
}
function pickBestGateways(spreadingFactor, receivers) {
  if (!receivers.length) {
    return [];
  }
  const bestGateways = sortAndNotateProximityConfidence(spreadingFactor, receivers).filter(gw => gw.signalScore >= MINIMAL_SCORE_ACCEPTABLE);
  return bestGateways.slice(0, 2);
}
function getIndicatorBySNR(sf, snr) {
  if (snr >= SnrIndicator[sf][ProximityConfidenceLevel.HIGH]) {
    return ProximityConfidenceLevel.HIGH;
  }
  if (snr >= SnrIndicator[sf][ProximityConfidenceLevel.MEDIUM]) {
    return ProximityConfidenceLevel.MEDIUM;
  }
  return ProximityConfidenceLevel.LOW;
}
function getIndicatorByRSSI(sf, rssi) {
  if (rssi >= RssiIndicator[sf][ProximityConfidenceLevel.HIGH]) {
    return ProximityConfidenceLevel.HIGH;
  }
  if (rssi >= RssiIndicator[sf][ProximityConfidenceLevel.MEDIUM]) {
    return ProximityConfidenceLevel.MEDIUM;
  }
  return ProximityConfidenceLevel.LOW;
}

//
/**
 * Extraction du niveau de batterie du message
 * @param message : String information envoyé par le module
 * @return *
 */
function extractStateOfCharge(message) {
  const batteryLevel = extractNumberFromMessage(message, STATE_OF_CHARGE);
  if (batteryLevel >= 0 && batteryLevel <= 100) {
    return batteryLevel;
  }
  return -1;
}
;
/**
 * Extraction des activités
 * @param activityNumber : Number nombre d'activité à extraire
 * @param interval : Number interval temporel entre 2 mesures d'activité (en minutes)
 * @param message : String information envoyé par le module
 * @return Array
 */
function extractActivities(message) {
  let dateNow = Date.now();
  let activities = [];
  let intervalMs = 6 * 60 * 60 * 1000;
  for (let i = 0; i < 4; i++) {
    let activityMask = [];
    activityMask[0] = FIRST_ACTIVITY[0] + i * FIRST_ACTIVITY[1];
    activityMask[1] = FIRST_ACTIVITY[1];
    let activityValue = extractNumberFromMessage(message, activityMask);
    activities[i] = {
      'activityValue': activityValue,
      'interval': 360,
      'timeMs': dateNow - i * intervalMs
    };
  }
  return activities;
}
;
/**
 * Extract of UTC Timezone.
 * @param message
 * @return UtcTimezone from -12 to 12
 */
function extractUtcTimezone(message) {
  let utcTimezoneinHex = extractDataFromMessage(message, UTC_TIME_ZONE_CONFIG);
  if (utcTimezoneinHex[0] == "1") {
    utcTimezoneinHex = "f" + utcTimezoneinHex[1];
  }
  const utcTimezone = hexToSignedInt(utcTimezoneinHex);
  if (utcTimezone > 12 || utcTimezone < -12) {
    throw new Error("incoherent timezone : " + utcTimezone);
  }
  return utcTimezone;
}
var report = /*#__PURE__*/Object.freeze({
  __proto__: null,
  extractStateOfCharge: extractStateOfCharge,
  extractActivities: extractActivities,
  extractUtcTimezone: extractUtcTimezone
});

/**
 * @brief clone an object.
 * @example
 * const object = { att1: 0 att2: [0]}
 * const clone1 = clone(object); // { att1: 0, att2: [0]}
 * @param object - clonable object.
 * @param deep - true to make a deep clone. (default: true)
 * @returns - a perfect copy.
 */
function clone(object, deep = true) {
  return map(object, value => value, deep);
}
;
/**
 * @brief apply a transform function on each object's attributes.
 * @example
 * const object = { att1: 1, att2: -2, att3: -10 }
 * const mappedObject = map(object, value => abs(value)); // { att1: 1, att2: 2, att3: 10}
 * @param object - mappable object.
 * @param transform - (value, key, object, circular) called on each attributes.
 * @param deep - true to make a deep call. (default: false)
 * @returns - a mapped copy of the object.
 */
function map(object, transform, deep = false) {
  const reducer = (accumulator, value, key, source, circular) => {
    accumulator[key] = transform(value, key, source, circular);
    return accumulator;
  };
  const accumulator = Array.isArray(object) ? [] : {};
  return reduce(object, reducer, accumulator, deep);
}
;
/**
 * @brief apply a predicate function on each object's attributes.
 * @example
 * const object = { att1: '1', password: 'azerty', att2: '2'}
 * filter(object, (value, key) => key !== 'password'); // { att1: '1', att2: '2' }
 * @param object - filterable object.
 * @param predicate - (value, key, object, circular) boolean callback function.
 * @param [deep] - true to make a deep call. (default: false)
 * @returns - a filtered copy of the object.
 */
function filter(object, predicate, deep = false) {
  const reducer = (accumulator, value, key, source, circular) => {
    if (predicate(value, key, source, circular) === true) {
      if (Array.isArray(accumulator)) {
        accumulator.push(value);
      } else {
        accumulator[key] = value;
      }
    }
    return accumulator;
  };
  const accumulator = Array.isArray(object) ? [] : {};
  return reduce(object, reducer, accumulator, deep);
}
;
/**
 * @brief Reduce an object in an accumulator.
 * @example
 * const obj = { att1: 1, att2: 2, att3: 3 }
 * reduce(obj, (acc, value) => {
 *     acc.push(value);
 *     return acc;
 * }, []); // [1, 2, 3]
 * reduce(obj, (acc, value) => acc + value, 0); // 6
 * @param object -
 * @param callback - (accumulator, value, key, object, circular)
 * @param accumulator -
 * @returns the accumulator.
 */
function reduce(object, callback, accumulator, deep = false) {
  // JS support
  if (typeof object !== 'object') {
    throw new Error(`Invalid type: '${typeof object}'`);
  }
  const seenObjects = new WeakMap();
  function _reduce(object, accumulator) {
    seenObjects.set(object, accumulator);
    Object.keys(object).forEach(key => {
      let value = object[key];
      let circular = false;
      if (deep && typeof value === 'object' && value !== null) {
        const copy = seenObjects.get(value);
        if (copy !== undefined) {
          value = copy;
          circular = true;
        } else {
          value = _reduce(value, Array.isArray(value) ? [] : {});
        }
      }
      accumulator = callback(accumulator, value, key, object, circular);
    });
    seenObjects.delete(object);
    return accumulator;
  }
  ;
  return _reduce(object, accumulator);
}
;
/**
 * Check if an object has a given path.
 * @param object - root of the path.
 * @param path - path to test.
 * @returns true if the path is non-null.
 */
function hasPath(object, path) {
  // JS support
  if (!Array.isArray(path)) {
    return false;
  }
  return getPathValue(object, path) !== null;
}
;
/**
 * Get a deep value of an object or null if not exist.
 * @param object - the object to undermine.
 * @param path - the path to value.
 * @returns - deep value of an object or null if not exists.
 */
function getPathValue(object, path) {
  return path.reduce((reduceObject, key) => reduceObject && typeof reduceObject[key] !== 'undefined' ? reduceObject[key] : null, object);
}
;
/**
 * Set a value for a given path.
 * Create the path if it does not exist.
 * @param object - the root of the path.
 * @param path - the path of the value.
 * @param value - the new value.
 */
function setPathValue(object, path, value) {
  let lastIndex = path.length - 1;
  let o = object;
  for (let i = 0; i < lastIndex; i++) {
    // If the next key is a number, mean that the
    // current object must be an array.
    if (typeof path[i + 1] === 'number') {
      if (!Array.isArray(o[path[i]])) {
        o[path[i]] = [];
      }
    }
    // Next key is a string, mean that the
    // current object must be an object.
    else if (typeof o[path[i]] !== 'object') {
      o[path[i]] = {};
    }
    o = o[path[i]];
  }
  o[path[lastIndex]] = value;
}
;
function isDeepEqual(source, toCompare) {
  if (source === toCompare) {
    return true;
  } // Same references
  if (source instanceof Date && toCompare instanceof Date) {
    return source.getTime() === toCompare.getTime();
  } // Specific comparison
  if (typeof source !== 'object' || typeof toCompare !== 'object' || source === null || toCompare === null) {
    return false;
  } // Not same type or null
  if (source instanceof URL && toCompare instanceof URL) {
    return source.href === toCompare.href;
  } // Specific comparison
  const sourceKeys = Object.keys(source);
  const toCompareKeys = Object.keys(toCompare);
  if (sourceKeys.length !== toCompareKeys.length) {
    return false;
  } // properties length are not the same
  for (const key of sourceKeys) {
    if (!toCompareKeys.includes(key) || !isDeepEqual(source[key], toCompare[key])) {
      return false;
    } // properties length are not the same or not recursively equals
  }
  return true;
}
var data_utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  clone: clone,
  map: map,
  filter: filter,
  reduce: reduce,
  hasPath: hasPath,
  getPathValue: getPathValue,
  setPathValue: setPathValue,
  isDeepEqual: isDeepEqual
});
class DataModel {
  /**
   * Deletes all object attributes thar are not in the primary (child) model.
   */
  // to delete when all call are done with typed params
  normalize(dirtyObject) {
    // JS support
    if (typeof dirtyObject !== 'object') {
      return {};
    }
    return filter(dirtyObject, (_, key) => key in this);
  }
}

/**
 * Check if the feature pass in the event is available in the current software version
 * @returns : true if the feature is available, false if the softwareVersion is blacklisted, and a string error if the feature does not exist
 */
function isAvailableFeature(feature, softwareVersion) {
  if (!allFeaturesInfos.get(feature)) {
    throw new Error('the feature does not exist');
  }
  // JS support
  if (!Object.values(SOFTWARE_VERSIONS).includes(softwareVersion)) {
    throw new Error('the softwareVersion is unknown');
  }
  return !allFeaturesInfos.get(feature).includes(softwareVersion);
}
;
/**
 * Check the type of a feature
 * @returns : true if the feature pass is included in VERSION_FEATURE
 */
function isVersionFeature(feature) {
  return Object.values(VERSION_FEATURE).includes(feature);
}
/* Main blacklist : if the version name is in the list, the feature isn't available */
const allFeaturesInfos = getAllFeaturesInfos();
function getAllFeaturesInfos() {
  const allFeaturesInfos = new Map();
  allFeaturesInfos.set(VERSION_FEATURE.GPS_RELIABILITY_FIX, [SOFTWARE_VERSIONS.CAW_00_2_0, SOFTWARE_VERSIONS.CAW_00_2_1, SOFTWARE_VERSIONS.CAW_00_2_2, SOFTWARE_VERSIONS.CAW_00_2_3, SOFTWARE_VERSIONS.CAW_00_2_4]);
  allFeaturesInfos.set(VERSION_FEATURE.FALL_MODULE_SETTING, [SOFTWARE_VERSIONS.TBD]);
  allFeaturesInfos.set(VERSION_FEATURE.UTC_TIME_ZONE_SETTING, [SOFTWARE_VERSIONS.TBD]);
  allFeaturesInfos.set(VERSION_FEATURE.CLOCK_MODE_SETTING, [SOFTWARE_VERSIONS.TBD]);
  allFeaturesInfos.set(VERSION_FEATURE.DATE_MODE_SETTING, [SOFTWARE_VERSIONS.CAW_00_2_0, SOFTWARE_VERSIONS.CAW_00_2_1, SOFTWARE_VERSIONS.CAW_00_2_2, SOFTWARE_VERSIONS.CAW_00_2_3, SOFTWARE_VERSIONS.TBD]);
  allFeaturesInfos.set(VERSION_FEATURE.BUTTON_LONG_PRESSURE_SETTING, [SOFTWARE_VERSIONS.CAW_00_2_0, SOFTWARE_VERSIONS.CAW_00_2_1, SOFTWARE_VERSIONS.CAW_00_2_2, SOFTWARE_VERSIONS.CAW_00_2_3, SOFTWARE_VERSIONS.CAW_00_2_4, SOFTWARE_VERSIONS.TBD]);
  allFeaturesInfos.set(VERSION_FEATURE.EMBED_ERROR_LOG, [SOFTWARE_VERSIONS.CAW_00_2_0, SOFTWARE_VERSIONS.CAW_00_2_1, SOFTWARE_VERSIONS.CAW_00_2_2, SOFTWARE_VERSIONS.CAW_00_2_3, SOFTWARE_VERSIONS.CAW_00_2_4, SOFTWARE_VERSIONS.CAW_00_2_5, SOFTWARE_VERSIONS.TBD]);
  allFeaturesInfos.set(VERSION_FEATURE.EMBED_FEATURE_STATE_MAP, [SOFTWARE_VERSIONS.CAW_00_2_0, SOFTWARE_VERSIONS.CAW_00_2_1, SOFTWARE_VERSIONS.CAW_00_2_2, SOFTWARE_VERSIONS.CAW_00_2_3, SOFTWARE_VERSIONS.CAW_00_2_4, SOFTWARE_VERSIONS.CAW_00_2_5, SOFTWARE_VERSIONS.TBD]);
  allFeaturesInfos.set(VERSION_FEATURE.SYNC_TIME_BY_ANY_DOWNLINK, [SOFTWARE_VERSIONS.CAW_00_2_0, SOFTWARE_VERSIONS.CAW_00_2_1, SOFTWARE_VERSIONS.CAW_00_2_2, SOFTWARE_VERSIONS.CAW_00_2_3, SOFTWARE_VERSIONS.CAW_00_2_4, SOFTWARE_VERSIONS.CAW_00_2_5, SOFTWARE_VERSIONS.TBD]);
  allFeaturesInfos.set(VERSION_FEATURE.NETWORK_OPERATOR_SETTING, [SOFTWARE_VERSIONS.CAW_00_2_0, SOFTWARE_VERSIONS.CAW_00_2_1, SOFTWARE_VERSIONS.CAW_00_2_2, SOFTWARE_VERSIONS.CAW_00_2_3, SOFTWARE_VERSIONS.CAW_00_2_4, SOFTWARE_VERSIONS.CAW_00_2_5, SOFTWARE_VERSIONS.CAW_00_2_6, SOFTWARE_VERSIONS.CAW_00_2_7, SOFTWARE_VERSIONS.CAW_00_2_8, SOFTWARE_VERSIONS.TBD]);
  allFeaturesInfos.set(VERSION_FEATURE.CRON_SEQUENCE, [SOFTWARE_VERSIONS.CAW_00_2_0, SOFTWARE_VERSIONS.CAW_00_2_1, SOFTWARE_VERSIONS.CAW_00_2_2, SOFTWARE_VERSIONS.CAW_00_2_3, SOFTWARE_VERSIONS.CAW_00_2_4, SOFTWARE_VERSIONS.CAW_00_2_5, SOFTWARE_VERSIONS.CAW_00_2_6, SOFTWARE_VERSIONS.CAW_00_2_7, SOFTWARE_VERSIONS.CAW_00_2_8, SOFTWARE_VERSIONS.CAW_SF_3_0, SOFTWARE_VERSIONS.CAW_LR_3_0, SOFTWARE_VERSIONS.CAW_LR_3_1, SOFTWARE_VERSIONS.CAW_SF_3_1, SOFTWARE_VERSIONS.CAW_LR_3_2, SOFTWARE_VERSIONS.CAW_SF_3_2, SOFTWARE_VERSIONS.TBD]);
  allFeaturesInfos.set(VERSION_FEATURE.RTC_COMPENSATION_REMOTELY, [SOFTWARE_VERSIONS.CAW_00_2_0, SOFTWARE_VERSIONS.CAW_00_2_1, SOFTWARE_VERSIONS.CAW_00_2_2, SOFTWARE_VERSIONS.CAW_00_2_3, SOFTWARE_VERSIONS.CAW_00_2_4, SOFTWARE_VERSIONS.CAW_00_2_5, SOFTWARE_VERSIONS.CAW_00_2_6, SOFTWARE_VERSIONS.CAW_00_2_7, SOFTWARE_VERSIONS.CAW_00_2_8, SOFTWARE_VERSIONS.CAW_SF_3_0, SOFTWARE_VERSIONS.CAW_LR_3_0, SOFTWARE_VERSIONS.CAW_LR_3_1, SOFTWARE_VERSIONS.CAW_SF_3_1, SOFTWARE_VERSIONS.TBD]);
  allFeaturesInfos.set(VERSION_FEATURE.RM_TIME_1ST_ALERT_MESSAGE, [SOFTWARE_VERSIONS.CAW_00_2_0, SOFTWARE_VERSIONS.CAW_00_2_1, SOFTWARE_VERSIONS.CAW_00_2_2, SOFTWARE_VERSIONS.CAW_00_2_3, SOFTWARE_VERSIONS.CAW_00_2_4, SOFTWARE_VERSIONS.CAW_00_2_5, SOFTWARE_VERSIONS.CAW_00_2_6, SOFTWARE_VERSIONS.CAW_00_2_7, SOFTWARE_VERSIONS.CAW_00_2_8, SOFTWARE_VERSIONS.CAW_SF_3_0, SOFTWARE_VERSIONS.CAW_LR_3_0, SOFTWARE_VERSIONS.CAW_LR_3_1, SOFTWARE_VERSIONS.CAW_SF_3_1, SOFTWARE_VERSIONS.TBD]);
  return allFeaturesInfos;
}
class Measurement {
  constructor(obj) {
    this.id = obj.id;
    this.date = obj.date;
    this.value = obj.value;
    this.index = obj.index;
    this.waterTemperature = obj.waterTemperature;
  }
  static isValidDateFormat(date) {
    return isValidShortCalendarDateFormat(date) || isValidFullCalendarDateFormat(date);
  }
}
class AdminItem {
  constructor(object = {}) {
    this.id = object.id;
  }
  getID() {
    return this.id;
  }
}
class Aggregate extends AdminItem {
  constructor(object = {}) {
    super(object);
    this.month = object.month;
    this.totalB2C = object.totalB2C;
    this.totalB2B = object.totalB2B;
  }
  getMonth() {
    return this.month;
  }
  getTotalB2C() {
    return this.totalB2C;
  }
  getTotalB2B() {
    return this.totalB2B;
  }
  setMonth(date) {
    const now = date ? new Date(date) : new Date();
    const aggregateDate = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}`;
    this.month = aggregateDate;
    return this;
  }
  incrementTotals(businessType) {
    return this.setTotals(businessType, 1);
  }
  decrementTotals(businessType) {
    return this.setTotals(businessType, -1);
  }
  setTotals(businessType, value) {
    this.totalB2C = businessType === BUSINESS_TYPE.B2C ? value : 0;
    this.totalB2B = value - this.totalB2C;
    return this;
  }
}
class Counter extends AdminItem {
  constructor(object = {}) {
    super(object);
    this.count = object.count || 1;
  }
  getCount() {
    return this.count;
  }
}
class DeviceUseRate extends AdminItem {
  constructor(object) {
    super(object);
    this[DEVICE_USE_RATE_KEY.ACTIVE_GROUP] = object[DEVICE_USE_RATE_KEY.ACTIVE_GROUP];
    this[DEVICE_USE_RATE_KEY.ACTIVE_GROUP_AND_ASSOCIATED] = object[DEVICE_USE_RATE_KEY.ACTIVE_GROUP_AND_ASSOCIATED];
    this[DEVICE_USE_RATE_KEY.ACTIVE_GROUP_AND_ASSOCIATED_AND_OK] = object[DEVICE_USE_RATE_KEY.ACTIVE_GROUP_AND_ASSOCIATED_AND_OK];
    this.deviceType = object.deviceType;
    this.timeMs = object.timeMs;
  }
}
DEVICE_USE_RATE_KEY.ACTIVE_GROUP, DEVICE_USE_RATE_KEY.ACTIVE_GROUP_AND_ASSOCIATED, DEVICE_USE_RATE_KEY.ACTIVE_GROUP_AND_ASSOCIATED_AND_OK;
var Civility = /*#__PURE__*/function (Civility) {
  Civility["Male"] = "male";
  Civility["Female"] = "female";
  return Civility;
}(Civility || {});
var Language = /*#__PURE__*/function (Language) {
  Language["Francais"] = "fr";
  Language["English"] = "en";
  return Language;
}(Language || {});
class GeneralUser {
  constructor(object) {
    var _a;
    /** @deprecated - use getName() */
    this.firstName = "";
    /** @deprecated - use getName() */
    this.lastName = "";
    this.userID = object.userID;
    this.homeAddress = object.homeAddress;
    this.homeAddressGps = object.homeAddressGps;
    this.otherAddressGps = object.otherAddressGps;
    this.invalidPositionSource = object.invalidPositionSource;
    this.lastKnownPosition = object.lastKnownPosition;
    this.language = object.language || Language.Francais;
    this.additionalInformation = object.additionalInformation;
    this.alertDuration = object.alertDuration;
    this.bluelineaID = object.bluelineaID;
    this.cegedevPromID = object.cegedevPromID;
    this.confidentialInformation = object.confidentialInformation;
    this.civility = object.civility;
    this.name = (_a = object.name) !== null && _a !== void 0 ? _a : `${object.firstName} ${object.lastName}`;
    this.email = object.email;
    this.entryDate = object.entryDate;
    this.phoneNumber = object.phoneNumber;
    this.notificationEndpoints = object.notificationEndpoints;
    this.ivrExtension = object.ivrExtension;
    this.group = object.group;
    this.timeZone = object.timeZone;
    this.paymentInformations = object.paymentInformations;
    this.invoiceEmail = object.invoiceEmail;
    // handle deprecated versions (mobile app)
    this.firstName = this.getName();
    this.displayName = this.getFullName();
    this.whatsAppVerification = object.whatsAppVerification;
    this.whatsAppNumber = object.whatsAppNumber;
  }
  getFullName() {
    return this.additionalInformation ? `${this.getName()} ${this.additionalInformation}` : this.getName();
  }
  getUserID() {
    return this.userID;
  }
  getName() {
    return this.name;
  }
  getGroupID() {
    return this.group;
  }
  isB2B() {
    return !!this.group;
  }
  isB2C() {
    return !this.isB2B();
  }
  update(data) {
    for (const field in data) {
      const key = field;
      if (key !== 'userID') {
        //@ts-ignore
        this[key] = data[key];
      }
    }
    ;
  }
}
class Notification {
  constructor(notification) {
    this.token = notification.token;
    this.deviceOS = notification.deviceOS;
    this.targetArn = notification.targetArn;
    this.deviceID = notification.deviceID;
    this.appVersion = notification.appVersion;
  }
  static isValid(notification) {
    return typeof (notification === null || notification === void 0 ? void 0 : notification.token) === "string" && typeof notification.targetArn === "string" && notification.deviceOS in DeviceOS;
  }
}
class Invoice extends DataModel {
  constructor(object) {
    super();
    this.locale = object.locale || 'fr';
    this.type = object.type || TYPE.INVOICE; // invoice OR creditNote
    this.invoiceID = object.invoiceID || 'FYYYYMM0000000';
    this.userID = object.userID;
    this.createdAt = object.createdAt || new Date().getTime();
    this.creditTo = object.creditTo;
    this.endOfFreeService = object.endOfFreeService;
    this.currency = object.currency || CURRENCY.EUR;
    this.html = object.html || '';
    this.billingAddress = object.billingAddress && new CustomerAddress(object.billingAddress);
    this.shippingAddress = object.shippingAddress && new CustomerAddress(object.shippingAddress);
    this.billing = object.billing && new Billing(object.billing);
    this.taxRate = object.taxRate || DEFAULT_TAX_RATE;
    this.total = object.total || 0;
    this.total_noTax = object.total_noTax || 0;
    this.total_tax = object.total_tax || 0;
    this.total_noTaxPreDiscount = object.total_noTaxPreDiscount || 0;
    this.total_discount = object.total_discount || 0;
    this.discount = object.discount;
    this.shipping = new Shipping(Object.assign({}, object.shipping));
    this.lines = [];
    if (object.lines && object.lines.length > 0) {
      this.lines = object.lines.map(line => new InvoiceLine(Object.assign(Object.assign({}, line), {
        unitPriceNoTax: line.unitPriceNoTax || this.getNoVATPrice(line.unitPrice)
      })));
    }
    // Autocompute totals if none found
    if (this.total === 0 && this.total_discount === 0) {
      this.setTotals(object.discount);
    }
  }
  static getVATValue(price, priceNoTax) {
    if (isNaN(price) || isNaN(priceNoTax)) return 0;
    return price - priceNoTax;
  }
  /***************************************
   * STATIC CONSTANT GETTERS
   */
  static getLineI18n(lineCode) {
    return LINE_i18n[lineCode];
  }
  static getLinePrice(lineCode) {
    return LINE_PRICE[lineCode];
  }
  static getTypePrefix(invoiceType) {
    return invoiceType && PREFIX[invoiceType] || PREFIX[TYPE.INVOICE];
  }
  static getTemplateHTML() {
    return TEMPLATE$1.HTML;
  }
  static getTemplateCSS() {
    return TEMPLATE$1.CSS;
  }
  /***************************************
   * SETTERS
   */
  /**
   * Set new invoice ID and update HTML
   * @param newID new invoice ID
   */
  setInvoiceID(newID) {
    const prevID = this.invoiceID;
    this.invoiceID = newID;
    this.setHtml(this.html.replace(prevID, newID));
  }
  /**
   * Set invoice discount and recompute totals
   * @param discount
   */
  setDiscount(discount) {
    this.discount = discount;
    this.setTotals(discount);
  }
  /**
   * Compute invoice totals
   * @param discount
   */
  setTotals(discount) {
    let preTotal = this.getLinesTotal();
    this.total_noTaxPreDiscount = this.getNoVATPrice(preTotal);
    this.total_discount = this.setDiscountTotal(discount, this.total_noTaxPreDiscount);
    this.total_noTax = this.total_noTaxPreDiscount + this.total_discount;
    if (!this.shipping.taxFree) {
      this.total_noTax += this.getNoVATPrice(this.shipping.total);
    }
    this.total = this.getVATPrice(this.total_noTax);
    this.total_tax = Invoice.getVATValue(this.total, this.total_noTax);
    if (this.shipping.taxFree) {
      this.total += this.shipping.total;
    }
  }
  /**
   * Set invoice HTML
   * @param html
   */
  setHtml(html) {
    this.html = html;
  }
  /**
   * Convert some of the invoice's values to readable values for HTML generation
   */
  htmlReady() {
    const currencyValues = ['unitPrice', 'total'];
    const percentValues = ['taxRate'];
    const dateValues = ['createdAt', 'date', 'nextPayment'];
    let result = clone(this);
    if (result.shipping.taxFree === false) {
      result.shipping.total = this.getNoVATPrice(result.shipping.total);
    }
    if (result.billing.method) {
      result.billing.method = `invoice.paymentMethod.${result.billing.method}`;
    }
    result.lines.forEach(line => {
      const i18n = LINE_i18n[line.item];
      if (i18n) {
        if (line.item === LINE_CODE.SERVICEINC) {
          line.itemArgs = {
            nextPayment: this.endOfFreeService
          };
        }
        line.item = `invoice.${i18n}`;
      }
    });
    result = map(result, (value, key) => {
      // replace zero values
      if (currencyValues.findIndex(item => key.startsWith(item)) > -1 && value === 0) {
        return '-';
      }
      // add currency markers
      if (currencyValues.findIndex(item => key.startsWith(item)) > -1 && typeof value !== 'undefined' && !isNaN(value)) {
        return value.toFixed(2).replace('.', ',') + ' ' + CURRENCY_SYMBOL[this.currency];
      }
      // add percent markers
      if (percentValues.includes(key) && typeof value !== 'undefined' && !isNaN(value)) {
        return (value * 100).toFixed(0) + ' %';
      }
      // update date format
      if (dateValues.includes(key) && typeof value !== 'undefined' && value !== null) {
        const date = new Date(value);
        return [date.getDate().toString().padStart(2, '0'), (date.getMonth() + 1).toString().padStart(2, '0'), date.getFullYear()].join('/');
      }
      return value;
    }, true);
    return result;
  }
  getNoVATPrice(price) {
    if (!price || isNaN(price)) return 0;
    return price / (1 + this.taxRate);
  }
  getVATPrice(price) {
    if (!price || isNaN(price)) return 0;
    return price * (1 + this.taxRate);
  }
  getLinesTotal() {
    return this.lines.reduce((acc, item) => acc += item.total, 0);
  }
  setDiscountTotal(discount, total) {
    if (discount && discount.name && discount.name !== 'NONE') {
      const price = discount.amount || 0;
      if (price > 0) {
        this.lines.push(new InvoiceLine({
          item: `Code ${discount.name}`
        }));
        return price > total ? -total : -price;
      }
    }
    return 0;
  }
}
class CustomerAddress {
  constructor(object) {
    var _a;
    this.civility = object.civility;
    this.firstName = "";
    this.lastName = "";
    this.name = object.name || `${object.firstName} ${(_a = object.lastName) === null || _a === void 0 ? void 0 : _a.toUpperCase()}`;
    this.address = object.address;
    this.postalCode = object.postalCode;
    this.city = object.city;
    this.country = object.country;
  }
}
class Billing {
  constructor(object) {
    this.method = object.method;
    this.date = object.date instanceof Date ? object.date.getTime() : object.date;
  }
}
class InvoiceLine {
  constructor(object) {
    this.item = object.item;
    this.qty = object.qty || 1;
    this.unitPrice = object.unitPrice || 0;
    this.unitPriceNoTax = object.unitPriceNoTax || 0;
    this.total = this.qty * this.unitPrice;
  }
}
class Shipping {
  constructor(object) {
    this.taxFree = object.taxFree || false;
    this.total = object.total || 0;
  }
}
const DEFAULT_DATE_LOCALE = 'fr-FR';
const DEFAULT_DATE_OPTIONS = {
  timeZone: 'Europe/Paris',
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
};
class Contract extends DataModel {
  constructor(object) {
    super();
    this.locale = object.locale || 'fr';
    this.userID = object.userID || object.user && object.user.userID;
    this.date = object.date || new Date().getTime();
    this.subscriber = new Person(object.subscriber);
    this.user = new Person(object.user);
    this.subscription = object.subscription && object.subscription.name || object.subscription;
    this.itemTitle = object.itemTitle;
    this.coverage = new ContractNetworkCoverage(object.coverage);
    this.html = object.html || '';
  }
  /***************************************
   * STATIC CONSTANT GETTERS
   */
  static getTemplateHTML() {
    return TEMPLATE.HTML;
  }
  static getTemplateCSS() {
    return TEMPLATE.CSS;
  }
  /***************************************
   * SETTERS
   */
  /**
   * Set invoice HTML
   * @param html
   */
  setHtml(html) {
    this.html = html;
  }
  /**
   * Convert some of the contract's values to readable values for HTML generation
   */
  htmlReady() {
    let result = clone(this);
    const date = new Date(result.date);
    // @ts-ignore
    result.date = date.toLocaleString(DEFAULT_DATE_LOCALE, DEFAULT_DATE_OPTIONS);
    if (result.subscriber.civility) {
      result.subscriber.civility = `civility.${result.subscriber.civility}`;
    }
    if (result.user.civility) {
      result.user.civility = `civility.${result.user.civility}`;
    }
    if (result.coverage.outdoor) {
      result.coverage.outdoor = `OUTDOOR_COVERAGE.${result.coverage.outdoor}`;
    }
    if (result.coverage.indoor) {
      result.coverage.indoor = `INDOOR_COVERAGE.${result.coverage.indoor}`;
    }
    return result;
  }
}
class Person {
  constructor(object = {}) {
    this.userID = object.userID;
    this.civility = object.civility;
    this.firstName = "";
    this.lastName = "";
    this.name = object.name || `${object.firstName} ${object.lastName}`;
    this.homeAddress = object.homeAddress;
    this.phoneNumber = object.phoneNumber;
    this.email = object.email;
  }
}
class ContractNetworkCoverage {
  constructor(object = {}) {
    this.address = object.address;
    this.outdoor = object.outdoor;
    this.indoor = object.indoor;
  }
}

//todo : move from direct export to export through Location Model
// merge with gpsPosition
var ZoneExitType = /*#__PURE__*/function (ZoneExitType) {
  ZoneExitType["CIRCULAR"] = "circular";
  ZoneExitType["POLYGONAL"] = "polygonal";
  ZoneExitType["ROOM"] = "room";
  ZoneExitType["ROOMSET"] = "roomSet";
  ZoneExitType["PLACE"] = "place";
  return ZoneExitType;
}(ZoneExitType || {});
;
class GPS {
  constructor(object) {
    this.lat = object && object.lat || 181;
    this.lng = object && object.lng || 181;
    this.lat = +this.lat.toFixed(7);
    this.lng = +this.lng.toFixed(7);
  }
}
class Rules {
  constructor(object) {
    this.zone_exit_type = object && object.zone_exit_type || null;
    this.distanceAuthorize = object && object.distanceAuthorize || 1000;
    this.center = object && new GPS(object.center) || new GPS();
    this.address = object && new AddressZone(object.address) || new AddressZone();
    this.polygonal_points = [];
    if (object === null || object === void 0 ? void 0 : object.polygonal_points) {
      this.polygonal_points = object.polygonal_points.map(point => new GPS(point));
    }
  }
}
class AddressZone {
  constructor(object) {
    this.name = object && object.name || null;
    this.city = object && object.city || null;
    this.zipCode = object && object.zipCode || null;
  }
}
class ActionSet {
  constructor(action) {
    var _a, _b;
    this.actionSetID = action === null || action === void 0 ? void 0 : action.actionSetID;
    this.moduleID = (_a = action === null || action === void 0 ? void 0 : action.moduleID) !== null && _a !== void 0 ? _a : 'default';
    this.name = (_b = action === null || action === void 0 ? void 0 : action.name) !== null && _b !== void 0 ? _b : 'default';
    this.active = !!(action === null || action === void 0 ? void 0 : action.active);
    this.alertType = action === null || action === void 0 ? void 0 : action.alertType;
    this.smss = Array.isArray(action === null || action === void 0 ? void 0 : action.smss) && action.smss || [];
    this.emails = Array.isArray(action === null || action === void 0 ? void 0 : action.emails) && action.emails || [];
    this.technicalSmss = Array.isArray(action === null || action === void 0 ? void 0 : action.technicalSmss) && action.technicalSmss || [];
    this.technicalEmails = Array.isArray(action === null || action === void 0 ? void 0 : action.technicalEmails) && action.technicalEmails || [];
    this.whatsApps = Array.isArray(action === null || action === void 0 ? void 0 : action.whatsApps) && action.whatsApps || [];
    this.webhooks = Array.isArray(action === null || action === void 0 ? void 0 : action.webhooks) && action.webhooks || [];
    this.pushNotifications = Array.isArray(action === null || action === void 0 ? void 0 : action.pushNotifications) && action.pushNotifications || [];
    this.processID = typeof (action === null || action === void 0 ? void 0 : action.processID) === 'string' ? action.processID : undefined;
    this.timeRanges = Array.isArray(action === null || action === void 0 ? void 0 : action.timeRanges) && action.timeRanges.map(tr => new TimeRange(tr)) || [];
    this.latency = action === null || action === void 0 ? void 0 : action.latency;
    if (this.alertType === AlertType.ZONE_EXIT) {
      this.rules = new Rules(action.rules);
    }
    this.threshold = action === null || action === void 0 ? void 0 : action.threshold;
  }
  static getUniqueId() {
    let uid = '';
    for (let i = 0; i < 8; i++) {
      uid += ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
    }
    return uid;
  }
  static actionIsTechnicalFormat(actionName) {
    return [ActionSetAction.SEND_TECHNICAL_SMS, ActionSetAction.SEND_TECHNICAL_EMAIL].includes(actionName);
  }
  setProcessID(processID) {
    this[ActionSetAction.SPECIFIC_ACTION] = processID;
  }
  addAction(name, value) {
    if (!this[name].includes(value)) {
      if (name === ActionSetAction.CALL_WEBHOOKS) {
        this[name].push(new WebhookDetails(value));
      } else if (name === ActionSetAction.PUSH_NOTIFICATION) {
        this[name].push(value);
      } else {
        this[name].push(value);
      }
    }
  }
  containAlertProcess(processID) {
    return this[ActionSetAction.SPECIFIC_ACTION] === processID;
  }
  getProcessID() {
    return this[ActionSetAction.SPECIFIC_ACTION];
  }
  getAction(name) {
    return this[name];
  }
  getWebhooksActions() {
    return this.webhooks;
  }
  getWhatsAppActions() {
    return this.whatsApps;
  }
  getSimpleActions() {
    return {
      [ActionSetAction.SEND_EMAIL]: this[ActionSetAction.SEND_EMAIL],
      [ActionSetAction.SEND_SMS]: this[ActionSetAction.SEND_SMS],
      [ActionSetAction.SEND_TECHNICAL_EMAIL]: this[ActionSetAction.SEND_TECHNICAL_EMAIL],
      [ActionSetAction.SEND_TECHNICAL_SMS]: this[ActionSetAction.SEND_TECHNICAL_SMS],
      [ActionSetAction.SEND_WHATSAPP_MSG]: this[ActionSetAction.SEND_WHATSAPP_MSG],
      [ActionSetAction.CALL_WEBHOOKS]: this[ActionSetAction.CALL_WEBHOOKS],
      [ActionSetAction.PUSH_NOTIFICATION]: this[ActionSetAction.PUSH_NOTIFICATION]
    };
  }
  getAllActionSetActions() {
    return {
      [ActionSetAction.SPECIFIC_ACTION]: this[ActionSetAction.SPECIFIC_ACTION],
      [ActionSetAction.SEND_EMAIL]: this[ActionSetAction.SEND_EMAIL],
      [ActionSetAction.SEND_SMS]: this[ActionSetAction.SEND_SMS],
      [ActionSetAction.SEND_TECHNICAL_EMAIL]: this[ActionSetAction.SEND_TECHNICAL_EMAIL],
      [ActionSetAction.SEND_TECHNICAL_SMS]: this[ActionSetAction.SEND_TECHNICAL_SMS],
      [ActionSetAction.SEND_WHATSAPP_MSG]: this[ActionSetAction.SEND_WHATSAPP_MSG],
      [ActionSetAction.CALL_WEBHOOKS]: this[ActionSetAction.CALL_WEBHOOKS],
      [ActionSetAction.PUSH_NOTIFICATION]: this[ActionSetAction.PUSH_NOTIFICATION]
    };
  }
  /**
   *
   */
  isEqual(other) {
    return this.actionSetID === other.actionSetID && this.alertType === other.alertType && this.moduleID === other.moduleID && this.name === other.name && this.active === other.active && this.rules === other.rules && this.latency === other.latency && this.processID === other.processID && isDeepEqual(this.timeRanges.map(tr => tr.getRange()), other.timeRanges.map(tr => tr.getRange())) && isDeepEqual(this.smss, other.smss) && isDeepEqual(this.emails, other.emails) && isDeepEqual(this.technicalSmss, other.technicalSmss) && isDeepEqual(this.technicalEmails, other.technicalEmails) && isDeepEqual(this.webhooks, other.webhooks) && isDeepEqual(this.whatsApps, other.whatsApps) && isDeepEqual(this.pushNotifications, other.pushNotifications);
  }
  /**
   * Is there a valid action set for the whole actionSet ?
   */
  isEmpty() {
    return !this[ActionSetAction.SPECIFIC_ACTION] && Object.values(this.getSimpleActions()).filter(elem => elem.length > 0).length === 0;
  }
  /**
   * Insert a time range in the schedule list
   * Throw an error when the timeRange overlaps
   * @param {TimeRange} timeRange to delete
   */
  getActivatedTimeRange() {
    return this.timeRanges;
  }
  getRangeForADay(day) {
    const lowerLimit = day * 24 * 60;
    const upperLimit = (day + 1) * 24 * 60;
    const data = [];
    this.timeRanges.forEach(timeRange => {
      if (lowerLimit <= timeRange.getFrom() && upperLimit >= timeRange.getTo()) {
        data.push(timeRange);
      }
    });
    return data;
  }
  getTimeRangeSize() {
    return this.timeRanges.length;
  }
  addNewTimeRange(timeRange) {
    if (!this.isOverlapsingTimeRange(timeRange)) {
      this.timeRanges.push(timeRange);
    } else {
      throw new Error('invalid time range: overlaps');
    }
  }
  /**
   * Add timeRange for the dayList, throw an error if an overlaps is detected
   * @param absTimeRange no offset must be set, from and to value must be absolute
   * @param dayList values must be between [0;6]
   */
  addTimeRangeForDayList(absTimeRange, dayList) {
    const oneDayOffset = 24 * 60;
    dayList.forEach(day => {
      if (typeof day === 'number' && day >= 0 && day <= 6) {
        const timeRange = new TimeRange({
          from: absTimeRange.getFrom() + day * oneDayOffset,
          to: absTimeRange.getTo() + day * oneDayOffset
        }); // valid clone - only one level
        this.addNewTimeRange(timeRange);
      }
    });
  }
  /**
   * Remove a time range from the schedule list
   * Throw an error when the timeRange is not found
   * @param timeRange to delete
   */
  deleteTimeRange(timeRange) {
    const index = this.timeRanges.findIndex(elem => elem.getRange() === timeRange.getRange());
    if (index > -1) {
      this.timeRanges.splice(index, 1);
    } else {
      throw new Error('invalid time range: no item found');
    }
  }
  /**
   * Remove all time range from the schedule list of the day
   * @param day from 0 to 6
   */
  deleteDay(day) {
    this.getRangeForADay(day).forEach(timeRange => {
      this.deleteTimeRange(timeRange);
    });
  }
  /**
   *  Does the current moment belongs to a valid timeRange
   * @returns {boolean} Does we match a timeRange ?
   */
  isActive(arg) {
    var _a;
    const offset = getTimezoneOffset((arg === null || arg === void 0 ? void 0 : arg.timeZone) || 'Europe/Paris', arg === null || arg === void 0 ? void 0 : arg.date);
    const rightDate = new Date((((_a = arg === null || arg === void 0 ? void 0 : arg.date) === null || _a === void 0 ? void 0 : _a.getTime()) || Date.now()) + offset * 60 * 1000);
    const time = rightDate.getUTCDay() * 1440 + rightDate.getUTCHours() * 60 + rightDate.getUTCMinutes();
    return this.timeRanges.findIndex(elem => elem.isInRange(time)) !== -1;
  }
  /**
   * Does the new value range overlaps an existing time range?
   * @param {TimeRange} waitingTR time range to test
   * @returns {boolean} does it overlaps
   */
  isOverlapsingTimeRange(waitingTR) {
    return !!this.timeRanges.find(timeRange => timeRange.overlaps(waitingTR));
  }
  /**
   * Drop all the time ranges
   */
  purge() {
    this.timeRanges = [];
  }
}
var Threshold;
(function (Threshold) {
  function isValid(threshold) {
    return threshold && ['>', '<', '>=', '<='].includes(threshold.operator) && typeof threshold.value === "number";
  }
  Threshold.isValid = isValid;
  function isThresholdReach(temperature, threshold) {
    return Function(`'use strict'; return (${temperature}${threshold.operator}${threshold.value})`)();
  }
  Threshold.isThresholdReach = isThresholdReach;
})(Threshold || (Threshold = {}));
class TimeRange {
  constructor(object = {}) {
    if (typeof object.from !== 'number' || typeof object.to !== 'number') {
      throw new Error('invalid time range: missing argument');
    }
    if (!this.isValidOffset(object.from) || !this.isValidOffset(object.to)) {
      throw new Error('invalid time range: invalid argument');
    }
    this.from = object.from;
    this.to = object.to;
  }
  getFrom(absolute = true) {
    return absolute ? this.from : this.getDayRelativeOffset(this.from);
  }
  getTo(absolute = true) {
    return absolute ? this.to : this.getDayRelativeOffset(this.to);
  }
  /**
   * return a string used as an id
   */
  getRange() {
    return `${this.from}:${this.to}`;
  }
  /**
   * Does the current period is in the time range ?
   * @param {number} time in minute offset (starting on sunday)
   */
  isInRange(time) {
    return this.from <= time && time < this.to;
  }
  overlaps(tr) {
    return this.from <= tr.from && tr.from < this.to || this.from < tr.to && tr.to < this.to;
  }
  getDayRelativeOffset(time) {
    return time % (24 * 60);
  }
  /**
   * Only use by the constructor to control offset value range
   * @param offset value to test
   */
  isValidOffset(offset) {
    return offset >= 0 && offset <= 7 * 24 * 60;
  }
}
class Tag {
  constructor(tag) {
    var _a, _b;
    this.tagID = tag.tagID;
    this.value = tag.value;
    this.associatedUsers = (_a = tag.associatedUsers) !== null && _a !== void 0 ? _a : [];
    this.associatedDevices = (_b = tag.associatedDevices) !== null && _b !== void 0 ? _b : [];
  }
  static getUniqueId() {
    let uid = '';
    for (let i = 0; i < 8; i++) {
      uid += ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
    }
    return uid;
  }
}
var Alert = /*#__PURE__*/function (Alert) {
  Alert.Type = AlertType;
  Alert.AlgorithmType = AlgorithmsType;
  return Alert;
}(Alert || {});
const DEFAULT_NUMBER_OF_CYCLES = 3;
class AlertProcess {
  constructor(object) {
    this.processID = object === null || object === void 0 ? void 0 : object.processID;
    this.name = object === null || object === void 0 ? void 0 : object.name;
    this.description = object === null || object === void 0 ? void 0 : object.description;
    this.specificActionType = (object === null || object === void 0 ? void 0 : object.specificActionType) || SpecificActionType.FOLLOW_UP;
    this.algorithmType = object === null || object === void 0 ? void 0 : object.algorithmType;
    this.specificActionData = (object === null || object === void 0 ? void 0 : object.specificActionData) || [];
    this.callHelpedFirst = (object === null || object === void 0 ? void 0 : object.callHelpedFirst) || false;
    this.askHelperToCloseTheAlert = (object === null || object === void 0 ? void 0 : object.askHelperToCloseTheAlert) || false;
    this.askHelperToAcquitTheAlert = (object === null || object === void 0 ? void 0 : object.askHelperToAcquitTheAlert) || false;
    this.numberOfCycle = (object === null || object === void 0 ? void 0 : object.numberOfCycle) || DEFAULT_NUMBER_OF_CYCLES;
    this.chooseHelperByPosition = (object === null || object === void 0 ? void 0 : object.chooseHelperByPosition) || false;
    this.technicalFormat = (object === null || object === void 0 ? void 0 : object.technicalFormat) || true;
  }
}
class AlertSetting {
  constructor(object) {
    this.alertSettingID = object.alertSettingID;
    this.name = object.name;
    this.active = object.active || false;
    this.actions = [];
    if (object.actions) {
      this.actions = object.actions.map(action => new ActionSet(action));
    }
    if (this.name === AlertType.ZONE_EXIT) {
      this.rules = new Rules(object.rules);
    }
    if (this.name === AlertType.INACTIVITY) {
      this.latency = object.latency || 0;
    }
  }
  addActionSet(actionSet) {
    this.actions.push(actionSet);
  }
  hasValidActions() {
    return this.actions.findIndex(actionSet => !actionSet.isEmpty()) > -1;
  }
}
class Option {
  constructor(option) {
    this.name = option.name;
    this.type = option.type;
    this.equipment = option.equipment;
    this.unitPrice = option.unitPrice;
    this.shippingPrice = option.shippingPrice;
    this.qty = option.qty;
    ;
  }
  static getRentingTotal(options, discount) {
    return Option.getOptionsTotal(options, OptionType.RENTING, discount);
  }
  static getPurchasingTotal(options, discount) {
    return Option.getOptionsTotal(options, OptionType.PURCHASE, discount);
  }
  static getShippingTotal(options, discount) {
    const shippingPrice = options.filter(opt => !!opt.shippingPrice).reduce((total, opt) => total + opt.shippingPrice, 0) || 0;
    return discount ? discount.applyDiscount(shippingPrice, Applicability.SHIPPING) : shippingPrice;
  }
  static hasRentingOptions(options) {
    return options.filter(opt => opt.type === OptionType.RENTING).length > 0 || false;
  }
  static hasPurchaseOptions(options) {
    return options.filter(opt => opt.type === OptionType.PURCHASE).length > 0 || false;
  }
  static getOptionsTotal(options, type, discount) {
    const optionsPrice = options.filter(opt => opt.type === type).reduce((total, opt) => total + opt.unitPrice * opt.qty, 0) || 0;
    return discount ? discount.applyDiscount(optionsPrice, Applicability.OPTION) : optionsPrice;
  }
}
class Discount {
  constructor(discount) {
    this.name = discount.name;
    this.applicability = discount.applicability;
    this.validityDate = discount.validityDate; // American format 'MM/DD/YYYY'
    this.period = discount.period;
    this.recurringPeriod = discount.recurringPeriod;
    this.amount = discount.amount;
    this.type = discount.type;
  }
  /**
   * Is the discount code applicable
   * @param subscriptionName
   * @param isFirstPayment
   */
  isApplicable(subscriptionName = Applicability.ALL, isFirstPayment = true) {
    const notExpired = new Date() <= new Date(this.validityDate);
    const matchingSubscription = this.applicability === Applicability.ALL || this.applicability === Applicability.OPTION || this.applicability === Applicability.WATCH && subscriptionName.startsWith('economy') || this.applicability === Applicability.SERVICE && subscriptionName.startsWith('liberty') || this.applicability === Applicability.SERVICE && subscriptionName.startsWith('economy') && !isFirstPayment;
    const validPeriod = this.period === Periodicity.RECURRENT || isFirstPayment && this.period === Periodicity.ONCE;
    return notExpired && matchingSubscription && validPeriod;
  }
  /**
   * return the discounted price only for 'Option' or 'Shipping' types
   */
  applyDiscount(price, type) {
    if (new Date() > new Date(this.validityDate)) {
      return price;
    }
    if ([Applicability.OPTION, Applicability.SHIPPING].includes(this.applicability) && type === this.applicability) {
      return this.calculateFinalPrice(price);
    }
    return price;
  }
  calculateFinalPrice(price) {
    let finalPrice = 0;
    if (this.type === DiscountType.EUR) {
      finalPrice = price - this.amount;
    } else {
      finalPrice = price - price * (this.amount / 100);
    }
    return finalPrice > 0 ? finalPrice : 0;
  }
}
const AVOID_AMOUNT = 0.00001;
const SPECIAL_PATTERN = 'none';
class Subscription {
  constructor(object) {
    this.name = object.name;
    this.alreadyOwnWatch = object.alreadyOwnWatch;
    this.watchPrice = object.watchPrice;
    this.servicePrice = object.servicePrice;
    this.currency = object.currency || CURRENCY.EUR;
    this.debitingOffset = object.debitingOffset;
    this.firstDebitingOffset = object.firstDebitingOffset;
  }
  getCurrency() {
    return this.currency;
  }
  /**
   * For a subscription like 'none', no payment must be done
   * We only check if a watch & a service price are defined
   */
  isPaymentFree() {
    return this.name.toLowerCase().startsWith(SPECIAL_PATTERN) || this.watchPrice === 0 && this.servicePrice === 0;
  }
  /**
   * return service price depending of the discount
   * @param discount
   */
  getRentingOptionsPrice(options, discount) {
    const optionsPrice = options.filter(opt => opt.type === OptionType.RENTING).reduce((total, opt) => total + opt.unitPrice * opt.qty, 0) || 0;
    if ((discount === null || discount === void 0 ? void 0 : discount.applicability) && [Applicability.OPTION, Applicability.ALL].includes(discount.applicability)) {
      return discount.type === DiscountType.PERCENT ? optionsPrice * ((100 - discount.amount) / 100) : optionsPrice - discount.amount;
    } else {
      return optionsPrice;
    }
  }
  /**
   * return watch price in the following format xx,xx (currency)
   * @param discount to be applied
   * @param options to be applied
   * @param isFirstPayment
   * @returns ex: 12,00
   */
  getWatchPrice(discount, options = [], isFirstPayment = true) {
    let price = isFirstPayment ? this.watchPrice : 0;
    // add discount
    if (discount && price && (discount.applicability === Applicability.WATCH || discount.applicability === Applicability.ALL)) {
      // TODO: Fix duplicate code (Discount#calculateFinalPrice)
      if (discount.type === DiscountType.PERCENT) {
        if (discount.amount !== AVOID_AMOUNT) {
          price *= (100 - discount.amount) / 100;
        }
      } else {
        price -= discount.amount;
      }
      if (price < 0) {
        price = 0;
      }
    }
    // add options
    price += Option.getPurchasingTotal(options, discount);
    return price;
  }
  /**
   * Return the price of the service in function of discount coupon
   * @param discount to be applied
   * @param options to be applied
   * @param isFirstPayment
   * @returns ex: 12,00
   */
  getServicePrice(discount, options = [], isFirstPayment = false) {
    let price = !isFirstPayment ? this.servicePrice : 0;
    // add discount
    if (discount && price && (discount.applicability === Applicability.SERVICE || discount.applicability === Applicability.ALL)) {
      // TODO: Fix duplicate code (Discount#calculateFinalPrice)
      if (discount.type === DiscountType.PERCENT) {
        if (discount.amount !== AVOID_AMOUNT) {
          price *= (100 - discount.amount) / 100;
        }
      } else {
        price -= discount.amount;
      }
      if (price < 0) {
        price = 0;
      }
    }
    // add options
    price += Option.getRentingTotal(options, discount);
    return price;
  }
  /**
   * Return price in cents with two mandatory decimals 10€ => 1000
   * @param number
   */
  static formatPriceInCents(number) {
    return Math.floor(number * 100);
  }
  /**
   * Sum of getWatchPrice & getServicePrice
   * @param discount to be applied
   * @param options to be applied
   * @param isFirstPayment
   */
  getTotalPrice(discount, options = [], isFirstPayment = true) {
    return this.getWatchPrice(discount, options, isFirstPayment) + this.getServicePrice(discount, options, isFirstPayment);
  }
  /**
   * A payment is not mandatory on the subscription if the user already owns the watch and has no options
   */
  isPaymentMandatoryOnSubscription(options = []) {
    return !this.alreadyOwnWatch || !this.isPaymentFree() && options.length > 0;
  }
  /**
   * Return the date of the first payment
   * A subscription has two debit intervals, the first one and the payment occurrency
   * @param {number|string} [subscriptionDate]
   * @returns {Date}
   */
  getFirstDebittingDate(subscriptionDate) {
    const offsetDate = subscriptionDate && new Date(subscriptionDate) || new Date();
    offsetDate.setDate(offsetDate.getDate() + this.firstDebitingOffset);
    return offsetDate;
  }
  /**
   * Return the day of the first payment
   * A subscription has two debit interval, the first one and the payment occurrency
   * @param {number|string} [subscriptionDate]
   * @returns {string} : date in this format dd/mm/yyyy
   */
  getFirstDebittingDay(subscriptionDate) {
    const offsetDate = this.getFirstDebittingDate(subscriptionDate);
    return [offsetDate.getDate().toString().padStart(2, '0'), (offsetDate.getMonth() + 1).toString().padStart(2, '0'), offsetDate.getFullYear()].join('/');
  }
  /**
   * Checks whether today is the first payment day
   * @param subscriptionDate
   */
  isFirstPaymentDate(subscriptionDate) {
    if (this.firstDebitingOffset > 0) {
      const today = getCurrentDate();
      const offsetDate = new Date(subscriptionDate);
      offsetDate.setDate(offsetDate.getDate() + this.firstDebitingOffset);
      return offsetDate.getTime() === today.getTime();
    }
    return false;
  }
  /**
   * Checks whether today is the payment day
   * @param lastRecurringPayment
   * @param lastOneShotPayment
   * @param includeOptions Defines whether options are to be debited
   * @param subscriptionDate
   */
  isPaymentDate(lastRecurringPayment, lastOneShotPayment, includeOptions = false, subscriptionDate = '') {
    const today = getCurrentDate();
    const subDate = new Date(subscriptionDate);
    const isBeforeFirstRec = subDate.setDate(subDate.getDate() + this.firstDebitingOffset) >= today.getTime();
    const offsetDate = this.nextPayment(lastRecurringPayment, lastOneShotPayment, includeOptions, isBeforeFirstRec);
    if (offsetDate.getTime() < today.getTime()) {
      throw new Error(ERROR_MESSAGES.LATE_PAYMENT);
    }
    return offsetDate.getTime() === today.getTime();
  }
  /**
   * Returns the next payment date
   * @param lastRecurringPayment
   * @param lastOneShotPayment
   * @param includeOptions Defines whether options are to be debited
   * @param isBeforeFirstRec Define whether we go through the first reccuring (subscriptionDate < 6 month)
   */
  nextPayment(lastRecurringPayment, lastOneShotPayment, includeOptions = false, isBeforeFirstRec = false) {
    const offsetDate = new Date(lastRecurringPayment ? lastRecurringPayment : lastOneShotPayment);
    offsetDate.setHours(0, 0, 0, 0);
    const offset = !isBeforeFirstRec || isBeforeFirstRec && includeOptions || this.firstDebitingOffset === 0 ? this.debitingOffset : this.firstDebitingOffset;
    offsetDate.setDate(offsetDate.getDate() + offset);
    return offsetDate;
  }
}
class PaymentInformations {
  constructor(object) {
    this.discount = object.discount ? new Discount(object.discount) : undefined;
    this.lastPayment = object.lastPayment;
    this.options = object.options.map(o => new Option(o));
    this.subscriptionDate = object.subscriptionDate;
    this.subscription = new Subscription(object.subscription);
  }
  /**
   * Is the debit must be procceed today
   * @param lastRecurringPayment Force check on a different date than the user lastPayment recurring date
   * @param includeOptions
   * @returns true if the lastPaymentDate + debitingOffset === todays date
   */
  isPaymentDate(lastRecurringPayment = null, includeOptions = false) {
    if (!lastRecurringPayment && !this.lastPayment) {
      return false;
    }
    const lastRecurring = lastRecurringPayment || this.lastPayment[Contract$1.RECURRING];
    return this.subscription.isPaymentDate(lastRecurring, this.lastPayment[Contract$1.ONECLICK], includeOptions, this.subscriptionDate);
  }
}
var FrameType = /*#__PURE__*/function (FrameType) {
  FrameType["uplink"] = "uplink";
  FrameType["downlink"] = "downlink";
  return FrameType;
}(FrameType || {});
var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["JoinRequest"] = "JoinRequest";
  MessageType["JoinAccept"] = "JoinAccept";
  MessageType["UnconfirmedDataUp"] = "UnconfirmedDataUp";
  MessageType["UnconfirmedDataDown"] = "UnconfirmedDataDown";
  MessageType["ConfirmedDataUp"] = "ConfirmedDataUp";
  MessageType["ConfirmedDataDown"] = "ConfirmedDataDown";
  MessageType["RejoinRequest"] = "RejoinRequest";
  return MessageType;
}(MessageType || {});
class ModuleFrame {
  constructor(object) {
    var _a;
    this.moduleID = object.moduleID;
    this.deviceType = object.deviceType;
    this.type = (_a = object.type) !== null && _a !== void 0 ? _a : FrameType.uplink;
    this.frameCounter = object.frameCounter;
    this.messageType = object.messageType;
    this.spreadingFactor = object.spreadingFactor;
    this.timestamp = object.timestamp;
    this.frame = object.frame;
    this.receivedBy = object.receivedBy;
  }
}
function isGPSPosition(position) {
  return true;
}
var Store;
(function (Store) {
  class ActivityReport {
    constructor(object) {
      this.userID = object.userID;
      this.timeMs = object.timeMs;
      this.interval = object.interval;
      this.activityValue = object.activityValue;
    }
  }
  Store.ActivityReport = ActivityReport;
  class Position {
    constructor(object) {
      /** @deprecated use name */
      this.lastName = '';
      this.userID = object.userID;
      this.timeMs = object.timeMs;
      this.accuracy = object.accuracy;
      this.GPScoordinates = object.GPScoordinates;
      this.pixelsCoordinates = object.pixelsCoordinates;
      this.planIDs = object.planIDs;
      this.name = object.name || `${object.firstName} ${object.lastName}`;
      this.firstName = this.name;
      this.displayName = object.displayName;
      this.source = object.source;
    }
  }
  Store.Position = Position;
  class MessageUser {
    constructor(object) {
      /** @deprecated use name */
      this.lastName = '';
      this.userID = object.userID;
      this.timeMs = object.timeMs;
      this.name = object.name || `${object.firstName} ${object.lastName}`;
      this.firstName = this.name;
      this.message = object.message;
      this.userSent = object.userSent;
    }
  }
  Store.MessageUser = MessageUser;
  class Alert {
    constructor(object) {
      this.userID = object.userID;
      this.timeMs = object.timeMs;
      this.alertID = object.alertID;
      this.startTimeMs = object.startTimeMs;
      this.displayName = object.displayName;
      this.alertType = object.alertType;
      this.status = object.status;
      this.handleInfo = object.handleInfo;
      this.acquitInfo = object.acquitInfo;
      this.moduleID = object.moduleID;
    }
  }
  Store.Alert = Alert;
  class AlertDetails {
    constructor(object) {
      this.userID = object.userID;
      this.timeMs = object.timeMs;
      this.alertID = object.alertID;
      this.qualification = object.qualification;
      this.comment = object.comment;
    }
  }
  Store.AlertDetails = AlertDetails;
  class Temperature {
    constructor(object) {
      this.userID = object.userID;
      this.timeMs = object.timeMs;
      this.moduleID = object.moduleID;
      this.value = object.value;
    }
  }
  Store.Temperature = Temperature;
  class DoorState {
    constructor(object) {
      this.userID = object.userID;
      this.timeMs = object.timeMs;
      this.moduleID = object.moduleID;
      this.value = object.value;
    }
  }
  Store.DoorState = DoorState;
})(Store || (Store = {}));
class SigfoxCredential {
  constructor(params) {
    this.isUsed = params.isUsed;
    this.isReusable = params.isReusable;
    this.PAC = params.PAC;
    this.secretKey = params.secretKey;
    this.sigfoxID = params.sigfoxID;
  }
}
class ItemConfig {
  constructor(object) {
    this.reference = object === null || object === void 0 ? void 0 : object.reference;
    this.title = object === null || object === void 0 ? void 0 : object.title;
    this.size = object === null || object === void 0 ? void 0 : object.size;
    this.moduleID = object === null || object === void 0 ? void 0 : object.moduleID;
    this.alreadyOwn = (object === null || object === void 0 ? void 0 : object.alreadyOwn) || false;
  }
}
;
class StockItem {
  constructor(object) {
    var _a, _b;
    this.reference = object.reference;
    this.stock = object.stock;
    this.minimalStockExpected = object.minimalStockExpected;
    this.fr = object.fr;
    this.en = object.en;
    this.dialogOption = object.dialogOption;
    this.businessVisibility = (_a = object.businessVisibility) !== null && _a !== void 0 ? _a : [];
    this.starProduct = object.starProduct;
    this.stockStatus = object.stockStatus;
    this.associatedDevices = (_b = object.associatedDevices) !== null && _b !== void 0 ? _b : [];
    this.productLink = object.productLink;
    this.costPrice = object.costPrice;
    this.imageName = object.imageName;
    this.imageUrl = object.imageUrl;
  }
}
class StockTransfer {
  constructor(object) {
    this.id = object.id;
    this.type = object.type;
    this.recipientName = object.recipientName;
    this.country = object.country;
    this.zip = object.zip;
    this.city = object.city;
    this.street = object.street;
    this.creationDate = object.creationDate;
    this.deliveryDate = object.deliveryDate;
    this.comments = object.comments;
    this.groupID = object.groupID;
    this.category = object.category;
    this.draft = object.draft;
    this.items = object.items;
    this.recipe = object.recipe;
  }
}
class StockRecipe {
  constructor(object) {
    this.id = object.id;
    this.name = object.name;
    this.components = object.components;
    this.finalItemReference = object.finalItemReference;
    this.timeMs = object.timeMs;
    this.comments = object.comments;
  }
}
class GeneralModule {
  constructor(object) {
    this.moduleID = object.moduleID;
    this.deviceType = object.deviceType;
    this.userID = object.userID;
    this.groupID = object.groupID;
    this.groupAssociationDate = object.groupAssociationDate;
    this.productionDeliveryDate = object.productionDeliveryDate;
    this.moduleOwner = object.moduleOwner;
    this.moduleStatus = object.moduleStatus;
    this.name = object.name;
    this.inactive = object.inactive;
    this.comment = object.comment;
    this.rfidID = object.rfidID;
  }
}
class GeneralCaw extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.CAW;
    this.hardButton = object.hardButton;
    this.hardwareVersion = object.hardwareVersion;
    this.softwareVersion = object.softwareVersion;
    this.moduleCondition = object.moduleCondition;
    this.noFallDetection = object.noFallDetection;
    this.noVibration = object.noVibration;
    this.sigfoxID = object.sigfoxID;
    this.loraDevEUI = object.loraDevEUI;
    this.awsIotDeviceID = object.awsIotDeviceID;
  }
}
class GeneralBsSigfox extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.BSSigfox;
    this.simCard = object.simCard;
  }
}
class GeneralCau extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.CAU;
    this.loraDevEUI = object.loraDevEUI;
    this.awsIotDeviceID = object.awsIotDeviceID;
  }
}
class GeneralI870sf extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.I870SF;
    this.sigfoxID = object.sigfoxID;
  }
}
class GeneralI870lr extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.I870LR;
    this.loraDevEUI = object.loraDevEUI;
    this.awsIotDeviceID = object.awsIotDeviceID;
  }
}
class GeneralCab extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.CAB;
    this.sigfoxID = object.sigfoxID;
    this.hardwareVersion = object.hardwareVersion;
    this.softwareVersion = object.softwareVersion;
  }
}
class GeneralSp4Mag extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.SP4MAG;
    this.sigfoxID = object.sigfoxID;
    this.softwareVersion = object.softwareVersion;
  }
}
class GeneralSp4But extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.SP4BUT;
    this.sigfoxID = object.sigfoxID;
    this.softwareVersion = object.softwareVersion;
  }
}
class GeneralGh5200 extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.GH5200;
    this.imei = object.imei;
    this.simCard = object.simCard;
    this.phoneNumber = object.phoneNumber;
  }
}
class GeneralEv07b extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.EV07B;
    this.imei = object.imei;
    this.simCard = object.simCard;
    this.phoneNumber = object.phoneNumber;
  }
}
class GeneralTmt250 extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.TMT250;
    this.imei = object.imei;
    this.simCard = object.simCard;
    this.phoneNumber = object.phoneNumber;
  }
}
class GeneralNetworkDevice extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.NETWORKDEVICE;
    this.reference = object.reference;
    this.macAddress = object.macAddress;
    this.imei = object.imei;
    this.simCard = object.simCard;
  }
}
class GeneralSmartphone extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.SMARTPHONE;
    this.reference = object.reference;
    this.imei = object.imei;
    this.simCard = object.simCard;
    this.phoneNumber = object.phoneNumber;
    this.knox = object.knox;
  }
}
class GeneralTagID extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.TAGID;
  }
}
class GeneralLuna4G extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.LUNA4G;
    this.simCard = object.simCard;
    this.phoneNumber = object.phoneNumber;
    this.attentiveID = object.attentiveID;
    this.vid = object.vid;
  }
}
class GeneralArf8170Bca extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.ARF8170BCA;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
    this.switchTypeNO = object.switchTypeNO;
  }
}
class GeneralArf8171Ba extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.ARF8171BA;
    this.sigfoxID = object.sigfoxID;
    this.switchTypeNO = object.switchTypeNO;
  }
}
class GeneralBsLora extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.BSLora;
    this.simCard = object.simCard;
    this.loraDevEUI = object.loraDevEUI;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.reference = object.reference;
  }
}
class GeneralCal extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = object.deviceType;
    ;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
    this.hardwareVersion = object.hardwareVersion;
    this.softwareVersion = object.softwareVersion;
    this.configurationCustom = object.configurationCustom;
  }
}
class GeneralCalAU extends GeneralCal {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.CALAU;
  }
}
class GeneralCalDC extends GeneralCal {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.CALDC;
  }
}
class GeneralCalP extends GeneralCal {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.CALP;
  }
}
class GeneralCalT extends GeneralCal {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.CALT;
  }
}
class GeneralCalWB extends GeneralCal {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.CALWB;
  }
}
class GeneralCalBC extends GeneralCal {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.CALBC;
  }
}
;
class GeneralVh2Bbus01 extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.VH2BBUS01;
    this.macAddress = object.macAddress;
  }
}
class GeneralCalDS extends GeneralCal {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.CALDS;
  }
}
class GeneralCalSB extends GeneralCal {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.CALSB;
  }
}
class GeneralLds02DS extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.LDS02DS;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
  }
}
class GeneralLds02SB extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.LDS02SB;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
  }
}
class GeneralLA66USB extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.LA66USB;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
  }
}
class GeneralZEPRLR extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.ZEPRLR;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
  }
}
class GeneralZEECDMINOLR extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.ZEECDMINOLR;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
    this.unitOfMeasure = object.unitOfMeasure;
    this.waterTemperature = object.waterTemperature;
  }
}
class GeneralLHT65NLR extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.LHT65NLR;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
    this.onExternalProbe = object.onExternalProbe;
  }
}
class GeneralX870LS extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.X870LS;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
  }
}
class GeneralX865LS extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.X865LS;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
  }
}
class GeneralX860LS extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.X860LS;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
  }
}
class GeneralX855LS extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.X855LS;
    this.awsIotDeviceID = object.awsIotDeviceID;
    this.loraDevEUI = object.loraDevEUI;
  }
}
class GeneralWSM02 extends GeneralModule {
  constructor(object) {
    super(object);
    this.deviceType = DeviceType.WSM02;
    this.withingsDeviceID = object.withingsDeviceID;
    this.macAddress = object.macAddress;
  }
}
class ModuleSetting {
  constructor(object) {
    this.moduleID = object.moduleID;
    this.name = object.name;
    this.value = object.value;
    this.updatedToModule = object.updatedToModule;
    this.comment = object.comment;
  }
}
class ModuleState {
  constructor(object) {
    this.moduleID = object.moduleID;
    this.stateType = object.stateType;
    this.value = object.value;
    this.lastUpdate = object.lastUpdate;
    this.comment = object.comment;
  }
}
class ModuleStateBatteryLevel extends ModuleState {
  constructor(object) {
    super(object);
    this.stateType = STATETYPE.BATTERY_LEVEL;
  }
}
class ModuleStatePosition extends ModuleState {
  constructor(object) {
    super(object);
    this.stateType = STATETYPE.POSITION_STATE;
  }
}
class ModuleStateConnectivity extends ModuleState {
  constructor(object) {
    super(object);
    this.stateType = STATETYPE.CONNECTIVITY;
    this.value = object.value;
  }
}
class ModuleStateWorn extends ModuleState {
  constructor(object) {
    super(object);
    this.stateType = STATETYPE.WORN_STATE;
  }
}
class ModuleStateDC extends ModuleState {
  constructor(object) {
    super(object);
    this.stateType = STATETYPE.DC_STATE;
    this.counter = object.counter;
  }
}
class ModuleStateInDefault extends ModuleState {
  constructor(object) {
    super(object);
    this.stateType = STATETYPE.IN_DEFAULT;
    this.hasEmbedErrorLog = object.hasEmbedErrorLog;
    this.featureStateMap = object.featureStateMap;
    this.noSignalMaxDuration = object.noSignalMaxDuration;
  }
}
class ModuleStateDoor extends ModuleState {
  constructor(object) {
    super(object);
    this.stateType = STATETYPE.DOOR_STATE;
  }
}
class ModuleStateLastValue extends ModuleState {
  constructor(object) {
    super(object);
    this.stateType = STATETYPE.LAST_VALUE;
  }
}
var IVRExpressionParser;
(function (IVRExpressionParser) {
  IVRExpressionParser.SPLIT_CHAR = '-';
  IVRExpressionParser.USER_EXT_CHAR = 'H';
  IVRExpressionParser.EXPRESSION_REGEX = /^\[[0-9#*]+\]$/gm;
  function expressionIsValid(expression) {
    return parseExpression(expression).length === expression.split(IVRExpressionParser.SPLIT_CHAR).length;
  }
  IVRExpressionParser.expressionIsValid = expressionIsValid;
  function parseExpression(actionExpression, ivrExtension = IVRExpressionParser.USER_EXT_CHAR) {
    return actionExpression.split(IVRExpressionParser.SPLIT_CHAR).reduce((actions, rawAction) => {
      if (rawAction.match(IVRExpressionParser.EXPRESSION_REGEX)) {
        actions.push({
          verb: TwilioVoiceVerb.play,
          param: {
            digits: rawAction.slice(1, rawAction.length - 1)
          }
        });
      } else if (rawAction === IVRExpressionParser.USER_EXT_CHAR) {
        actions.push({
          verb: TwilioVoiceVerb.play,
          param: {
            digits: ivrExtension
          }
        });
      } else if (Number.isInteger(+rawAction) && +rawAction > 0) {
        actions.push({
          verb: TwilioVoiceVerb.pause,
          param: {
            length: +rawAction
          }
        });
      }
      return actions;
    }, []);
  }
  IVRExpressionParser.parseExpression = parseExpression;
})(IVRExpressionParser || (IVRExpressionParser = {}));
class SupportTicket {
  constructor(object) {
    var _a;
    this.id = object.id;
    this.moduleID = object.moduleID;
    this.hubspotTicketID = object.hubspotTicketID;
    this.invoiceID = object.invoiceID;
    this.referenceStock = object.referenceStock;
    this.history = ((_a = object.history) === null || _a === void 0 ? void 0 : _a.sort(this.sortHistory)) || [{
      step: SupportTicketStep.OPENED
    }];
    this.moduleReceptionDate = object.moduleReceptionDate;
    this.deviceType = object.deviceType;
    this.groupID = object.groupID;
    this.gpsNeeded = object.gpsNeeded;
    this.groupAddress = object.groupAddress;
    this.moduleSoftwareVersion = object.moduleSoftwareVersion;
    this.moduleHardwareVersion = object.moduleHardwareVersion;
    this.moduleProductionDeliveryDate = object.moduleProductionDeliveryDate;
    this.urgent = object.urgent;
    this.userID = object.userID;
    this.files = object.files;
    this.shippingNumber = object.shippingNumber;
    this.batchReturn = object.batchReturn;
    this.deliveryID = object.deliveryID;
  }
  get currentStep() {
    return this.history[this.history.length - 1].step;
  }
  get displayableHistory() {
    // doesn't include the current step in the history if not closed (front purpose)
    return this.isClosed() ? this.history : this.history.slice(0, -1);
  }
  isClosed() {
    return this.currentStep === SupportTicketStep.CLOSED;
  }
  /**
   * Store the history data in the current step, if nextStep is submited then update the currentStep
   */
  processStep(historyLineData, nextStep) {
    if (this.isClosed()) {
      throw 'ticket is closed';
    } else {
      this.history[this.history.length - 1] = historyLineData;
      if (nextStep) {
        this.history.push({
          step: nextStep
        });
      }
    }
  }
  /**
   * Sort history by timeMs and place the current step (without timeMs) on the end of the list
   */
  sortHistory(historyA, historyB) {
    if (!historyA.timeMs) {
      return 1;
    }
    if (!historyB.timeMs) {
      return -1;
    }
    return historyA.timeMs - historyB.timeMs;
  }
}
var KnowledgeBaseItemType = /*#__PURE__*/function (KnowledgeBaseItemType) {
  KnowledgeBaseItemType[KnowledgeBaseItemType["category"] = 0] = "category";
  KnowledgeBaseItemType[KnowledgeBaseItemType["article"] = 1] = "article";
  KnowledgeBaseItemType[KnowledgeBaseItemType["cacheVersion"] = 2] = "cacheVersion";
  return KnowledgeBaseItemType;
}(KnowledgeBaseItemType || {});
class CacheVersion {
  constructor(cacheVersion) {
    this.id = cacheVersion.id;
    this.version = cacheVersion.version;
  }
}
class Category {
  constructor(category) {
    var _a;
    this.id = category.id;
    this.urn = category.urn;
    this.parentID = category.parentID;
    this.name = category.name;
    this.icon = category.icon;
    this.children = (_a = category.children) !== null && _a !== void 0 ? _a : [];
  }
  isArticle() {
    return isArticle(this);
  }
  isCategory() {
    return isCategory(this);
  }
}
class Article {
  constructor(article) {
    var _a;
    this.id = article.id;
    this.urn = article.urn;
    this.parentID = article.parentID;
    this.title = article.title;
    this.content = article.content;
    this.visibleBy = article.visibleBy;
    this.status = article.status;
    this.author = article.author;
    this.lastUpdate = article.lastUpdate;
    this.tags = (_a = article.tags) !== null && _a !== void 0 ? _a : [];
  }
  static getAvailablesDegrees(degree) {
    switch (degree) {
      case VisibilityDegree.atLeastVisitor:
        return [VisibilityDegree.atLeastVisitor];
      case VisibilityDegree.atLeastConnectedUser:
        return [VisibilityDegree.atLeastVisitor, VisibilityDegree.atLeastConnectedUser];
      case VisibilityDegree.atLeastConnectedCoAssistAdmin:
        return [VisibilityDegree.atLeastVisitor, VisibilityDegree.atLeastConnectedUser, VisibilityDegree.atLeastConnectedCoAssistAdmin];
      default:
        return [];
    }
  }
  static getPublicationStatuses(degree) {
    switch (degree) {
      case VisibilityDegree.atLeastVisitor:
      case VisibilityDegree.atLeastConnectedUser:
        return [PublicationStatus.published];
      case VisibilityDegree.atLeastConnectedCoAssistAdmin:
        return [PublicationStatus.published, PublicationStatus.draft, PublicationStatus.archived];
      default:
        return [];
    }
  }
  isArticle() {
    return isArticle(this);
  }
  isCategory() {
    return isCategory(this);
  }
}
function isCategory(item) {
  return 'name' in item;
}
function isArticle(item) {
  return 'title' in item;
}
var PublicationStatus = /*#__PURE__*/function (PublicationStatus) {
  PublicationStatus["draft"] = "draft";
  PublicationStatus["published"] = "published";
  PublicationStatus["archived"] = "archived";
  return PublicationStatus;
}(PublicationStatus || {});
/**
 * atLeastVisitor: no data means means public content only
 * atLeastConnectedUser: means public content, connected user restricted content only
 * atLeastConnectedCoAssistAdmin: means public content, connected user restricted content an co_assist_admin restricted content only
 */
var VisibilityDegree = /*#__PURE__*/function (VisibilityDegree) {
  VisibilityDegree["atLeastVisitor"] = "visitor";
  VisibilityDegree["atLeastConnectedUser"] = "connectedUser";
  VisibilityDegree["atLeastConnectedCoAssistAdmin"] = "connectedCoAssistAdmin";
  return VisibilityDegree;
}(VisibilityDegree || {});
/**
 * Generated bundle index. Do not edit.
 */

export { actionSet_const as ACTIONSET, admin_const as ADMIN, alert_const as ALERT, acknowledgment as Acknowledgment, ActionSet, AddressZone, administration as Administration, Aggregate, Alert, AlertProcess, AlertSetting, Article, baseConverter as BaseConverter, Billing, bluelinea_const as Bluelinea, contract_const as CONTRACT, CacheVersion, Category, Civility, index$2 as Constants, Contract, Counter, CustomerAddress, db_const as DB, DEFAULT_NUMBER_OF_CYCLES, discount_const as DISCOUNT, DataModel, data_utils as DataUtils, index as Decoder, DeviceUseRate, Discount, error_const as ERROR, entity_const as Entity, index$1 as Event, FrameType, GPS, GeneralArf8170Bca, GeneralArf8171Ba, GeneralBsLora, GeneralBsSigfox, GeneralCab, GeneralCal, GeneralCalAU, GeneralCalBC, GeneralCalDC, GeneralCalDS, GeneralCalP, GeneralCalSB, GeneralCalT, GeneralCalWB, GeneralCau, GeneralCaw, GeneralEv07b, GeneralGh5200, GeneralGroup, GeneralI870lr, GeneralI870sf, GeneralLA66USB, GeneralLHT65NLR, GeneralLds02DS, GeneralLds02SB, GeneralLuna4G, GeneralModule, GeneralNetworkDevice, GeneralSmartphone, GeneralSp4But, GeneralSp4Mag, GeneralTagID, GeneralTmt250, GeneralUser, GeneralVh2Bbus01, GeneralWSM02, GeneralX855LS, GeneralX860LS, GeneralX865LS, GeneralX870LS, GeneralZEECDMINOLR, GeneralZEPRLR, geolocation_const as Geolocation, gpsPosition as GpsPosition, Group, invoice_const as INVOICE, IVRExpressionParser, Invoice, InvoiceLine, ItemConfig, KnowledgeBaseItemType, Language, MINIMAL_SCORE_ACCEPTABLE, features_const as MODULE_FEATURES, Measurement, MessageType, mainModel as Model, index$3 as Module, ModuleFrame, ModuleSetting, ModuleState, ModuleStateBatteryLevel, ModuleStateConnectivity, ModuleStateDC, ModuleStateDoor, ModuleStateInDefault, ModuleStateLastValue, ModuleStatePosition, ModuleStateWorn, Notification, option_const as OPTION, Option, parser as Parser, PaymentInformations, Person, PositionSource, ProximityConfidenceLevel, PublicationStatus, RSSIRange, report as Report, RssiIndicator, Rules, SNRRange, subscription_const as SUBSCRIPTION, SigfoxCredential, SnrIndicator, SpreadingFactor, StockItem, StockRecipe, StockTransfer, Store, Subscription, SupportTicket, time_const as TIME, Tag, Threshold, TimeRange, VisibilityDegree, ZoneExitType, getIndicatorByRSSI, getIndicatorBySNR, isArticle, isAvailableFeature, isCategory, isGPSPosition, isVersionFeature, pickBestGateways, sortAndNotateProximityConfidence, AdminItem as ɵa, DeviceOS as ɵb, VERSION_FEATURE as ɵc, index$2 as ɵd, OptionType as ɵe, isValidShortCalendarDateFormat as ɵf, isValidFullCalendarDateFormat as ɵg };
